/* Production handoff: original photo files plus a versioned placement manifest. */
window.GamedayProPackage={
 async attach(form,recipe){
  if(!recipe?.proPhotos)return;
  const copy=structuredClone(recipe),photos=copy.proPhotos;
  const files=[];
  for(const side of ['front','back']){
   const source=photos.linked&&side==='back'?recipe.proPhotos.front:recipe.proPhotos[side];
   if(!source){photos[side]=null;continue;}
   const mime=source.dataUrl.slice(5,source.dataUrl.indexOf(';'));
   const bytes=Uint8Array.from(atob(source.dataUrl.split(',')[1]),c=>c.charCodeAt(0));
   const sha=[...new Uint8Array(await crypto.subtle.digest('SHA-256',bytes))].map(n=>n.toString(16).padStart(2,'0')).join('');
   if(sha!==source.sha256)throw Error('Original photo integrity check failed. Please upload it again.');
   const filename='pro-'+side+'-'+sha.slice(0,12)+'.'+({ 'image/png':'png','image/jpeg':'jpg','image/webp':'webp'}[mime]);
   files.push({key:'PRO '+side+' original',file:new File([bytes],filename,{type:mime})});
   photos[side]={name:source.name,filename,sha256:sha,width:source.width,height:source.height,fullFlag:source.fullFlag===true};
   if(source.sourceOriginal){const original=source.sourceOriginal,omime=original.dataUrl.slice(5,original.dataUrl.indexOf(';')),obytes=Uint8Array.from(atob(original.dataUrl.split(',')[1]),c=>c.charCodeAt(0)),osha=[...new Uint8Array(await crypto.subtle.digest('SHA-256',obytes))].map(n=>n.toString(16).padStart(2,'0')).join('');if(osha!==original.sha256)throw Error('Studio original integrity check failed');const oname='studio-'+side+'-original-'+osha.slice(0,12)+'.'+({'image/png':'png','image/jpeg':'jpg','image/webp':'webp'}[omime]);files.push({key:'Studio '+side+' original',file:new File([obytes],oname,{type:omime})});photos[side].sourceOriginal={name:original.name,filename:oname,sha256:osha,width:original.width,height:original.height};} 
  }
  files.push({key:'PRO production recipe',file:new File([JSON.stringify({schema:'gameday-pro-production-v1',recipe:copy},null,2)],'pro-production-recipe.json',{type:'application/json'})});
  form.querySelectorAll('[data-pro-production-file]').forEach(e=>e.remove());
  for(const row of files){const input=document.createElement('input');input.type='file';input.hidden=true;input.dataset.proProductionFile='';input.name='properties['+row.key+']';const dt=new DataTransfer();dt.items.add(row.file);input.files=dt.files;form.append(input);}
 },
 assertSaveSize(recipe){if(new Blob([JSON.stringify(recipe)]).size>22*1024*1024)throw Error('This design exceeds the 22 MB account-save limit. Reduce photo or logo file sizes before saving.');}
};

/* Compact Pro photo controls. Presentation only; existing placement and originals remain authoritative. */
window.GamedayProPhotoUI=function(panel,api){
 const style=document.createElement('style');style.textContent=`
 .custom-pro-photos{background:linear-gradient(145deg,#252b25,#151915);padding:22px!important;border-color:#434d40!important}
 .custom-pro-photos summary{font-size:18px!important;letter-spacing:-.02em}.custom-pro-photos p{line-height:1.5}
 .custom-pro-photos fieldset{border:0;padding:0!important;margin:14px 0!important}.custom-pro-photos legend{font-size:11px;letter-spacing:.12em;color:#a6d90d;padding:8px 0}
 .custom-pro-photos [data-pro-tab]{background:#30372e;color:#ddd;border-radius:6px;padding:11px 16px;margin:10px 6px 0 0}
 .custom-pro-photos [data-pro-tab][aria-pressed=true]{background:#a6d90d;color:#111}
 .pro-photo-drop{display:flex!important;position:relative;align-items:center;justify-content:center;min-height:92px;border:1px dashed #8ba653;border-radius:8px;background:#1c2318;cursor:pointer;text-align:center;padding:16px;margin:0!important;font-weight:750}
 .pro-photo-drop input{position:absolute;inset:0;opacity:0;cursor:pointer;width:100%;height:100%}.pro-photo-drop:focus-within,.pro-photo-drop[data-drag=true]{outline:2px solid #a6d90d;background:#354522}
 .custom-pro-photos [data-pro-status]{overflow-wrap:anywhere;color:#bcc8b5;font-size:12px;margin:8px 0}
 .custom-pro-photos select{padding:10px;border:1px solid #65725b;border-radius:5px;background:#151a13;color:white}
 .custom-pro-photos label:has(input[type=range]){font-size:12px;font-weight:700;margin:14px 0}.custom-pro-photos output{float:right;font-variant-numeric:tabular-nums;color:#c1ef44}.custom-pro-photos input[type=range]{height:22px;cursor:ew-resize}
 .custom-pro-photos [data-pro-rotate],.custom-pro-photos [data-pro-reset],.custom-pro-photos [data-pro-remove]{border:1px solid #56624c;background:#2b3326;color:white;border-radius:5px;padding:10px;margin:4px 6px 4px 0}
 .pro-palette-link{display:flex;gap:10px;align-items:center;border-top:1px solid #46513d;padding-top:16px;margin-top:12px;font-size:12px}.pro-palette-link i{width:28px;height:28px;border:1px solid #aaa;border-radius:50%;flex-shrink:0}.pro-palette-link strong,.pro-palette-link small{display:block}.pro-palette-link small{font-size:11px;color:#b9c2b3;margin-top:4px}.pro-palette-link output{font-size:11px;margin-left:auto}
 `;panel.append(style);
 for(const tab of panel.querySelectorAll('[data-pro-tab]')){tab.setAttribute('aria-pressed',String(tab.dataset.proTab==='front'));tab.addEventListener('click',()=>{for(const t of panel.querySelectorAll('[data-pro-tab]'))t.setAttribute('aria-pressed',String(t===tab));});}
 for(const row of panel.querySelectorAll('[data-pro-side]')){
  const side=row.dataset.proSide,input=row.querySelector('input[type=file]'),drop=document.createElement('label');drop.className='pro-photo-drop';drop.textContent='＋ Drop your photo here or browse';input.before(drop);drop.append(input);input.setAttribute('aria-label',side+' photo upload');
  drop.addEventListener('dragover',e=>{e.preventDefault();drop.dataset.drag='true';});drop.addEventListener('dragleave',()=>delete drop.dataset.drag);drop.addEventListener('drop',e=>{e.preventDefault();delete drop.dataset.drag;if(!input.disabled)api.upload(side,e.dataTransfer.files[0]);});
  for(const range of row.querySelectorAll('input[type=range]')){const output=document.createElement('output');output.dataset.proReadout=range.dataset.proKey;range.before(output);range.setAttribute('aria-label',side+' '+range.dataset.proKey);}
  const reset=document.createElement('button');reset.type='button';reset.dataset.proReset='';reset.textContent='Reset position';reset.onclick=()=>{api.reset(side);window.GamedayProPhotoUI.refresh(panel);};row.querySelector('[data-pro-remove]').before(reset);const remove=row.querySelector('[data-pro-remove]');remove.textContent='Remove '+side+' photo';remove.setAttribute('aria-label','Remove '+side+' photo without resetting the design');drop.after(remove);remove.style.cssText='display:block;width:100%;border:1px solid #a6d90d;color:#fff;padding:12px;margin:10px 0';
 }
 window.GamedayProPhotoUI.refresh(panel);
};
window.GamedayProPhotoUI.refresh=panel=>{for(const row of panel.querySelectorAll('[data-pro-side]'))for(const range of row.querySelectorAll('input[type=range]')){const v=Number(range.value);row.querySelector('[data-pro-readout='+range.dataset.proKey+']').textContent=range.dataset.proKey==='zoom'?Math.round(v*100)+'%':v===0?'Centered':(v>0?'+':'')+v+'%';}};

/* Scoped to the opt-in Pro test. Live detail preview and visible header lettering. */
window.GamedayProRedlines=(()=>{
 const escape=v=>String(v).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&apos;'}[c]));
 function headerMarkup({text,x,y,width,height,headerWidth,inches=12,font='Arial',weight=700,color='#171C17'}){text=Array.from(String(text||'').trim().toUpperCase()).slice(0,16).join('');if(!text)return '';const rgb=(/^#[0-9a-f]{6}$/i.test(color)?color:'#171C17').slice(1).match(/../g).map(c=>parseInt(c,16)),ink=rgb[0]*.299+rgb[1]*.587+rgb[2]*.114>150?'#171817':'#FFFFFF';const px=headerWidth*.56,baseY=y+height*(1-1/inches),cx=x+headerWidth/2,available=height*Math.min(8,inches-2)/inches;const cv=document.createElement('canvas'),ctx=cv.getContext('2d');ctx.font=weight+' '+px+'px '+font;const len=Math.min(available,ctx.measureText(text).width);return '<text x="0" y="0" transform="translate('+cx+' '+baseY+') rotate(-90)" fill="'+ink+'" font-family="'+escape(font)+'" font-weight="'+escape(weight)+'" font-size="'+px+'" dominant-baseline="central" text-anchor="start" textLength="'+len+'" lengthAdjust="spacingAndGlyphs">'+escape(text)+'</text>';}
 function mount(section,api){
  const panel=api.photos.panel,preview=document.createElement('section');preview.className='pro-photo-detail-preview';preview.setAttribute('aria-label','Live photo placement preview');preview.innerHTML='<header><strong>PHOTO PLACEMENT PREVIEW</strong><span data-pro-preview-side>FRONT</span></header><div class="pro-photo-detail-preview__stage"></div><p>Live final design: photo, logo, lettering and solid header. Switch FRONT PHOTO / BACK PHOTO to inspect each side.</p>';panel.after(preview);
  const example=document.createElement('figure');example.className='pro-photo-example';example.innerHTML='<img alt="Example only: United States flag and fireworks" loading="lazy"><figcaption><strong>EXAMPLE ONLY — NOT FOR PRODUCTION</strong><span>Upload your own photo to replace this placeholder. This image is not added to your flag, saved design, proofs, or 3D model.</span></figcaption>';
  const themeScript=[...document.scripts].find(s=>s.src.includes('/assets/exo-theme.js'));
  example.querySelector('img').src=new URL('gameday-america-250-87.webp',themeScript.src).href;
  preview.querySelector('.pro-photo-detail-preview__stage').after(example);example.querySelector('img').hidden=true;
  const exampleStyle=document.createElement('style');exampleStyle.textContent='.pro-photo-example{margin:0;position:relative;background:#101510;border:1px solid #65715c;overflow:hidden}.pro-photo-example img{display:none;width:100%;max-height:470px;object-fit:contain;filter:saturate(.55) brightness(.65)}.pro-photo-example figcaption{padding:18px;background:#111811;color:white;font-size:13px;line-height:1.5}.pro-photo-example strong,.pro-photo-example span{display:block}.pro-photo-example strong{color:#a6d90d;letter-spacing:.08em;margin-bottom:7px}.pro-photo-example[hidden],.pro-photo-detail-preview__stage[hidden]{display:none!important}';preview.append(exampleStyle);

  const style=document.createElement('style');style.textContent='.custom-pro-photos{grid-column:1}.pro-photo-detail-preview{grid-column:2 / -1;min-width:0;padding:clamp(18px,2vw,32px);background:#202420;color:white;display:flex;flex-direction:column;justify-content:center;border:1px solid #666}.pro-photo-detail-preview header{display:flex;justify-content:space-between;gap:12px;color:#a6d90d;margin-bottom:20px;font-size:13px}.pro-photo-detail-preview__stage{width:100%;min-width:0}.pro-photo-detail-preview__stage>.custom-flag-stage{width:100%!important;max-width:none!important;margin:0!important}.pro-photo-detail-preview p{font-size:13px;line-height:1.5;margin-top:16px;color:#ccd1ce}@media(max-width:800px){.custom-pro-photos,.pro-photo-detail-preview{grid-column:1 / -1}.pro-photo-detail-preview{padding:16px}}';section.append(style);
  let scheduled=false,last='',seq=0;const source=side=>section.querySelector('[data-custom-stage="live-'+side+'"]');
  function update(){scheduled=false;const side=panel.querySelector('[data-pro-side="back"]').hidden?'front':'back';
   const value=section.querySelector('[data-custom-header-text]')?.value||'',fontEl=section.querySelector('[data-custom-text="front"]'),fontStyle=fontEl?getComputedStyle(fontEl):null,sizeButton=section.querySelector('[data-custom-size].is-active')||section.querySelector('[data-custom-size][aria-pressed="true"]'),size=sizeButton?.dataset.customSize||api.recipe().variant.size,inches={'12x17':12,'3x5':36,'4x6':48,'5x8':60}[size]||12;
   for(const svg of section.querySelectorAll('svg.gameday-approved-proof__svg')){const header=svg.querySelector('[data-custom-geometry-header][data-approved-proof-side="front"]');if(!header)continue;let group=svg.querySelector('[data-pro-header-lettering]');if(!group){group=document.createElementNS('http://www.w3.org/2000/svg','g');group.setAttribute('data-pro-header-lettering','');header.after(group);}const frontPhoto=Boolean(api.photos.surface('front')),stop=svg.querySelector('linearGradient[id^="GamedayTemplateHeader-"] stop:last-child'),fill=getComputedStyle(stop||header)[stop?'stopColor':'fill'];let color=frontPhoto?api.photos.headerColor():'#171C17';const match=fill.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/);if(!frontPhoto&&match)color='#'+match.slice(1,4).map(x=>Number(x).toString(16).padStart(2,'0')).join('');const markup=headerMarkup({text:value,x:Number(header.getAttribute('x')),y:Number(header.getAttribute('y')),width:954,height:Number(header.getAttribute('height')),headerWidth:Number(header.getAttribute('width')),inches,font:fontStyle?.fontFamily||'Arial',weight:fontStyle?.fontWeight||700,color});if(group.dataset.markup!==markup){group.innerHTML=markup;group.dataset.markup=markup;}}
   const hasPhoto=Boolean(api.photos.surface(side));example.hidden=hasPhoto||side==='back';preview.querySelector('.pro-photo-detail-preview__stage').hidden=false;preview.querySelector('[data-pro-preview-side]').textContent=side.toUpperCase();preview.querySelector('p').textContent=hasPhoto?'Live final design: photo, logo, lettering and solid header. Switch FRONT PHOTO / BACK PHOTO to inspect each side.':side==='back'?'No back photo selected — showing your current back proof above.':'Preview inspiration only. No photo is selected for this side.';
   const original=source(side);if(!original)return;const content=side+hasPhoto+original.outerHTML;if(content===last)return;last=content;const clone=original.cloneNode(true),prefix='pro-detail-'+(++seq)+'-',ids=new Map();if(!hasPhoto&&side==='front'){
    const svg=clone.querySelector('svg.gameday-approved-proof__svg'),group=svg?.querySelector('g[clip-path]');
    if(group){const frame=window.EXOGamedayFlagProofPresentation.frame,geometry=window.EXOGamedayFlagProofPresentation.sizes[size],x=side==='back'?1000-frame.x-frame.width:frame.x,w=geometry.headerWidth*frame.width;
     const image=document.createElementNS('http://www.w3.org/2000/svg','image');image.setAttribute('href',example.querySelector('img').src);for(const [k,v] of Object.entries({x,y:frame.y,width:frame.width,height:frame.height,preserveAspectRatio:'xMidYMid slice',opacity:'.55'}))image.setAttribute(k,String(v));group.prepend(image);
     const header=document.createElementNS('http://www.w3.org/2000/svg','rect');for(const [k,v] of Object.entries({x:side==='back'?x+frame.width-w:x,y:frame.y,width:w,height:frame.height,fill:api.photos.headerColor()}))header.setAttribute(k,String(v));image.after(header);
    }
   }
   for(const e of [clone,...clone.querySelectorAll('*')])if(e.id){ids.set(e.id,prefix+e.id);e.id=prefix+e.id;}for(const e of [clone,...clone.querySelectorAll('*')]){for(const a of [...e.attributes]){if(a.name.startsWith('data-')&&a.name!=='data-size')e.removeAttribute(a.name);else{let v=a.value;for(const [old,id] of ids)v=v.split('url(#'+old+')').join('url(#'+id+')');if(v!==a.value)e.setAttribute(a.name,v);}}}preview.querySelector('.pro-photo-detail-preview__stage').replaceChildren(clone);preview.querySelector('[data-pro-preview-side]').textContent=side.toUpperCase();
  }
  const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(update);}};
  // Observe the original proof only; the detail copy is intentionally excluded.
  for(const side of ['front','back']){const original=source(side);if(original)new MutationObserver(schedule).observe(original,{attributes:true,childList:true,subtree:true,characterData:true});}
  section.addEventListener('input',schedule);section.addEventListener('change',schedule);panel.addEventListener('click',schedule);document.fonts.ready.then(schedule);schedule();
 }
 return {mount,headerMarkup};
})();

/* Pro Gameday Flags: independent photo backgrounds; never replaces logo or text layers. */
(function(root,factory){const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else root.GamedayProPhotos=api;})(typeof window==='object'?window:globalThis,function(){
 'use strict';
 const clamp=(n,a,b,f)=>Number.isFinite(Number(n))?Math.min(b,Math.max(a,Number(n))):f;
 const fresh=()=>({mode:'fill',zoom:1,x:0,y:0,rotation:0});
 const placement=p=>({mode:p?.mode==='fit'?'fit':'fill',zoom:clamp(p?.zoom,1,4,1),x:clamp(p?.x,-100,100,0),y:clamp(p?.y,-100,100,0),rotation:[0,90,180,270].includes(p?.rotation)?p.rotation:0});
 function layout(box,iw,ih,p){p=placement(p);const flip=p.rotation%180!==0,rw=flip?ih:iw,rh=flip?iw:ih;if(!(rw>0&&rh>0&&box.width>0&&box.height>0))throw Error('Invalid photo dimensions');const scale=(p.mode==='fit'?Math.min:Math.max)(box.width/rw,box.height/rh)*p.zoom;return {cx:box.x+box.width/2+Math.abs(rw*scale-box.width)*p.x/200,cy:box.y+box.height/2+Math.abs(rh*scale-box.height)*p.y/200,scale,rotation:p.rotation};}
 function validate(v){if(!v)return {version:1,linked:true,headerColor:'#171C17',front:null,back:null,placement:{front:fresh(),back:fresh()}};if(v.version!==1)throw Error('Unsupported Pro photo revision');const r={version:1,linked:v.linked!==false,headerColor:/^#[a-f0-9]{6}$/i.test(v.headerColor||'')?v.headerColor.toUpperCase():'#171C17',placement:{front:placement(v.placement?.front),back:placement(v.placement?.back)}};for(const side of ['front','back']){const a=v[side];if(!a){r[side]=null;continue;}if(typeof a.name!=='string'||a.name.length>180||!/^data:image\/(png|jpeg|webp);base64,[A-Za-z0-9+/]*={0,2}$/.test(a.dataUrl||'')||a.dataUrl.length>12*1024*1024||!/^\w{64}$/.test(a.sha256||''))throw Error('Invalid saved '+side+' photo');if(a.sourceOriginal){const original=a.sourceOriginal;if(typeof original.name!=='string'||original.name.length>180||!/^data:image\/(png|jpeg|webp);base64,[A-Za-z0-9+/]*={0,2}$/.test(original.dataUrl||'')||original.dataUrl.length>12*1024*1024||!/^[a-f0-9]{64}$/.test(original.sha256||''))throw Error('Invalid Studio original');}r[side]={...a,fullFlag:a.fullFlag===true};}return r;}
 function mount(section,{size,geometry,changed,paletteColor}){
  let state=validate(),images={front:null,back:null},revision=0,inflight=0;const cache=new Map(),pending={front:0,back:0};
  const panel=document.createElement('details');panel.open=true;panel.className='custom-pro-photos';panel.innerHTML='<summary>Photos · optional background layer</summary><p>Add photos behind your logos and lettering. Each side has independent fit and positioning.</p><label><input type="checkbox" data-pro-link checked> Same photo on both sides</label>'+['front','back'].map(side=>'<fieldset data-pro-side="'+side+'"><legend>'+side.toUpperCase()+' PHOTO</legend><input type="file" data-pro-upload="'+side+'" accept="image/png,image/jpeg,image/webp"><p data-pro-status="'+side+'">No photo · use the existing background</p><label>Fit <select data-pro-key="mode"><option value="fill">Fill photo field</option><option value="fit">Fit whole photo</option></select></label>'+[['zoom','Zoom',1,4,.05],['x','Left / right',-100,100,1],['y','Up / down',-100,100,1]].map(([k,t,a,b,s])=>'<label>'+t+'<input type="range" data-pro-key="'+k+'" min="'+a+'" max="'+b+'" step="'+s+'"></label>').join('')+'<button type="button" data-pro-rotate>Rotate 90°</button><button type="button" data-pro-remove>Remove photo</button></fieldset>').join('')+'<div class="pro-palette-link"><i data-pro-header-swatch></i><span><strong>Palette-linked hem header</strong><small>Primary / front field color · automatically matched on both sides</small></span><output data-pro-header-value></output></div><p data-pro-message role="status"></p>';
  const anchor=section.querySelector('.custom-designer__step--artwork');if(!anchor)throw Error('Pro photo placement anchor missing');anchor.before(panel);
  const style=document.createElement('style');style.textContent='.custom-pro-photos{padding:24px;border:1px solid #777;background:#242924;color:white;min-width:0}.custom-pro-photos summary{font-weight:800;color:#a6d90d;cursor:pointer}.custom-pro-photos fieldset{margin:16px 0;padding:12px;min-width:0}.custom-pro-photos label{display:block;margin:12px 0}.custom-pro-photos input[type=range],.custom-pro-photos select,.custom-pro-photos input[type=file]{width:100%;max-width:100%}.custom-pro-photos button{padding:8px;margin:4px;color:#111;background:#a6d90d}.custom-pro-photos [data-pro-hex]{width:110px;color:#111;background:white}.custom-pro-photos p{font-size:13px}';panel.append(style);
  const tabs=document.createElement('div');tabs.innerHTML='<button type="button" data-pro-tab="front">FRONT PHOTO</button><button type="button" data-pro-tab="back">BACK PHOTO</button>';panel.querySelector('fieldset').before(tabs);panel.querySelector('[data-pro-side="back"]').hidden=true;tabs.addEventListener('click',e=>{if(!e.target.dataset.proTab)return;for(const row of panel.querySelectorAll('[data-pro-side]'))row.hidden=row.dataset.proSide!==e.target.dataset.proTab;});
  style.textContent+='.custom-pro-photos input[type=range]{accent-color:#a6d90d}.custom-pro-photos fieldset[hidden]{display:none}.custom-pro-photos button{border:0;font-weight:700;font-size:12px}.custom-pro-photos summary{font-size:20px}.custom-pro-photos{font-family:inherit}.custom-pro-photos input[type=file]{font-size:12px}';
  const q=s=>panel.querySelector(s),asset=side=>state.linked&&side==='back'?state.front:state[side],img=side=>state.linked&&side==='back'?images.front:images[side];
  function sync(){const fullFlag=Boolean(asset('front')?.fullFlag||asset('back')?.fullFlag);q('summary').textContent=fullFlag?'Studio artwork · full flag faces':'Photos · optional background layer';q('.pro-palette-link strong').textContent=fullFlag?'Full-flag artwork imported':'Palette-linked hem header';q('.pro-palette-link small').textContent=fullFlag?'Review both sides and print placement before ordering.':'Primary / front field color · automatically matched on both sides';q('[data-pro-link]').checked=state.linked;q('[data-pro-upload="back"]').disabled=state.linked;syncPalette();for(const side of ['front','back']){const row=q('[data-pro-side="'+side+'"]');for(const el of row.querySelectorAll('[data-pro-key]'))el.value=state.placement[side][el.dataset.proKey];q('[data-pro-status="'+side+'"]').textContent=(side==='back'&&state.linked?'Linked to front · ':'')+(asset(side)?.name||'No photo · use the existing background');}for(const side of ['front','back'])q('[data-pro-side="'+side+'"] [data-pro-remove]').disabled=!asset(side);window.GamedayProPhotoUI.refresh(panel);}
  function touch(){revision++;cache.clear();sync();changed();}
  const load=url=>new Promise((resolve,reject)=>{const i=new Image();i.onload=()=>resolve(i);i.onerror=()=>reject(Error('Photo cannot be opened'));i.src=url;});
  async function upload(side,file){if(!file)return;const ticket=++pending[side];inflight++;changed();try{if(!['image/png','image/jpeg','image/webp'].includes(file.type)||file.size>8*1024*1024)throw Error('Choose PNG, JPG or WebP up to 8 MB');const dataUrl=await new Promise((resolve,reject)=>{const r=new FileReader();r.onload=()=>resolve(r.result);r.onerror=reject;r.readAsDataURL(file);});const image=await load(dataUrl);if(image.naturalWidth*image.naturalHeight>100000000)throw Error('Photo exceeds 100 megapixels');const digest=await crypto.subtle.digest('SHA-256',await file.arrayBuffer());if(ticket!==pending[side])return;state[side]={name:file.name.slice(0,180),dataUrl,sha256:[...new Uint8Array(digest)].map(x=>x.toString(16).padStart(2,'0')).join(''),width:image.naturalWidth,height:image.naturalHeight};images[side]=image;state.placement[side]=fresh();q('[data-pro-message]').textContent='Photo added; review both sides.';touch();}catch(e){q('[data-pro-message]').textContent=e.message;}finally{inflight--;changed();}}
  for(const side of ['front','back']){const row=q('[data-pro-side="'+side+'"]');q('[data-pro-upload="'+side+'"]').addEventListener('change',e=>upload(side,e.target.files[0]));for(const el of row.querySelectorAll('[data-pro-key]'))el.addEventListener('input',()=>{state.placement[side]=placement({...state.placement[side],[el.dataset.proKey]:el.value});touch();});row.querySelector('[data-pro-rotate]').onclick=()=>{state.placement[side].rotation=(state.placement[side].rotation+90)%360;touch();};row.querySelector('[data-pro-remove]').onclick=()=>{if(state.linked){if(side==='front'){state.back=state.front?structuredClone(state.front):null;images.back=images.front;}state.linked=false;}pending[side]++;state[side]=null;images[side]=null;state.placement[side]=fresh();q('[data-pro-upload="'+side+'"]').value='';q('[data-pro-message]').textContent=side.charAt(0).toUpperCase()+side.slice(1)+' photo removed. Your other side, colors, logo and lettering are unchanged.';touch();};}
  q('[data-pro-link]').onchange=e=>{state.linked=e.target.checked;touch();};
  function surface(side){syncPalette();const a=asset(side),image=img(side);if(!a||!image)return null;const key=revision+':'+size()+':'+side+':'+state.headerColor;if(!cache.has(key)){const g=geometry(),cv=document.createElement('canvas');cv.width=1800;cv.height=Math.round(cv.width/g.aspect);const ctx=cv.getContext('2d'),header=cv.width*g.headerWidth,box=a.fullFlag?{x:0,y:0,width:cv.width,height:cv.height}:{x:side==='front'?header:0,y:0,width:cv.width-header,height:cv.height};ctx.fillStyle='#fff';ctx.fillRect(0,0,cv.width,cv.height);const l=layout(box,image.naturalWidth,image.naturalHeight,state.placement[side]);ctx.save();ctx.beginPath();ctx.rect(box.x,0,box.width,box.height);ctx.clip();ctx.translate(l.cx,l.cy);ctx.rotate(l.rotation*Math.PI/180);ctx.drawImage(image,-image.naturalWidth*l.scale/2,-image.naturalHeight*l.scale/2,image.naturalWidth*l.scale,image.naturalHeight*l.scale);ctx.restore();if(!a.fullFlag){ctx.fillStyle=state.headerColor;ctx.fillRect(side==='front'?0:cv.width-header,0,header,cv.height);}cache.set(key,{id:'pro-photo-'+side,kind:'pro-photo',fullFlag:a.fullFlag===true,name:a.name,description:'Customer photo background',dataUrl:cv.toDataURL('image/png')});}return cache.get(key);}
  async function restore(v){const next=validate(v),decoded={front:null,back:null};for(const side of ['front','back'])if(next[side]){const bytes=Uint8Array.from(atob(next[side].dataUrl.split(',')[1]),c=>c.charCodeAt(0));const hash=[...new Uint8Array(await crypto.subtle.digest('SHA-256',bytes))].map(x=>x.toString(16).padStart(2,'0')).join('');if(hash!==next[side].sha256)throw Error('Saved photo hash mismatch');decoded[side]=await load(next[side].dataUrl);}state=next;images=decoded;touch();}
  function syncPalette(){const c=paletteColor?.();if(/^#[a-f0-9]{6}$/i.test(c||''))state.headerColor=c.toUpperCase();state.headerColorSource='palette-front-primary';q('[data-pro-header-swatch]').style.background=state.headerColor;q('[data-pro-header-value]').textContent=state.headerColor;return state.headerColor;}
  window.GamedayProPhotoUI(panel,{upload,reset:side=>{state.placement[side]=fresh();touch();}});
  panel.addEventListener('input',()=>requestAnimationFrame(()=>window.GamedayProPhotoUI.refresh(panel)));
  sync();return {busy:()=>inflight>0,surface,restore,recipe:()=>{syncPalette();return structuredClone(state);},hasPhotos:()=>Boolean(state.front||state.back),headerColor:syncPalette,panel};
 }
 return {fresh,placement,layout,validate,mount};
});

(() => {
  const fallbackShellProfiles = {
    exo: {
      logoKey: "exoLogo",
      logoAlt: "EXOLOX",
      domain: "EXOLOX.COM",
      domainUrl: "/",
      navLabel: "EXO navigation",
      nav: [
        ["Brands", "/#brand-network"],
        ["Strategy + Engineering", "/pages/market-sales-strategy"],
        ["Manufacturing", "/pages/exocnc"],
        ["Live Environments", "/collections/live-environments"],
        ["EXO OS", "/pages/exo-os"],
        ["Contact", "/pages/contact"],
      ],
    },
    diatread: {
      logoKey: "diatreadLogo",
      logoAlt: "DiaTread",
      domain: "DIATREAD.COM",
      domainUrl: "/pages/diatread",
      navLabel: "DiaTread navigation",
      nav: [
        ["Stair Treads", "/collections/diatread-stair-treads"],
        ["Stringers", "/collections/diatread-stringers"],
        ["Prefabricated Systems", "/collections/diatread-prefabricated-systems"],
        ["Hardware", "/collections/diatread-hardware"],
      ],
    },
    gameday: {
      logoKey: "gamedayLogo",
      logoAlt: "Gameday Flags",
      domain: "GAMEDAYFLAGS.COM",
      domainUrl: "https://gamedayflags.com/",
      navLabel: "Gameday Flags navigation",
      nav: [
  [
    "FLAGS",
    "/collections/gameday-flags"
  ],
  [
    "POLES",
    "/collections/flagpoles"
  ],
  [
    "GEAR",
    "/collections/gameday-accessories"
  ],
  [
    "GAMES",
    "/collections/gameday-games"
  ],
  [
    "NOTES",
    "/blogs/gameday-field-notes"
  ]
],
    },
    rolypulley: {
      logoKey: "rolypulleyLogo",
      logoAlt: "RolyPulley",
      domain: "ROLYPULLEY",
      domainUrl: "/collections/rolypulley",
      navLabel: "RolyPulley navigation",
      nav: [
        ["Pulleys", "/collections/rolypulley"],
        ["Kits", "/collections/rolypulley-kits"],
        ["LaserWeb", "/products/exo-hdw-laserweb-configurable-webbing"],
        ["Hardware", "/collections/rolypulley-hardware"],
      ],
    },
    "exo-hdw": {
      logoKey: "exoHdwLogo",
      logoAlt: "EXOHDW",
      domain: "EXOHDW",
      domainUrl: "/collections/exo-hdw",
      navLabel: "EXOHDW navigation",
      nav: [
        ["Hardware", "/collections/exo-hdw"],
        ["EXOWASHER", "/products/exo-hdw-flat-washer-1-4"],
        ["RolyPulley", "/collections/rolypulley"],
        ["Quality Standards + Warranty", "/pages/exo-quality-standards"],
      ],
    },
    exostrut: {
      logoKey: "exostrutLogo",
      logoAlt: "EXOSTRUT",
      domain: "EXOSTRUT",
      domainUrl: "/collections/exostrut",
      navLabel: "EXOSTRUT navigation",
      nav: [
        ["Channels", "/collections/exostrut-channels"],
        ["Brackets", "/collections/exostrut-brackets"],
        ["Hardware", "/collections/exostrut-hardware"],
        ["Prefab assemblies", "/collections/exostrut-prefab-assemblies"],
      ],
    },
    virtus: {
      logoKey: "virtusLogo",
      logoAlt: "Virtus Vans",
      domain: "VIRTUSVANS.COM",
      domainUrl: "https://virtusvans.com/",
      navLabel: "Virtus Vans navigation",
      nav: [
        [
          "Base Camp",
          "https://virtusvans.com/products/virtus-vans-mercedes-sprinter-2019-modular-base-camp-build",
        ],
        [
          "Side Steps",
          "https://virtusvans.com/products/virtus-vans-mercedes-sprinter-2019-black-diamond-side-steps",
        ],
        ["Storage", "https://virtusvans.com/collections/cabinetry-furniture"],
      ],
    },
    lesstain: {
      logoKey: "lesstainLogo",
      logoAlt: "Lesstain",
      domain: "LESSTAIN",
      domainUrl: "/collections/lesstain",
      navLabel: "Lesstain navigation",
      nav: [
        ["Trim", "/collections/lesstain#trim"],
        ["Countertops", "/collections/lesstain#countertops"],
        ["Bollards", "/collections/lesstain#bollards"],
        ["Security", "/collections/lesstain#security"],
      ],
    },
  };

  const canonicalExoNavigation = [
    ["Brands", "/#brand-network"],
    [
      "Strategy + Engineering",
      "/pages/market-sales-strategy",
      [
        ["Strategy + Engineering overview", "/pages/market-sales-strategy"],
        ["Product + IP development", "/pages/market-sales-strategy#product-ip"],
        ["Market + sales strategy", "/pages/market-sales-strategy#market-growth"],
        ["Partnerships + licensing", "/pages/market-sales-strategy#partnerships-licensing"],
        ["Certification + testing", "/pages/market-sales-strategy#certification-testing"],
      ],
    ],
    [
      "Manufacturing",
      "/pages/exocnc",
      [
        ["Connected manufacturing overview", "/pages/exocnc"],
        ["EXOCNC work centers", "/pages/exocnc#work-centers"],
        ["EXOHDW modular hardware", "/collections/exo-hdw"],
        ["Quality Standards + Warranty", "/pages/exo-quality-standards"],
        ["Product configurators", "/#configurators"],
      ],
    ],
    [
      "Live Environments",
      "/collections/live-environments",
      [
        ["Environmental branding", "/collections/live-environments#environmental-branding"],
        ["Events + activations", "/collections/live-environments#events-activations"],
        ["Tradeshows + exhibits", "/collections/live-environments#tradeshows-exhibits"],
        ["Photo + content systems", "/collections/live-environments#photo-content"],
      ],
    ],
    ["EXO OS", "/pages/exo-os"],
    ["Contact", "/pages/contact"],
  ];

  function initAdaptiveHeader(root = document) {
    const header = root.querySelector("[data-exo-header]");
    const page = document.querySelector(".brand-network");
    if (!header || !page || header.dataset.ready === "true") return;
    header.dataset.ready = "true";

    const logo = header.querySelector("[data-header-logo]");
    const brand = header.querySelector(".adaptive-header__brand");
    const nav = header.querySelector("[data-header-nav]");
    const domain = header.querySelector("[data-header-domain]");
    const domainText = domain?.querySelector("strong");
    const mobileMenu = header.querySelector("[data-header-mobile-menu]");
    const mobileMenuLabel = header.querySelector("[data-header-mobile-menu-label]");
    const mobileMenuLinks = header.querySelector("[data-header-mobile-menu-links]");
    let shellProfiles = fallbackShellProfiles;
    try {
      const configuredProfiles = JSON.parse(
        header.querySelector("[data-shell-profiles]")?.textContent || "{}",
      );
      if (
        configuredProfiles.exo?.nav?.length &&
        configuredProfiles.diatread?.nav?.length &&
        configuredProfiles.rolypulley?.nav?.length &&
        configuredProfiles.exostrut?.nav?.length &&
        configuredProfiles.virtus?.nav?.length &&
        configuredProfiles.lesstain?.nav?.length
      ) {
        shellProfiles = configuredProfiles;
      }
    } catch {
      shellProfiles = fallbackShellProfiles;
    }
    if (shellProfiles.exo) shellProfiles.exo.nav = canonicalExoNavigation;
    let currentShell = "";
    let frame = 0;

    const buildMobileMenuItem = ([label, href, children], shell) => {
      if (shell === "exo" && label.toLocaleLowerCase() === "brands") {
        const group = document.createElement("details");
        group.className = "adaptive-header__mobile-brands";
        const summary = document.createElement("summary");
        summary.textContent = label;
        const indicator = document.createElement("span");
        indicator.className = "adaptive-header__mobile-menu-indicator";
        indicator.setAttribute("aria-hidden", "true");
        summary.append(indicator);

        const grid = document.createElement("div");
        grid.className = "adaptive-header__brand-orbit adaptive-header__mobile-brands-grid";
        grid.setAttribute("aria-label", "EXO brand network");
        const brandTemplate = header.querySelector("[data-header-brand-menu-template]");
        brandTemplate?.content
          ?.querySelectorAll(".adaptive-header__brand-orbit-item")
          .forEach((item) => grid.append(item.cloneNode(true)));
        group.append(summary, grid);
        return group;
      }

      if (Array.isArray(children) && children.length) {
        const group = document.createElement("details");
        group.className = "adaptive-header__mobile-group";
        const summary = document.createElement("summary");
        summary.textContent = label;
        const indicator = document.createElement("span");
        indicator.className = "adaptive-header__mobile-menu-indicator";
        indicator.setAttribute("aria-hidden", "true");
        summary.append(indicator);

        const links = document.createElement("div");
        links.className = "adaptive-header__mobile-group-links";
        children.forEach(([childLabel, childHref]) => {
          const childLink = document.createElement("a");
          childLink.href = childHref;
          childLink.textContent = childLabel;
          links.append(childLink);
        });
        group.append(summary, links);
        return group;
      }

      const link = document.createElement("a");
      link.href = href;
      link.textContent = label;
      return link;
    };

    const renderShell = (shell) => {
      if (!shellProfiles[shell] || currentShell === shell) return;
      currentShell = shell;
      const profile = shellProfiles[shell];
      page.dataset.activeShell = shell;
      if (logo) {
        logo.src = header.dataset[profile.logoKey];
        logo.alt = profile.logoAlt;
      }
      if (brand) brand.href = profile.domainUrl;
      if (nav) {
        nav.setAttribute("aria-label", profile.navLabel);
        nav.replaceChildren(
          ...profile.nav.map(([label, href]) => {
            const link = document.createElement("a");
            link.href = href;
            link.textContent = label;
            return link;
          }),
        );
      }
      if (domain) domain.href = profile.domainUrl;
      if (domainText) domainText.textContent = profile.domain;
      if (mobileMenuLabel) mobileMenuLabel.textContent = "Menu";
      if (mobileMenuLinks) {
        mobileMenuLinks.setAttribute("aria-label", `${profile.logoAlt} mobile navigation`);
        mobileMenuLinks.replaceChildren(
          ...profile.nav.map((item) => buildMobileMenuItem(item, shell)),
        );
      }
      mobileMenu?.removeAttribute("open");
    };

    mobileMenuLinks?.addEventListener("toggle", (event) => {
      const openedGroup = event.target.closest(".adaptive-header__mobile-group, .adaptive-header__mobile-brands");
      if (!openedGroup?.open) return;
      mobileMenuLinks
        .querySelectorAll(".adaptive-header__mobile-group[open], .adaptive-header__mobile-brands[open]")
        .forEach((group) => {
          if (group !== openedGroup) group.removeAttribute("open");
        });
    }, true);

    document.addEventListener("pointerdown", (event) => {
      if (mobileMenu?.open && !mobileMenu.contains(event.target)) {
        mobileMenu.removeAttribute("open");
      }
    });
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") mobileMenu?.removeAttribute("open");
    });

    const update = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const sections = [...document.querySelectorAll("[data-brand-shell]")];
        if (!sections.length) return;
        const headerBoundary = Math.min(
          window.innerHeight - 1,
          Math.max(0, header.getBoundingClientRect().bottom + 1),
        );
        const active =
          sections.find((section) => {
            const rect = section.getBoundingClientRect();
            return rect.top <= headerBoundary && rect.bottom > headerBoundary;
          }) ||
          sections.reduce((nearest, section) => {
            const nearestDistance = Math.abs(
              nearest.getBoundingClientRect().top - headerBoundary,
            );
            const distance = Math.abs(
              section.getBoundingClientRect().top - headerBoundary,
            );
            return distance < nearestDistance ? section : nearest;
          });
        renderShell(active.dataset.brandShell || "exo");
      });
    };

    renderShell(document.body.dataset.exoPageShell || "exo");

    const observer = new IntersectionObserver(update, {
      rootMargin: "-84px 0px -75% 0px",
      threshold: [0, 0.01, 0.5, 1],
    });
    document
      .querySelectorAll("[data-brand-shell]")
      .forEach((section) => observer.observe(section));
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    if ("ResizeObserver" in window) {
      const headerObserver = new ResizeObserver(update);
      headerObserver.observe(header);
    }
    update();
  }

  function initCatalog(section) {
    if (!section || section.dataset.ready === "true") return;
    section.dataset.ready = "true";

    const cards = [...section.querySelectorAll("[data-design-card]")];
    const filterButtons = [...section.querySelectorAll("[data-catalog-filter]")];
    const groupButtons = [...section.querySelectorAll("[data-catalog-group]")];
    const library = section.querySelector("[data-design-library]");
    const context = section.querySelector("[data-catalog-context] strong");
    const search = section.querySelector("[data-catalog-search]");
    const empty = section.querySelector("[data-catalog-empty]");
    const proofImage = section.querySelector("[data-proof-image]");
    const proofCompanion = section.querySelector("[data-proof-companion]");
    const proofCompanionWrap = section.querySelector("[data-proof-companion-wrap]");
    const proofCompanionLabel = section.querySelector("[data-proof-companion-label]");
    const proofCompanionPending = section.querySelector("[data-proof-companion-pending]");
    const proofCaption = section.querySelector("[data-proof-caption]");
    const proofCode = section.querySelector("[data-proof-code]");
    const proofRoute = section.querySelector("[data-proof-route]");
    const proofState = section.querySelector("[data-proof-state]");
    const proofBadge = section.querySelector("[data-proof-badge]");
    const selectedDesign = section.querySelector("[data-selected-design]");
    const artworkProperty = section.querySelector("[data-artwork-property]");
    const designIdProperty = section.querySelector("[data-design-id-property]");
    const designCodeProperty = section.querySelector("[data-design-code-property]");
    const catalogVariantSku = section.querySelector("[data-catalog-variant-sku]");
    const catalogFulfillmentKey = section.querySelector("[data-catalog-fulfillment-key]");
    const receiptFaces = section.querySelector("[data-receipt-faces]");
    const receiptConstruction = section.querySelector("[data-receipt-construction]");
    const receiptLoadPath = section.querySelector("[data-receipt-load-path]");
    const viewButtons = [...section.querySelectorAll("[data-proof-view]")];
    const orbitButton = section.querySelector('[data-proof-view="orbit"]');
    const sizeButtons = [...section.querySelectorAll("[data-size-label]")];
    const selectedSize = section.querySelector("[data-selected-size]");
    const variantInput = section.querySelector("[data-variant-id]");
    const productForm = section.querySelector(".gameday-product-form");
    const kitLink = section.querySelector("[data-gameday-kit-link]");
    const dialog = section.querySelector("[data-feedback-dialog]");
    const dialogHeading = section.querySelector("[data-feedback-heading]");
    const dialogDesign = section.querySelector("[data-feedback-design]");
    const dialogIntent = section.querySelector("[data-feedback-intent]");
    const endpoint = section.dataset.engagementEndpoint;
    const defaultDesignId = section.dataset.defaultDesignId;
    const requestedDesignId = new URLSearchParams(window.location.search).get("design");
    const initialCard =
      cards.find((card) => card.dataset.designId === requestedDesignId) ||
      cards.find((card) => card.dataset.designId === defaultDesignId) ||
      cards.find((card) => card.classList.contains("is-selected")) ||
      cards[0];
    let activeFilter = "all";
    let activeGroup = "all";
    let activeCard = initialCard;
    let activeView = "front";
    let product = null;

    try {
      product = JSON.parse(
        section.querySelector("[data-gameday-product-json]")?.textContent || "null",
      );
    } catch {
      product = null;
    }

    const mediaFor = (card, view) => {
      if (!card) return "";
      if (view === "orbit") return card.dataset.orbit || "";
      if (view === "back") return card.dataset.back || "";
      return card.dataset.front || "";
    };

    const selectView = (view) => {
      activeView = view;
      viewButtons.forEach((button) => {
        const pressed = button.dataset.proofView === view;
        button.setAttribute("aria-pressed", String(pressed));
      });
      if (proofImage && activeCard) {
        const source = mediaFor(activeCard, view);
        proofImage.hidden = !source;
        if (source) proofImage.src = source;
        proofImage.alt = `${activeCard.dataset.designName} ${
          view === "orbit" ? "360-degree" : view
        } artwork proof`;
      }
      if (proofCompanionWrap && activeCard) {
        const companionView = view === "back" ? "front" : "back";
        const companionSource = mediaFor(activeCard, companionView);
        proofCompanionWrap.dataset.companionView = companionView;
        if (proofCompanionLabel) {
          proofCompanionLabel.textContent =
            companionView === "front" ? "FRONT / TAG SIDE" : "REVERSE / CLEAN SIDE";
        }
        if (proofCompanion) {
          proofCompanion.hidden = !companionSource;
          if (companionSource) proofCompanion.src = companionSource;
          proofCompanion.alt = `${activeCard.dataset.designName} ${companionView} artwork proof`;
        }
        if (proofCompanionPending) {
          proofCompanionPending.hidden = Boolean(companionSource);
        }
      }
      if (proofCaption) {
        const hasSource = Boolean(mediaFor(activeCard, view));
        const isSupplier = activeCard?.dataset.proofStatus === "supplier";
        proofCaption.textContent = !hasSource
          ? "REVERSE ARTWORK / SOURCE REVIEW REQUIRED"
          : view === "orbit"
            ? "APPROVED 360 / FRONT + CLEAN REVERSE"
            : view === "back"
              ? "CLEAN SIDE / REVERSE ARTWORK"
              : isSupplier
                ? "CATALOG / FRONT PROOF"
                : "TAG SIDE / FRONT ARTWORK";
      }
    };

    const selectDesign = (card) => {
      if (!card) return;
      activeCard = card;
      cards.forEach((candidate) => {
        const isSelected = candidate === card;
        candidate.classList.toggle("is-selected", isSelected);
        candidate
          .querySelector("[data-select-design]")
          ?.setAttribute("aria-pressed", String(isSelected));
      });
      if (proofCode) proofCode.textContent = card.dataset.designCode || card.dataset.designId;
      if (proofRoute) {
        proofRoute.textContent =
          card.dataset.supplyRoute === "eder-authentic"
            ? "CATALOG PROOF / AUTHENTIC OPTION"
            : card.dataset.supplyRoute === "eder"
              ? "CATALOG PROOF"
              : "AUTHENTIC GAMEDAY FLAG / ARTWORK PROOF";
      }
      const hasOrbit = Boolean(card.dataset.orbit);
      if (orbitButton) orbitButton.disabled = !hasOrbit;
      if (activeView === "orbit" && !hasOrbit) activeView = "front";
      const status = card.dataset.proofStatus || "legacy";
      if (proofState) {
        proofState.textContent =
          status === "connected"
            ? "CONNECTED MODEL"
            : status === "intake"
              ? "ARTWORK INTAKE"
              : status === "supplier"
                ? "SUPPLIER SOURCE"
                : "LEGACY ART PROOF";
      }
      if (proofBadge) {
        proofBadge.textContent =
          status === "connected"
            ? "CONNECTED 360 MODEL"
            : status === "intake"
              ? "ARTWORK REQUIRED"
              : status === "supplier"
                ? "CATALOG PROOF / AUTHENTIC RIGHTS GATED"
                : "LEGACY ART PROOF / RELEASE REVIEW";
      }
      if (selectedDesign) selectedDesign.textContent = card.dataset.designName;
      if (artworkProperty) artworkProperty.value = card.dataset.designName;
      if (designIdProperty) designIdProperty.value = card.dataset.designId || "";
      if (designCodeProperty) designCodeProperty.value = card.dataset.designCode || "";
      if (catalogFulfillmentKey) {
        catalogFulfillmentKey.value = `${card.dataset.designCode || "DESIGN"} / ${
          catalogVariantSku?.value || "SKU PENDING"
        }`;
      }
      if (kitLink) {
        const kitUrl = new URL(kitLink.getAttribute("href"), window.location.origin);
        kitUrl.searchParams.set("design", card.dataset.designId || "");
        kitUrl.searchParams.set("design_name", card.dataset.designName || "Selected Authentic flag");
        kitUrl.searchParams.set("design_code", card.dataset.designCode || "DESIGN PENDING");
        kitLink.href = `${kitUrl.pathname}${kitUrl.search}`;
      }
      const isSupplier = card.dataset.supplyRoute?.startsWith("eder");
      if (receiptFaces) {
        receiptFaces.textContent = isSupplier
          ? card.dataset.back
            ? "Supplier front + sourced reverse proof"
            : "Front source / reverse proof pending"
          : "Approved front + clean reverse";
      }
      if (receiptConstruction) {
        receiptConstruction.textContent = isSupplier
          ? "Choose a catalog flag or Authentic construction"
          : "Authentic webbing-bound flag";
      }
      if (receiptLoadPath) {
        receiptLoadPath.textContent = isSupplier
          ? "Route-specific / supplier and Authentic specs stay separate"
          : "Webbing perimeter + matching loops";
      }
      const submit = productForm?.querySelector('button[type="submit"]');
      const releasedForOrder =
        productForm?.dataset.gamedayPaymentLocked !== "true" &&
        ["available", "order"].includes(card.dataset.state) &&
        card.dataset.supplyRoute === "authentic";
      if (submit) {
        submit.disabled = !releasedForOrder;
        submit.firstChild.textContent = releasedForOrder
          ? "ADD AUTHENTIC FLAG TO CART "
          : "RELEASE LOCKED ";
      }
      selectView(activeView);
    };

    const updateContext = () => {
      if (!context) return;
      const visibleCards = cards.filter((card) => !card.hidden);
      if (!visibleCards.length) {
        context.textContent = "NO MATCHING DESIGNS";
        return;
      }
      const libraryTop = library?.getBoundingClientRect().top || 0;
      const current =
        visibleCards.find((card) => card.getBoundingClientRect().bottom > libraryTop + 24) ||
        visibleCards[0];
      const labels = [
        current.dataset.organizationLabel,
        current.dataset.conferenceLabel,
      ].filter(Boolean);
      context.textContent = labels.join(" / ") || current.dataset.category || "ALL DESIGNS";
    };

    const applyFilters = () => {
      const term = (search?.value || "").trim().toLowerCase();
      let visibleCount = 0;
      cards.forEach((card) => {
        const stateMatches = activeFilter === "all" || card.dataset.state === activeFilter;
        const groupMatches =
          activeGroup === "all" ||
          card.dataset.organization === activeGroup ||
          card.dataset.conference === activeGroup ||
          card.dataset.category === activeGroup;
        const searchMatches = !term || (card.dataset.search || "").includes(term);
        const visible = stateMatches && groupMatches && searchMatches;
        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });
      if (empty) empty.hidden = visibleCount !== 0;
      if (activeCard?.hidden) {
        selectDesign(cards.find((card) => !card.hidden));
      }
      if (library) library.scrollTop = 0;
      updateContext();
    };

    filterButtons.forEach((button) => {
      button.addEventListener("click", () => {
        activeFilter = button.dataset.catalogFilter;
        filterButtons.forEach((candidate) => {
          const active = candidate === button;
          candidate.classList.toggle("is-active", active);
          candidate.setAttribute("aria-pressed", String(active));
        });
        applyFilters();
      });
    });
    groupButtons.forEach((button) => {
      button.addEventListener("click", () => {
        activeGroup = button.dataset.catalogGroup;
        groupButtons.forEach((candidate) => {
          const active = candidate === button;
          candidate.classList.toggle("is-active", active);
          candidate.setAttribute("aria-pressed", String(active));
        });
        applyFilters();
      });
    });
    library?.addEventListener("scroll", updateContext, { passive: true });
    search?.addEventListener("input", applyFilters);
    cards.forEach((card) => {
      card
        .querySelector("[data-select-design]")
        ?.addEventListener("click", () => selectDesign(card));
    });
    viewButtons.forEach((button) => {
      button.addEventListener("click", () => selectView(button.dataset.proofView));
    });

    const matchVariant = (sizeLabel) => {
      if (!product?.variants || !variantInput) return;
      const normalized = sizeLabel.toLowerCase().replace(/\s+/g, " ").trim();
      const variant = product.variants.find((candidate) => {
        const values = [
          candidate.title,
          candidate.option1,
          candidate.option2,
          candidate.option3,
        ]
          .filter(Boolean)
          .map((value) => String(value).toLowerCase().replace(/\s+/g, " ").trim());
        return values.includes(normalized);
      });
      if (variant) {
        variantInput.value = variant.id;
        if (catalogVariantSku) catalogVariantSku.value = variant.sku || "SKU PENDING";
        if (catalogFulfillmentKey) {
          catalogFulfillmentKey.value = `${
            activeCard?.dataset.designCode || "DESIGN"
          } / ${variant.sku || "SKU PENDING"}`;
        }
        const submit = productForm?.querySelector('button[type="submit"]');
        if (submit) {
          const releasedForOrder =
        productForm?.dataset.gamedayPaymentLocked !== "true" &&
            ["available", "order"].includes(activeCard?.dataset.state) &&
            activeCard?.dataset.supplyRoute === "authentic";
          submit.disabled = !variant.available || !releasedForOrder;
          submit.firstChild.textContent = variant.available && releasedForOrder
            ? "ADD AUTHENTIC FLAG TO CART "
            : !releasedForOrder
              ? "RELEASE LOCKED "
              : "SELECTED SIZE UNAVAILABLE ";
        }
      }
    };

    sizeButtons.forEach((button) => {
      button.addEventListener("click", () => {
        sizeButtons.forEach((candidate) =>
          candidate.setAttribute("aria-pressed", String(candidate === button)),
        );
        if (selectedSize) selectedSize.textContent = button.dataset.sizeLabel;
        matchVariant(button.dataset.sizeLabel);
      });
    });

    const openFeedback = (button) => {
      const designName = button.dataset.designName || activeCard?.dataset.designName || "Selected flag";
      const intent = button.dataset.intent || "Comment";
      if (dialogHeading) dialogHeading.textContent = intent;
      if (dialogDesign) dialogDesign.value = designName;
      if (dialogIntent) dialogIntent.value = intent;
      if (typeof dialog?.showModal === "function") dialog.showModal();
      else dialog?.setAttribute("open", "");
    };
    section
      .querySelectorAll("[data-feedback-open]")
      .forEach((button) => button.addEventListener("click", () => openFeedback(button)));
    section
      .querySelector("[data-feedback-close]")
      ?.addEventListener("click", () => dialog?.close());
    dialog?.addEventListener("click", (event) => {
      if (event.target === dialog) dialog.close();
    });

    section.querySelectorAll('[data-interest-action="like"]').forEach((button) => {
      const designId = button.dataset.designId;
      const storageKey = `gameday-interest:${designId}`;
      const base = Number(button.dataset.baseCount || 0);
      const count = button.querySelector("[data-interest-count]");
      let supported = localStorage.getItem(storageKey) === "1";
      const render = () => {
        button.setAttribute("aria-pressed", String(supported));
        button.classList.toggle("is-supported", supported);
        if (count) count.textContent = String(base + (supported ? 1 : 0));
      };
      render();
      button.addEventListener("click", async () => {
        supported = !supported;
        localStorage.setItem(storageKey, supported ? "1" : "0");
        render();
        if (endpoint) {
          try {
            await fetch(endpoint, {
              method: "POST",
              credentials: "same-origin",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                designId,
                action: supported ? "support" : "remove_support",
              }),
            });
          } catch {
            // The local signal remains visible if the optional app endpoint is offline.
          }
        }
      });
    });

    const shareDesign = async (button) => {
      const designId = button.dataset.designId || activeCard?.dataset.designId || "";
      const designName = button.dataset.designName || activeCard?.dataset.designName || "Authentic Gameday Flag";
      const designCode = button.dataset.designCode || activeCard?.dataset.designCode || "";
      const shareUrl = new URL(window.location.href);
      shareUrl.searchParams.set("design", designId);
      shareUrl.hash = "gameday-configurator";
      const shareData = {
        title: `${designName} | Authentic Gameday Flag`,
        text: `Help ${designName} become an Authentic Gameday Flag. Likes, comments, shares, and pre-orders determine which collectible designs release next.`,
        url: shareUrl.toString(),
      };
      try {
        if (navigator.share) await navigator.share(shareData);
        else if (navigator.clipboard) await navigator.clipboard.writeText(shareData.url);
        else window.prompt("Copy this Authentic Gameday Flag link", shareData.url);
        const previous = button.dataset.shareLabel || button.textContent.trim();
        button.dataset.shareLabel = previous;
        button.classList.add("is-shared");
        button.setAttribute("aria-label", `Share link copied for ${designName}`);
        window.setTimeout(() => button.classList.remove("is-shared"), 1800);
        if (endpoint) {
          await fetch(endpoint, {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ designId, designCode, action: "share" }),
          }).catch(() => {});
        }
      } catch (error) {
        if (error?.name !== "AbortError") window.prompt("Copy this Authentic Gameday Flag link", shareData.url);
      }
    };
    section
      .querySelectorAll("[data-catalog-share]")
      .forEach((button) => button.addEventListener("click", () => shareDesign(button)));

    selectDesign(activeCard);
    selectView("front");
    applyFilters();
  }

  function initGamedayKit(section) {
    if (!section || section.dataset.kitReady === "true") return;
    section.dataset.kitReady = "true";
    const params = new URLSearchParams(window.location.search);
    const designId = params.get("design") || "";
    const designName = params.get("design_name") || "";
    const designCode = params.get("design_code") || "";
    const output = section.querySelector("[data-kit-design-output]");
    const chooseLink = section.querySelector("[data-kit-choose-flag]");
    const hiddenName = section.querySelector("[data-kit-design-name]");
    const hiddenId = section.querySelector("[data-kit-design-id]");
    const hiddenCode = section.querySelector("[data-kit-design-code]");
    if (designName && output) output.textContent = `${designName}${designCode ? ` / ${designCode}` : ""}`;
    if (hiddenName) hiddenName.value = designName || "Selection to be confirmed";
    if (hiddenId) hiddenId.value = designId || "Selection to be confirmed";
    if (hiddenCode) hiddenCode.value = designCode || "Selection to be confirmed";
    if (chooseLink) {
      const returnUrl = new URL(chooseLink.href, window.location.origin);
      returnUrl.searchParams.set("kit", section.dataset.kitHandle || "gameday-mvp-flagpole-kit");
      chooseLink.href = `${returnUrl.pathname}${returnUrl.search}#gameday-configurator`;
    }
  }

  function initProduct(section) {
    if (!section || section.dataset.productReady === "true") return;
    section.dataset.productReady = "true";
    const mediaSlides = [...section.querySelectorAll("[data-game-media-slide]")];
    const mediaButtons = [...section.querySelectorAll("[data-game-media-target]")];
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const applyViewerMotion = (viewer, active) => {
      const paused = viewer.dataset.motionPaused === "true";
      viewer.setAttribute("camera-controls", "");
      viewer.setAttribute("interaction-prompt", "auto");
      viewer.setAttribute("rotation-per-second", "14deg");
      viewer.setAttribute("auto-rotate-delay", "0");
      if (active && !paused) {
        viewer.setAttribute("auto-rotate", "");
        viewer.play?.();
      } else {
        viewer.removeAttribute("auto-rotate");
        viewer.pause?.();
      }
    };

    const setupDirectCameraControls = (viewer, slide, syncMotionButton) => {
      if (viewer.dataset.directCameraReady === "true") return;
      viewer.dataset.directCameraReady = "true";

      const clamp = (value, minimum, maximum) =>
        Math.min(maximum, Math.max(minimum, value));
      const orbitParts = (viewer.getAttribute("camera-orbit") || "0deg 70deg 65%")
        .trim()
        .split(/\s+/);
      let theta = Number.parseFloat(orbitParts[0]) || 0;
      let phi = Number.parseFloat(orbitParts[1]) || 70;
      let radius = Number.parseFloat(orbitParts[2]) || 65;

      const pauseForInteraction = () => {
        viewer.dataset.motionPaused = "true";
        applyViewerMotion(viewer, !slide.hidden);
        syncMotionButton();
      };

      const applyCamera = () => {
        viewer.setAttribute("camera-orbit", `${theta}deg ${phi}deg ${radius}%`);
        viewer.jumpCameraToGoal?.();
      };

      const bindGestureLayer = () => {
        const wrapper = viewer.closest(".shopify-model-viewer-ui");
        if (!wrapper) return;

        let layer = wrapper.querySelector("[data-exo-model-gesture]");
        if (!layer) {
          layer = document.createElement("div");
          layer.className = "gameday-game-product__model-gesture";
          layer.dataset.exoModelGesture = "";
          layer.setAttribute("aria-hidden", "true");
          wrapper.appendChild(layer);
        }

        if (layer.dataset.gestureReady !== "true") {
          layer.dataset.gestureReady = "true";
          const pointers = new Map();
          let lastPoint = null;
          let lastPinchDistance = 0;

          const pointerDistance = () => {
            const points = [...pointers.values()];
            if (points.length < 2) return 0;
            return Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y);
          };

          const releasePointer = (event) => {
            pointers.delete(event.pointerId);
            try {
              if (layer.hasPointerCapture(event.pointerId)) {
                layer.releasePointerCapture(event.pointerId);
              }
            } catch {
              // Pointer capture may already be released by the browser.
            }
            const remaining = [...pointers.values()];
            lastPoint = remaining.length === 1 ? remaining[0] : null;
            lastPinchDistance = remaining.length > 1 ? pointerDistance() : 0;
            layer.classList.toggle("is-dragging", pointers.size > 0);
          };

          layer.addEventListener(
            "pointerdown",
            (event) => {
              if (event.pointerType === "mouse" && event.button !== 0) return;
              event.preventDefault();
              event.stopPropagation();
              pauseForInteraction();
              const point = { x: event.clientX, y: event.clientY };
              pointers.set(event.pointerId, point);
              try {
                layer.setPointerCapture(event.pointerId);
              } catch {
                // Continue without capture when the browser does not expose it.
              }
              if (pointers.size === 1) {
                lastPoint = point;
              } else {
                lastPinchDistance = pointerDistance();
              }
              layer.classList.add("is-dragging");
            },
            { capture: true },
          );

          layer.addEventListener(
            "pointermove",
            (event) => {
              if (!pointers.has(event.pointerId)) return;
              event.preventDefault();
              event.stopPropagation();
              const point = { x: event.clientX, y: event.clientY };
              pointers.set(event.pointerId, point);

              if (pointers.size > 1) {
                const distance = pointerDistance();
                if (lastPinchDistance > 0 && distance > 0) {
                  radius = clamp(radius * (lastPinchDistance / distance), 38, 180);
                  applyCamera();
                }
                lastPinchDistance = distance;
                return;
              }

              if (lastPoint) {
                theta -= (point.x - lastPoint.x) * 0.34;
                phi = clamp(phi + (point.y - lastPoint.y) * 0.24, 10, 170);
                applyCamera();
              }
              lastPoint = point;
            },
            { capture: true },
          );

          ["pointerup", "pointercancel", "lostpointercapture"].forEach((eventName) => {
            layer.addEventListener(eventName, releasePointer, { capture: true });
          });

          layer.addEventListener(
            "wheel",
            (event) => {
              event.preventDefault();
              event.stopPropagation();
              pauseForInteraction();
              radius = clamp(radius + event.deltaY * 0.08, 38, 180);
              applyCamera();
            },
            { capture: true, passive: false },
          );
        }

        if (wrapper.dataset.exoZoomReady !== "true") {
          wrapper.dataset.exoZoomReady = "true";
          wrapper.addEventListener(
            "click",
            (event) => {
              const control = event.target.closest(".shopify-model-viewer-ui__button--control");
              if (!control) return;
              const zoomIn = control.classList.contains(
                "shopify-model-viewer-ui__button--zoom-in",
              );
              const zoomOut = control.classList.contains(
                "shopify-model-viewer-ui__button--zoom-out",
              );
              if (!zoomIn && !zoomOut) return;
              event.preventDefault();
              event.stopImmediatePropagation();
              pauseForInteraction();
              radius = clamp(radius + (zoomIn ? -8 : 8), 38, 180);
              applyCamera();
            },
            true,
          );
        }
      };

      viewer.addEventListener("load", bindGestureLayer);
      viewer.addEventListener("exo:model-viewer-ready", bindGestureLayer);
      bindGestureLayer();
    };

    const selectMedia = (target) => {
      mediaSlides.forEach((slide) => {
        const active = String(slide.dataset.gameMediaSlide) === String(target);
        slide.hidden = !active;
        slide.classList.toggle("is-active", active);
        slide.querySelectorAll("video").forEach((video) => {
          if (!active) video.pause();
        });
        slide.querySelectorAll("model-viewer").forEach((viewer) => {
          applyViewerMotion(viewer, active);
        });
      });
      mediaButtons.forEach((button) => {
        const active = String(button.dataset.gameMediaTarget) === String(target);
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-selected", String(active));
        button.tabIndex = active ? 0 : -1;
      });
    };

    mediaButtons.forEach((button, index) => {
      button.addEventListener("click", () => {
        selectMedia(button.dataset.gameMediaTarget);
      });
      button.addEventListener("keydown", (event) => {
        if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === "ArrowLeft") {
          nextIndex = (index - 1 + mediaButtons.length) % mediaButtons.length;
        } else if (event.key === "ArrowRight") {
          nextIndex = (index + 1) % mediaButtons.length;
        } else if (event.key === "Home") {
          nextIndex = 0;
        } else if (event.key === "End") {
          nextIndex = mediaButtons.length - 1;
        }
        mediaButtons[nextIndex]?.focus();
        mediaButtons[nextIndex]?.click();
      });
    });

    const initialMediaButton =
      mediaButtons.find((button) => button.classList.contains("is-active")) ||
      mediaButtons.find((button) => button.getAttribute("aria-selected") === "true") ||
      mediaButtons[0];
    if (initialMediaButton) selectMedia(initialMediaButton.dataset.gameMediaTarget);

    section.querySelectorAll("[data-game-model-cta]").forEach((button) => {
      const slide = button.closest("[data-game-media-slide]");
      const viewer = slide?.querySelector("model-viewer");
      if (!viewer) return;
      if (!viewer.dataset.motionPaused) {
        viewer.dataset.motionPaused = reducedMotion ? "true" : "false";
      }
      const syncMotionButton = () => {
        const paused = viewer.dataset.motionPaused === "true";
        button.setAttribute("aria-pressed", String(!paused));
        button.textContent = paused ? "PLAY MODEL MOTION" : "PAUSE MODEL MOTION";
        button.setAttribute(
          "aria-label",
          paused ? "Play model motion" : "Pause model motion",
        );
      };
      setupDirectCameraControls(viewer, slide, syncMotionButton);
      viewer.addEventListener("load", () => {
        applyViewerMotion(viewer, !slide.hidden);
        syncMotionButton();
      });
      viewer.addEventListener("exo:model-viewer-ready", () => {
        applyViewerMotion(viewer, !slide.hidden);
        syncMotionButton();
      });
      button.addEventListener("click", () => {
        const paused = viewer.dataset.motionPaused === "true";
        viewer.dataset.motionPaused = paused ? "false" : "true";
        applyViewerMotion(viewer, !slide.hidden);
        syncMotionButton();
      });
      applyViewerMotion(viewer, !slide.hidden);
      syncMotionButton();
    });

    let variants = [];
    try {
      variants = JSON.parse(
        section.querySelector("[data-product-variants]")?.textContent || "[]",
      );
    } catch {
      return;
    }
    const variantInput = section.querySelector("[data-product-variant]");
    const variantSkuProperty = section.querySelector("[data-product-variant-sku]");
    const fulfillmentKeyProperty = section.querySelector("[data-product-fulfillment-key]");
    const variantSkuOutput = section.querySelector("[data-product-sku-output]");
    const price = section.querySelector("[data-product-price]");
    const submit = section.querySelector('button[type="submit"]');
    const submitLabel = section.querySelector("[data-product-submit-label]");
    const submitAvailableLabel = "ADD PAIR TO CART";
    const submitUnavailableLabel = "SELECTED PAIR UNAVAILABLE";
    const quote = section.querySelector("[data-product-quote]");
    const radios = [...section.querySelectorAll('input[type="radio"][name^="options["]')];
    const quoteRadios = [
      ...section.querySelectorAll(
        'input[type="radio"][name^="quote["], input[type="radio"][name^="properties["]',
      ),
    ];

    const update = () => {
      const selected = {};
      radios
        .filter((radio) => radio.checked)
        .forEach((radio) => {
          selected[radio.name] = radio.value;
        });
      const values = Object.values(selected);
      const variant = variants.find((candidate) =>
        values.every((value) =>
          [candidate.option1, candidate.option2, candidate.option3].includes(value),
        ),
      );
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      const variantSku = variant.sku || "SKU PENDING";
      if (variantSkuProperty) variantSkuProperty.value = variantSku;
      if (variantSkuOutput) variantSkuOutput.textContent = variantSku;
      if (fulfillmentKeyProperty) {
        fulfillmentKeyProperty.value = `${
          fulfillmentKeyProperty.dataset.designCode || "DESIGN"
        } / ${variantSku}`;
      }
      const finishValue = variant.option1;
      if (finishValue) {
        const matchingMediaButton = mediaButtons.find((button) =>
          String(button.dataset.gameFinishValues || "")
            .split(",")
            .map((value) => value.trim())
            .filter(Boolean)
            .includes(finishValue),
        );
        if (matchingMediaButton) {
          selectMedia(matchingMediaButton.dataset.gameMediaTarget);
        }
      }
      if (submit) {
        submit.disabled = !variant.available;
        if (submitLabel) {
          submitLabel.textContent = variant.available
            ? submitAvailableLabel
            : submitUnavailableLabel;
        }
      }
      if (price) {
        const currency = window.Shopify?.currency?.active || "USD";
        price.textContent = new Intl.NumberFormat(document.documentElement.lang || "en", {
          style: "currency",
          currency,
        }).format(variant.price / 100);
      }
      if (quote) {
        const base = quote.dataset.quoteBase || quote.getAttribute("href") || "/pages/contact";
        const destination = new URL(base, window.location.origin);
        destination.searchParams.set(
          "product",
          section.dataset.productHandle || document.title,
        );
        Object.entries(selected).forEach(([name, value]) => {
          destination.searchParams.set(
            name.replace(/^options\[/, "").replace(/\]$/, "").toLowerCase().replace(/\s+/g, "_"),
            value,
          );
        });
        quoteRadios
          .filter((radio) => radio.checked)
          .forEach((radio) => {
            destination.searchParams.set(
              radio.name
                .replace(/^(quote|properties)\[/, "")
                .replace(/\]$/, "")
                .toLowerCase()
                .replace(/\s+/g, "_"),
              radio.value,
            );
          });
        quote.href = `${destination.pathname}${destination.search}${destination.hash}`;
      }
    };
    radios.forEach((radio) => radio.addEventListener("change", update));
    quoteRadios.forEach((radio) => radio.addEventListener("change", update));
    update();
  }

  function initCustomDesigner(section) {
    if (!section || section.dataset.customReady === "true") return;
    section.dataset.customReady = "true";

    const form = section.querySelector(".custom-designer__form");
    const controlRail = section.querySelector("[data-custom-designer-rail]");
    const identityPanel = section.querySelector(".custom-designer__step--identity");
    const reviewPanel = section.querySelector(".custom-designer__review");
    if (controlRail && identityPanel && reviewPanel) {
      controlRail.append(identityPanel, reviewPanel);
    }
    const clearEphemeralBuilderForm = () => {
      if (!form) return;
      form.setAttribute("autocomplete", "off");
      form.setAttribute("data-form-type", "other");
      form.reset();
      form.dataset.customProofReady = "false";
      form.querySelectorAll("input, textarea").forEach((control) => {
        control.setAttribute("autocomplete", "off");
        control.setAttribute("data-form-type", "other");
        control.setAttribute("autocorrect", "off");
        control.setAttribute("autocapitalize", "off");
        control.spellcheck = false;
        if (
          control instanceof HTMLTextAreaElement ||
          ["text", "search", "email", "tel", "url", "file"].includes(control.type)
        ) {
          control.value = "";
        }
      });
    };
    clearEphemeralBuilderForm();

    window.addEventListener("pagehide", () => {
      clearEphemeralBuilderForm();
      section.hidden = true;
    }, { once: true });
    window.addEventListener("pageshow", (event) => {
      if (!event.persisted) return;
      section.hidden = true;
      window.location.reload();
    }, { once: true });

    const accountReturn = new URLSearchParams(window.location.search).get("exo_account_popup") === "1";
    if (accountReturn && window.opener && !window.opener.closed) {
      window.opener.postMessage({ type: "exo-gameday-account-ready" }, window.location.origin);
      window.setTimeout(() => window.close(), 350);
    }

    const paletteSelect = section.querySelector("[data-custom-palette]");
    const paletteNote = section.querySelector("[data-custom-palette-note]");
    const paletteGroup = section.querySelector("[data-custom-palette-group]");
    const paletteSearch = section.querySelector("[data-custom-palette-search]");
    const paletteInvert = section.querySelector("[data-custom-palette-invert]");
    const paletteOrientationOutput = section.querySelector("[data-custom-palette-orientation]");
    const brandName = section.querySelector("[data-custom-brand-name]");
    const brandApply = section.querySelector("[data-custom-brand-apply]");
    const brandMatchMethod = section.querySelector("[data-custom-brand-match-method]");
    const brandHexInputs = new Map([...section.querySelectorAll("[data-custom-brand-hex]")].map((input) => [input.dataset.customBrandHex, input]));
    const brandRgbInputs = new Map([...section.querySelectorAll("[data-custom-brand-rgb]")].map((input) => [input.dataset.customBrandRgb, input]));
    const brandPantoneInputs = new Map([...section.querySelectorAll("[data-custom-brand-pantone]")].map((input) => [input.dataset.customBrandPantone, input]));
    const colorSelects = [...section.querySelectorAll("[data-custom-color]")];
    const nameInput = section.querySelector("[data-custom-name]");
    const proofName = section.querySelector("[data-custom-proof-name]");
    const textInputs = [...section.querySelectorAll("[data-custom-text-input]")];
    const headerTextInput = section.querySelector("[data-custom-header-text]");
    const liveProofTitle = section.querySelector("[data-custom-live-proof-title]");
    const customProductTitle = section.dataset.customProductTitle || "Custom Gameday Flag";
    const liveProofSize = section.querySelector("[data-custom-live-proof-size]");
    const liveProofPrice = section.querySelector("[data-custom-live-proof-price]");
    const proofFrontCaptions = [...section.querySelectorAll('[data-custom-proof-caption="front"]')];
    const proofBackCaptions = [...section.querySelectorAll('[data-custom-proof-caption="back"]')];
    const constructionCanvases = [...section.querySelectorAll("[data-custom-construction-canvas]")];
    const liveProofPersonalization = section.querySelector("[data-custom-live-personalization]");
    const liveProofPrint = section.querySelector("[data-custom-live-proof-print]");
    const uploads = [...section.querySelectorAll("[data-custom-upload]")];
    const stockDesignButtons = [...section.querySelectorAll("[data-custom-stock-design]")];
    const stockUploadButton = section.querySelector("[data-custom-stock-upload]");
    const stockDesignStatus = section.querySelector("[data-custom-stock-status]");
    const backgroundMotif = section.querySelector("[data-custom-background-motif]");
    const backgroundSurfaceSelects = [...section.querySelectorAll("[data-custom-background-surface]")];
    const backgroundSurfaceBySide = Object.fromEntries(backgroundSurfaceSelects.map((select) => [
      select.dataset.customBackgroundSurface || "front",
      select,
    ]));
    const backgroundSurfaceNotes = [...section.querySelectorAll("[data-custom-background-surface-note]")];
    const backgroundChoiceButtons = [...section.querySelectorAll("[data-custom-background-open]")];
    const backgroundCatalog = section.querySelector("[data-custom-background-catalog]");
    const backgroundCatalogGrid = section.querySelector("[data-custom-background-catalog-grid]");
    const backgroundCatalogCategories = section.querySelector("[data-custom-background-catalog-categories]");
    const backgroundCatalogSearch = section.querySelector("[data-custom-background-catalog-search]");
    const backgroundCatalogSideButtons = [...section.querySelectorAll("[data-custom-background-catalog-side]")];
    const backgroundCatalogCancelButtons = [...section.querySelectorAll("[data-custom-background-catalog-cancel]")];
    const backgroundCatalogApply = section.querySelector("[data-custom-background-catalog-apply]");
    const backgroundCatalogLink = section.querySelector("[data-custom-background-catalog-link]");
    const backgroundCatalogPreview = section.querySelector("[data-custom-background-catalog-preview]");
    const backgroundCatalogName = section.querySelector("[data-custom-background-catalog-name]");
    const backgroundCatalogGroup = section.querySelector("[data-custom-background-catalog-group]");
    const backgroundCatalogDescription = section.querySelector("[data-custom-background-catalog-description]");
    const backgroundCatalogLicense = section.querySelector("[data-custom-background-catalog-license]");
    const backgroundCatalogApplied = section.querySelector("[data-custom-background-catalog-applied]");
    const backgroundCopyFront = section.querySelector("[data-custom-background-copy-front]");
    const backgroundSwap = section.querySelector("[data-custom-background-swap]");
    const rasterSurfaceAssets = {
      "black-diamond-plate": section.dataset.diatreadBlackUrl || "",
      "polished-diamond-plate": section.dataset.diatreadPolishedUrl || "",
      sand: section.dataset.sandSurfaceUrl || "",
      grass: section.dataset.grassSurfaceUrl || "",
      snow: section.dataset.snowSurfaceUrl || "",
      stars: section.dataset.starsSurfaceUrl || "",
    };
    const backgroundLayout = section.querySelector("[data-custom-background-layout]");
    const backgroundScale = section.querySelector("[data-custom-background-scale]");
    const backgroundScaleOutput = section.querySelector("[data-custom-background-scale-output]");
    const backgroundAnchor = section.querySelector("[data-custom-background-anchor]");
    const foregroundSeparation = section.querySelector("[data-custom-foreground-separation]");
    const foregroundBorderColor = section.querySelector("[data-custom-foreground-border-color]");
    const frontArtworkLayout = section.querySelector("[data-custom-front-art-layout]");
    const frontArtworkScale = section.querySelector("[data-custom-front-art-scale]");
    const frontArtworkScaleOutput = section.querySelector("[data-custom-front-art-scale-output]");
    const frontArtworkAnchor = section.querySelector("[data-custom-front-art-anchor]");
    const frontArtworkBackTexture = section.querySelector("[data-custom-front-art-back-texture]");
    const projectSaveButton = section.querySelector("[data-custom-project-save]");
    const projectListButton = section.querySelector("[data-custom-project-list]");
    const projectStatus = section.querySelector("[data-custom-project-status]");
    const accountOpenButton = section.querySelector("[data-custom-account-open]");
    const accountDialog = section.querySelector("[data-custom-account-dialog]");
    const accountCloseButton = section.querySelector("[data-custom-account-close]");
    const accountLaunchButton = section.querySelector("[data-custom-account-launch]");
    const accountSaveButton = section.querySelector("[data-custom-account-save]");
    const accountStatus = section.querySelector("[data-custom-account-status]");
    const mirror = section.querySelector("[data-custom-mirror]");
    const rights = section.querySelector("[data-custom-rights]");
    const batch = section.querySelector("[data-custom-batch]");
    const submit = section.querySelector("[data-custom-submit]");
    const proofFileInputs = {
      combined: section.querySelector('[data-custom-proof-file="combined"]'),
      front: section.querySelector('[data-custom-proof-file="front"]'),
      back: section.querySelector('[data-custom-proof-file="back"]'),
    };
    const proofCaptureStatus = section.querySelector("[data-custom-proof-capture-status]");
    const variantInput = section.querySelector("[data-custom-variant-input]");
    const sizeButtons = [...section.querySelectorAll("[data-custom-size]")];
    const sideButtons = [...section.querySelectorAll("[data-custom-side]")];
    const stages = [...section.querySelectorAll("[data-custom-stage]")];
    const stage = section.querySelector('[data-custom-stage="main"]');
    const configuratorProofStack = section.querySelector('[data-custom-proof-face-stack="configurator"]');
    const configuratorProofFaces = [...section.querySelectorAll("[data-custom-focus-card]")];
    const geometryPaths = [...section.querySelectorAll("[data-custom-geometry-path], [data-custom-geometry-clip]")];
    const geometryOutlines = [...section.querySelectorAll("[data-custom-geometry-outline]")];
    const geometryHeaders = [...section.querySelectorAll("[data-custom-geometry-header]")];
    const geometryHeaderSeams = [...section.querySelectorAll("[data-custom-geometry-header-seam]")];
    const sizeOutputs = [...section.querySelectorAll("[data-custom-size-output]")];
    const orderIdOutputs = [
      ...section.querySelectorAll("[data-custom-order-id], [data-custom-preview-id]"),
    ];
    const orderSizeOutput = section.querySelector("[data-custom-order-size]");
    const orderSkuOutputs = [
      ...section.querySelectorAll("[data-custom-order-sku], [data-custom-preview-sku]"),
    ];
    const orderPriceOutput = section.querySelector("[data-custom-order-price]");
    const fontSelect = section.querySelector("[data-custom-font]");
    const fontUpload = section.querySelector("[data-custom-font-upload]");
    const fontUploadStatus = section.querySelector("[data-custom-font-upload-status]");
    const fontRights = section.querySelector("[data-custom-font-rights]");
    const fontRightsWrap = section.querySelector("[data-custom-font-rights-wrap]");
    const fontSample = section.querySelector("[data-custom-font-sample]");
    const orderFontOutput = section.querySelector("[data-custom-order-font]");
    const productAvailable = section.dataset.productAvailable === "true";
    const defaultPaletteId = section.dataset.defaultPaletteId || "gameday-lime";
    const propertyInputs = new Map(
      [...section.querySelectorAll("[data-custom-property]")].map((input) => [
        input.dataset.customProperty,
        input,
      ]),
    );
    const proPreview=['/products/custom-gameday-flag','/products/custom-gameday-mvp-flagpole-kit'].includes(location.pathname);let proPhotos=null;const proHeaderStyles=new WeakMap();
    const artworkUrls = { front: "", back: "" };
    const artworkDataUrls = { front: "", back: "" };
    const artworkFileNames = { front: "", back: "" };
    const artworkReadPromises = {
      front: Promise.resolve(),
      back: Promise.resolve(),
    };
    const stockAssets = new Map(stockDesignButtons.map((button) => [
      button.dataset.stockDesignId,
      button.dataset.stockDesignUrl,
    ]));
    const placementInputs = [...section.querySelectorAll("[data-custom-placement]")];
    const placementOutputs = new Map(
      [...section.querySelectorAll("[data-custom-placement-output]")].map((output) => [
        output.dataset.customPlacementOutput,
        output,
      ]),
    );
    // Normalized from the closed inner extents in the authored OMAX DXF.
    // Source SHA256: 9FD9FF44C98BD14329A1E77D1557F12D323FF76ACEFD27B70EA4378DBBE677D9
    const dxfArtworkBounds = Object.freeze({
      "12x17": { left: 0.285658, right: 0.047543, top: 0.083333, bottom: 0.083333 },
      "3x5": { left: 0.14475, right: 0.032136, top: 0.058824, bottom: 0.058824 },
      "4x6": { left: 0.157111, right: 0.03925, top: 0.065217, bottom: 0.065217 },
      "5x8": { left: 0.165659, right: 0.044151, top: 0.068966, bottom: 0.068966 },
    });
    const approvedProofFrame = Object.freeze(
      window.EXOGamedayFlagProofPresentation?.frame || {
        x: 32,
        y: 14,
        width: 954,
        height: 972,
        extension: 24,
      },
    );
    const approvedGeometryForSize = (size) => {
      const perimeter = window.EXOGamedayFlagPerimeters?.perimeters?.[size];
      const presentation = window.EXOGamedayFlagProofPresentation?.sizes?.[size];
      return perimeter && presentation ? { ...perimeter, ...presentation } : null;
    };
    // Keep the authored vertical clearance, but balance the horizontal field
    // between the sewn header and the tail. The DXF maximum bounds include
    // asymmetric construction clearance, which made centered customer art read
    // visibly tail-heavy in the storefront preview.
    const centeredArtworkBounds = (size) => {
      const geometry = approvedGeometryForSize(size);
      const authoredBounds = dxfArtworkBounds[size] || {
        left: geometry?.safeLeft || 0.1,
        right: geometry?.safeRight || 0.1,
        top: 0.14,
        bottom: 0.14,
      };
      const headerWidth = geometry?.headerWidth || 0;
      const edgeClearance = Math.max(0, Math.min(0.08, authoredBounds.right));
      return {
        left: headerWidth + edgeClearance,
        right: edgeClearance,
        top: authoredBounds.top,
        bottom: authoredBounds.bottom,
      };
    };
    const flagPhysicalHeightsInches = Object.freeze({
      "12x17": 12,
      "3x5": 36,
      "4x6": 48,
      "5x8": 60,
    });
    const defaultLetterHeightsInches = Object.freeze({
      "12x17": 2,
      "3x5": 6,
      "4x6": 8,
      "5x8": 10,
    });
    let proofCapturePending = false;
    let fontUploadPending = false;
    let customFontFamily = "";
    let customFontDataUrl = "";
    let customFontFileName = "";
    let customFontFace = null;
    let fontReadPromise = Promise.resolve();
    const fontAssetDataUrls = new Map();
    const surfaceAssetDataUrls = new Map();
    const spacedRepeatMaskAssets = new Map();
    const repeatLogoGapRatio = 1;
    let palettes = [...section.querySelectorAll("[data-palette-record]")].map((record) => ({
      id: record.dataset.id,
      name: record.dataset.name,
      group: "Gameday",
      status: record.dataset.status,
      colors: [...record.querySelectorAll("[data-palette-color]")].map((color) => ({
        name: color.dataset.name || "Color",
        hex: color.dataset.hex || "#383838",
        pantone: color.dataset.pantone || "",
      })),
    }));
    let backgroundSurfaces = [{ id: "solid", name: "Solid color", group: "Color", kind: "solid", colors: [] }];
    let backgroundCatalogSide = "front";
    let backgroundCatalogCategory = "All";
    let backgroundCatalogSnapshot = null;
    let paletteInverted = false;
    let activePaletteId = "";

    const normalizeCustomHex = (value, fallback = "#383838") => {
      const normalized = String(value || "").trim().replace(/^#/, "").toUpperCase();
      return /^[0-9A-F]{6}$/.test(normalized) ? `#${normalized}` : fallback;
    };
    const customHexToRgb = (hex) => {
      const value = Number.parseInt(normalizeCustomHex(hex).slice(1), 16);
      return `${(value >> 16) & 255}, ${(value >> 8) & 255}, ${value & 255}`;
    };
    const customRgbToHex = (value, fallback = "#383838") => {
      const parts = String(value || "").match(/\d+(?:\.\d+)?/g)?.slice(0, 3).map(Number) || [];
      if (parts.length !== 3 || parts.some((part) => !Number.isFinite(part))) return fallback;
      return `#${parts.map((part) => Math.max(0, Math.min(255, Math.round(part))).toString(16).padStart(2, "0")).join("")}`.toUpperCase();
    };

    const constructionSourceCache = new Map();
    const constructionRenderCache = new Map();
    let constructionRenderVersion = 0;
    const smoothstep = (edge0, edge1, value) => {
      const scaled = Math.max(0, Math.min(1, (value - edge0) / (edge1 - edge0)));
      return scaled * scaled * (3 - 2 * scaled);
    };
    const srgbToLinear = (value) => {
      const normalized = value / 255;
      return normalized <= 0.04045
        ? normalized / 12.92
        : ((normalized + 0.055) / 1.055) ** 2.4;
    };
    const linearToSrgb = (value) => {
      const normalized = Math.max(0, Math.min(1, value));
      return Math.round(255 * (normalized <= 0.0031308
        ? normalized * 12.92
        : 1.055 * normalized ** (1 / 2.4) - 0.055));
    };
    const constructionColor = (hex) => {
      const value = Number.parseInt(normalizeCustomHex(hex).slice(1), 16);
      return [(value >> 16) & 255, (value >> 8) & 255, value & 255];
    };
    const constructionSourceImage = (url) => {
      if (!url) return Promise.reject(new Error("The approved construction source is unavailable."));
      if (!constructionSourceCache.has(url)) {
        constructionSourceCache.set(url, new Promise((resolve, reject) => {
          const image = new Image();
          image.crossOrigin = "anonymous";
          image.onload = () => resolve(image);
          image.onerror = () => reject(new Error("The approved construction source could not be loaded."));
          image.src = url;
        }));
      }
      return constructionSourceCache.get(url);
    };
    const recoloredConstruction = async (zone, headerHex, fieldHex) => {
      const canvas = constructionCanvases.find((candidate) => candidate.dataset.customConstructionCanvas === zone);
      const sourceImage = canvas?.closest("[data-custom-construction-media]")?.querySelector(".custom-live-proof__construction-source");
      const sourceUrl = sourceImage?.currentSrc || sourceImage?.src || "";
      const cacheKey = `${zone}|${sourceUrl}|${normalizeCustomHex(headerHex)}|${normalizeCustomHex(fieldHex)}`;
      if (constructionRenderCache.has(cacheKey)) return constructionRenderCache.get(cacheKey);
      const renderPromise = (async () => {
        const image = await constructionSourceImage(sourceUrl);
        const output = document.createElement("canvas");
        output.width = 720;
        output.height = 540;
        const context = output.getContext("2d", { willReadFrequently: true });
        if (!context) throw new Error("The approved construction renderer is unavailable.");
        context.drawImage(image, 0, 0, output.width, output.height);
        const frame = context.getImageData(0, 0, output.width, output.height);
        const pixels = frame.data;
        const headerTarget = constructionColor(headerHex).map(srgbToLinear);
        const fieldTarget = constructionColor(fieldHex).map(srgbToLinear);
        const headerSourceLuminance = 0.2126 * srgbToLinear(0x69) + 0.7152 * srgbToLinear(0xBE) + 0.0722 * srgbToLinear(0x28);
        const fieldSourceLuminance = 0.2126 * srgbToLinear(0x00) + 0.7152 * srgbToLinear(0x2A) + 0.0722 * srgbToLinear(0x5C);
        for (let index = 0; index < pixels.length; index += 4) {
          const red = pixels[index] / 255;
          const green = pixels[index + 1] / 255;
          const blue = pixels[index + 2] / 255;
          const maximum = Math.max(red, green, blue);
          const minimum = Math.min(red, green, blue);
          const saturation = maximum > 0 ? (maximum - minimum) / maximum : 0;
          const headerWeight = smoothstep(0.015, 0.105, green - Math.max(red, blue)) * smoothstep(0.16, 0.52, saturation);
          const fieldWeight = smoothstep(0.006, 0.070, blue - Math.max(red, green)) * smoothstep(0.10, 0.45, saturation);
          const weight = Math.max(headerWeight, fieldWeight);
          if (weight < 0.01) continue;
          const sourceLinear = [
            srgbToLinear(pixels[index]),
            srgbToLinear(pixels[index + 1]),
            srgbToLinear(pixels[index + 2]),
          ];
          const sourceLuminance = 0.2126 * sourceLinear[0] + 0.7152 * sourceLinear[1] + 0.0722 * sourceLinear[2];
          const target = headerWeight >= fieldWeight ? headerTarget : fieldTarget;
          const referenceLuminance = headerWeight >= fieldWeight ? headerSourceLuminance : fieldSourceLuminance;
          const intensity = Math.max(0.48, Math.min(1.52, sourceLuminance / Math.max(referenceLuminance, 0.001)));
          const specular = Math.max(0, intensity - 1.02) * 0.10;
          for (let channel = 0; channel < 3; channel += 1) {
            const tinted = Math.max(0, Math.min(1, target[channel] * intensity + specular * (1 - target[channel])));
            const blended = sourceLinear[channel] * (1 - weight) + tinted * weight;
            pixels[index + channel] = linearToSrgb(blended);
          }
        }
        context.putImageData(frame, 0, 0);
        return output;
      })();
      constructionRenderCache.set(cacheKey, renderPromise);
      return renderPromise;
    };
    const renderConstructionProof = async (headerHex, fieldHex) => {
      if (!constructionCanvases.length) return;
      const version = ++constructionRenderVersion;
      try {
        const rendered = await Promise.all(["top", "underside"].map((zone) =>
          recoloredConstruction(zone, headerHex, fieldHex)));
        if (version !== constructionRenderVersion) return;
        constructionCanvases.forEach((canvas, index) => {
          const context = canvas.getContext("2d");
          if (!context) return;
          context.clearRect(0, 0, canvas.width, canvas.height);
          context.drawImage(rendered[index], 0, 0, canvas.width, canvas.height);
          canvas.closest("[data-custom-construction-media]")?.classList.add("is-ready");
        });
      } catch (error) {
        console.warn("The approved construction proof could not be recolored.", error);
      }
    };

    const surfaceHash = (value) => {
      let hash = 2166136261;
      [...String(value || "surface")].forEach((character) => {
        hash ^= character.charCodeAt(0);
        hash = Math.imul(hash, 16777619);
      });
      return hash >>> 0;
    };

    const surfaceRandom = (seed) => {
      let state = seed >>> 0;
      return () => {
        state += 0x6d2b79f5;
        let value = state;
        value = Math.imul(value ^ (value >>> 15), value | 1);
        value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
        return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
      };
    };

    const surfaceBlobPath = (random, cx, cy, radiusX, radiusY, points = 9, rotation = 0) => {
      const vertices = Array.from({ length: points }, (_, index) => {
        const angle = rotation + (Math.PI * 2 * index) / points;
        const variance = 0.7 + random() * 0.55;
        return [
          cx + Math.cos(angle) * radiusX * variance,
          cy + Math.sin(angle) * radiusY * variance,
        ];
      });
      const midpoint = (left, right) => [
        (left[0] + right[0]) / 2,
        (left[1] + right[1]) / 2,
      ];
      const first = midpoint(vertices[vertices.length - 1], vertices[0]);
      return [
        `M${first[0].toFixed(1)} ${first[1].toFixed(1)}`,
        ...vertices.map((vertex, index) => {
          const next = vertices[(index + 1) % vertices.length];
          const end = midpoint(vertex, next);
          return `Q${vertex[0].toFixed(1)} ${vertex[1].toFixed(1)} ${end[0].toFixed(1)} ${end[1].toFixed(1)}`;
        }),
        "Z",
      ].join("");
    };

    const proceduralCamouflage = (surface, colors) => {
      const [a, b, c, d] = colors;
      const random = surfaceRandom(surfaceHash(surface.id));
      const canvasWidth = 900;
      const canvasHeight = 600;
      const colorAt = (index) => colors[index % colors.length];
      const blobs = ({ count, minRadius, maxRadius, stretched = false, paletteOffset = 1, opacity = 1 }) =>
        Array.from({ length: count }, (_, index) => {
          const radiusX = minRadius + random() * (maxRadius - minRadius);
          const radiusY = radiusX * (stretched ? 0.25 + random() * 0.35 : 0.55 + random() * 0.55);
          return `<path d="${surfaceBlobPath(
            random,
            random() * canvasWidth,
            random() * canvasHeight,
            radiusX,
            radiusY,
            7 + Math.floor(random() * 5),
            random() * Math.PI,
          )}" fill="${colorAt(index + paletteOffset)}" opacity="${opacity}"/>`;
        }).join("");

      const generators = {
        woodland: () => `<rect width="900" height="600" fill="${a}"/>
          <g>${blobs({ count: 34, minRadius: 58, maxRadius: 165, stretched: true })}</g>
          <g opacity=".94">${blobs({ count: 52, minRadius: 13, maxRadius: 45, stretched: true, paletteOffset: 2 })}</g>`,
        fleck: () => `<rect width="900" height="600" fill="${a}"/>
          <g>${blobs({ count: 22, minRadius: 70, maxRadius: 170, stretched: true })}</g>
          <g>${Array.from({ length: 145 }, (_, index) => {
            const width = 5 + random() * 22;
            const height = 3 + random() * 11;
            return `<ellipse cx="${(random() * canvasWidth).toFixed(1)}" cy="${(random() * canvasHeight).toFixed(1)}" rx="${width.toFixed(1)}" ry="${height.toFixed(1)}" fill="${colorAt(index + 2)}" transform="rotate(${(-35 + random() * 70).toFixed(1)} ${(random() * canvasWidth).toFixed(1)} ${(random() * canvasHeight).toFixed(1)})"/>`;
          }).join("")}</g>`,
        digital: () => {
          const pixel = 18;
          const clusters = Array.from({ length: 68 }, (_, index) => {
            const startX = Math.floor((random() * canvasWidth) / pixel) * pixel;
            const startY = Math.floor((random() * canvasHeight) / pixel) * pixel;
            const cells = 3 + Math.floor(random() * 9);
            let x = startX;
            let y = startY;
            return Array.from({ length: cells }, () => {
              const width = pixel * (1 + Math.floor(random() * 4));
              const height = pixel * (1 + Math.floor(random() * 3));
              const rectangle = `<rect x="${x}" y="${y}" width="${width}" height="${height}" fill="${colorAt(index + 1)}"/>`;
              x += (Math.floor(random() * 3) - 1) * pixel;
              y += (Math.floor(random() * 3) - 1) * pixel;
              return rectangle;
            }).join("");
          }).join("");
          return `<rect width="900" height="600" fill="${a}"/><g shape-rendering="crispEdges">${clusters}</g>`;
        },
        tiger: () => `<rect width="900" height="600" fill="${c}"/>
          <g opacity=".58">${blobs({ count: 18, minRadius: 80, maxRadius: 230, stretched: true, paletteOffset: 1 })}</g>
          <g fill="none" stroke="${a}" stroke-linecap="round">${Array.from({ length: 26 }, (_, index) => {
            const y = -30 + index * 28 + random() * 26;
            const x = -120 + random() * 220;
            const wave = 60 + random() * 150;
            return `<path d="M${x.toFixed(1)} ${y.toFixed(1)} C${(x + 180).toFixed(1)} ${(y - wave).toFixed(1)}, ${(x + 410).toFixed(1)} ${(y + wave).toFixed(1)}, ${(x + 610).toFixed(1)} ${y.toFixed(1)} S${(x + 850).toFixed(1)} ${(y - wave * 0.7).toFixed(1)}, ${(x + 1100).toFixed(1)} ${(y + random() * 40 - 20).toFixed(1)}" stroke-width="${(9 + random() * 24).toFixed(1)}"/>`;
          }).join("")}</g>
          <g fill="none" stroke="${d}" stroke-linecap="round" opacity=".38">${Array.from({ length: 12 }, (_, index) => `<path d="M${(-80 + random() * 160).toFixed(1)} ${(index * 52 + random() * 30).toFixed(1)} C250 ${(index * 52 - 45).toFixed(1)}, 620 ${(index * 52 + 60).toFixed(1)}, 980 ${(index * 52 + random() * 35).toFixed(1)}" stroke-width="${(3 + random() * 8).toFixed(1)}"/>`).join("")}</g>`,
        marsh: () => `<rect width="900" height="600" fill="${a}"/>
          <g opacity=".9">${blobs({ count: 26, minRadius: 70, maxRadius: 200, stretched: true })}</g>
          <g fill="none" stroke-linecap="round">${Array.from({ length: 105 }, (_, index) => {
            const x = random() * canvasWidth;
            const baseY = 480 + random() * 150;
            const topY = baseY - 80 - random() * 360;
            const bend = -30 + random() * 60;
            return `<path d="M${x.toFixed(1)} ${baseY.toFixed(1)} Q${(x + bend).toFixed(1)} ${((baseY + topY) / 2).toFixed(1)} ${(x + bend * 0.55).toFixed(1)} ${topY.toFixed(1)}" stroke="${colorAt(index + 1)}" stroke-width="${(2 + random() * 9).toFixed(1)}" opacity="${(0.48 + random() * 0.46).toFixed(2)}"/>`;
          }).join("")}</g>`,
        terrain: () => `<rect width="900" height="600" fill="${a}"/>
          <g>${blobs({ count: 38, minRadius: 45, maxRadius: 155, stretched: true })}</g>
          <g fill="none" stroke="${d}" stroke-width="3" opacity=".24">${Array.from({ length: 20 }, (_, index) => {
            const y = 15 + index * 31 + random() * 18;
            return `<path d="M-40 ${y.toFixed(1)} C180 ${(y - 75).toFixed(1)}, 350 ${(y + 70).toFixed(1)}, 540 ${(y - 20).toFixed(1)} S780 ${(y + 80).toFixed(1)}, 940 ${(y - 15).toFixed(1)}"/>`;
          }).join("")}</g>`,
        branch: () => `<rect width="900" height="600" fill="${a}"/>
          <g opacity=".68">${blobs({ count: 28, minRadius: 38, maxRadius: 135, stretched: true, paletteOffset: 1 })}</g>
          <g fill="none" stroke="${d}" stroke-linecap="round">${Array.from({ length: 18 }, (_, index) => {
            const startX = -60 + random() * 960;
            const startY = -80 + random() * 760;
            const endX = startX + 140 + random() * 330;
            const endY = startY - 70 + random() * 140;
            const twigs = Array.from({ length: 4 }, (_, twig) => {
              const ratio = 0.22 + twig * 0.17;
              const x = startX + (endX - startX) * ratio;
              const y = startY + (endY - startY) * ratio;
              const direction = twig % 2 ? -1 : 1;
              return `<path d="M${x.toFixed(1)} ${y.toFixed(1)} l${(direction * (28 + random() * 55)).toFixed(1)} ${(-35 - random() * 75).toFixed(1)}" stroke-width="${(3 + random() * 5).toFixed(1)}"/>`;
            }).join("");
            return `<path d="M${startX.toFixed(1)} ${startY.toFixed(1)} Q${((startX + endX) / 2).toFixed(1)} ${(startY - 80 + random() * 160).toFixed(1)} ${endX.toFixed(1)} ${endY.toFixed(1)}" stroke-width="${(6 + random() * 11).toFixed(1)}"/>${twigs}`;
          }).join("")}</g>`,
        macro: () => `<rect width="900" height="600" fill="${a}"/>
          <g opacity=".98">${blobs({ count: 17, minRadius: 125, maxRadius: 310, stretched: true, paletteOffset: 1 })}</g>
          <g opacity=".82">${blobs({ count: 31, minRadius: 20, maxRadius: 68, stretched: true, paletteOffset: 2 })}</g>
          <g>${Array.from({ length: 92 }, (_, index) => {
            const width = 2 + random() * 12;
            const height = 1 + random() * 5;
            const x = random() * canvasWidth;
            const y = random() * canvasHeight;
            return `<ellipse cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" rx="${width.toFixed(1)}" ry="${height.toFixed(1)}" fill="${colorAt(index + 3)}" opacity="${(0.16 + random() * 0.3).toFixed(2)}" transform="rotate(${(-38 + random() * 76).toFixed(1)} ${x.toFixed(1)} ${y.toFixed(1)})"/>`;
          }).join("")}</g>`,
        mesh: () => `<rect width="900" height="600" fill="${a}"/>
          <g>${blobs({ count: 20, minRadius: 105, maxRadius: 245, stretched: true, paletteOffset: 1 })}</g>
          <g opacity=".75">${blobs({ count: 35, minRadius: 18, maxRadius: 64, stretched: true, paletteOffset: 2 })}</g>
          <g fill="none" stroke="${d}" opacity=".2" stroke-width="3">${Array.from({ length: 18 }, (_, index) => {
            const y = -120 + index * 46;
            return `<path d="M-80 ${y} L980 ${y + 430}"/><path d="M-80 ${y + 430} L980 ${y}"/>`;
          }).join("")}</g>
          <g fill="none" stroke="${b}" opacity=".35" stroke-width="2">${Array.from({ length: 13 }, (_, index) => {
            const y = index * 52 + 8;
            return `<path d="M-20 ${y} C180 ${y - 85}, 355 ${y + 88}, 540 ${y - 12} S770 ${y + 75}, 930 ${y - 18}"/>`;
          }).join("")}</g>`,
      };
      const content = (generators[surface.kind] || generators.woodland)();
      return `${content}<defs><filter id="cloth"><feTurbulence type="fractalNoise" baseFrequency=".42 .8" numOctaves="2" seed="${surfaceHash(surface.id) % 97}"/><feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 .1 0"/></filter><pattern id="weave" width="5" height="5" patternUnits="userSpaceOnUse"><path d="M0 1h5M1 0v5" stroke="#fff" stroke-width=".45" opacity=".16"/></pattern></defs><rect width="900" height="600" filter="url(#cloth)" opacity=".34"/><rect width="900" height="600" fill="url(#weave)" opacity=".26"/>`;
    };

    const surfaceSvgDataUrl = (surface) => {
      if(surface?.kind === "pro-photo")return surface.dataUrl;
      if (!surface || surface.kind === "solid") return "";
      if (["material", "photographic"].includes(surface.kind)) return rasterSurfaceAssets[surface.id] || "";
      const [a = "#101010", b = "#383838", c = "#777777", d = "#FFFFFF"] = surface.colors || [];
      const shapes = {
        brushed: `<defs><linearGradient id="bg" x1="0" y1="0" x2="1" y2="0"><stop stop-color="${a}"/><stop offset=".22" stop-color="${d}"/><stop offset=".48" stop-color="${b}"/><stop offset=".75" stop-color="${c}"/><stop offset="1" stop-color="${a}"/></linearGradient><filter id="n"><feTurbulence baseFrequency=".005 .65" numOctaves="2" seed="13"/><feColorMatrix values=".22 0 0 0 .45 .22 0 0 0 .45 .22 0 0 0 .45 0 0 0 .26 0"/></filter></defs><rect width="600" height="400" fill="url(#bg)"/><rect width="600" height="400" filter="url(#n)" opacity=".52"/>`,
        corten: `<defs><radialGradient id="r"><stop stop-color="${d}"/><stop offset=".42" stop-color="${c}"/><stop offset="1" stop-color="${a}"/></radialGradient><filter id="n"><feTurbulence baseFrequency=".012" numOctaves="4" seed="21"/><feColorMatrix values=".7 0 0 0 .2 .28 0 0 0 .06 .12 0 0 0 .01 0 0 0 .8 0"/></filter></defs><rect width="600" height="400" fill="${b}"/><rect width="600" height="400" fill="url(#r)" opacity=".76"/><rect width="600" height="400" filter="url(#n)" opacity=".72"/>`,
        spangle: `<defs><filter id="n"><feTurbulence type="fractalNoise" baseFrequency=".028" numOctaves="3" seed="37"/><feColorMatrix values=".8 0 0 0 .15 .8 0 0 0 .15 .8 0 0 0 .15 0 0 0 .55 0"/></filter><linearGradient id="g"><stop stop-color="${a}"/><stop offset=".48" stop-color="${d}"/><stop offset="1" stop-color="${b}"/></linearGradient></defs><rect width="600" height="400" fill="url(#g)"/><rect width="600" height="400" filter="url(#n)" opacity=".56"/><g fill="none" stroke="${c}" opacity=".32">${Array.from({ length: 24 }, (_, i) => `<path d="M${(i * 83) % 640} -20l${42 + (i % 4) * 11} 80-56 74-61-82z"/>`).join("")}</g>`,
        hotrolled: `<defs><filter id="n"><feTurbulence baseFrequency=".015 .09" numOctaves="4" seed="17"/><feColorMatrix values=".35 0 0 0 .08 .35 0 0 0 .08 .35 0 0 0 .08 0 0 0 .62 0"/></filter><linearGradient id="g" x2="0" y2="1"><stop stop-color="${c}"/><stop offset=".45" stop-color="${a}"/><stop offset="1" stop-color="${b}"/></linearGradient></defs><rect width="600" height="400" fill="url(#g)"/><rect width="600" height="400" filter="url(#n)" opacity=".74"/>`,
        blackoxide: `<defs><radialGradient id="g"><stop stop-color="${c}"/><stop offset=".52" stop-color="${b}"/><stop offset="1" stop-color="${a}"/></radialGradient><filter id="n"><feTurbulence baseFrequency=".09" numOctaves="3" seed="9"/><feColorMatrix values=".18 0 0 0 .03 .18 0 0 0 .03 .18 0 0 0 .03 0 0 0 .35 0"/></filter></defs><rect width="600" height="400" fill="url(#g)"/><rect width="600" height="400" filter="url(#n)" opacity=".58"/>`,
        weave: `<defs><pattern id="w" width="16" height="16" patternUnits="userSpaceOnUse"><rect width="16" height="16" fill="${a}"/><path d="M0 3h16M0 11h16" stroke="${c}" stroke-width="4" opacity=".7"/><path d="M3 0v16M11 0v16" stroke="${b}" stroke-width="4" opacity=".86"/><path d="M0 1h16M1 0v16" stroke="${d}" stroke-width=".6" opacity=".24"/></pattern></defs><rect width="600" height="400" fill="url(#w)"/>`,
        ripstop: `<defs><pattern id="r" width="42" height="42" patternUnits="userSpaceOnUse"><rect width="42" height="42" fill="${a}"/><path d="M0 0h42v42H0z" fill="none" stroke="${c}" stroke-width="2" opacity=".7"/><path d="M0 7h42M7 0v42" stroke="${b}" stroke-width=".7" opacity=".55"/></pattern><filter id="n"><feTurbulence baseFrequency=".55" numOctaves="1" seed="19"/></filter></defs><rect width="600" height="400" fill="url(#r)"/><rect width="600" height="400" filter="url(#n)" opacity=".08"/>`,
        gravel: `<rect width="600" height="400" fill="${a}"/><g>${Array.from({ length: 180 }, (_, i) => `<ellipse cx="${(i * 83) % 620}" cy="${(i * 47) % 420}" rx="${7 + (i % 9)}" ry="${5 + (i % 6)}" fill="${[b, c, d][i % 3]}" opacity="${.42 + (i % 4) * .12}" transform="rotate(${(i * 29) % 180} ${(i * 83) % 620} ${(i * 47) % 420})"/>`).join("")}</g>`,
        dirt: `<defs><filter id="n"><feTurbulence baseFrequency=".045" numOctaves="5" seed="31"/><feColorMatrix values=".5 0 0 0 .18 .25 0 0 0 .07 .12 0 0 0 .02 0 0 0 .7 0"/></filter></defs><rect width="600" height="400" fill="${b}"/><rect width="600" height="400" filter="url(#n)" opacity=".82"/>`,
        water: `<defs><linearGradient id="g" x2="0" y2="1"><stop stop-color="${d}"/><stop offset=".45" stop-color="${c}"/><stop offset="1" stop-color="${a}"/></linearGradient></defs><rect width="600" height="400" fill="url(#g)"/><g fill="none" stroke="${d}" opacity=".42">${Array.from({ length: 22 }, (_, i) => `<path d="M-40 ${i * 20 + 4}q80 -16 160 0t160 0t160 0t160 0t160 0" stroke-width="${1 + i % 3}"/>`).join("")}</g>`,
        cloud: `<defs><filter id="n"><feTurbulence type="fractalNoise" baseFrequency=".008" numOctaves="5" seed="43"/><feColorMatrix values=".75 0 0 0 .15 .75 0 0 0 .15 .8 0 0 0 .18 0 0 0 .82 0"/></filter><linearGradient id="g" x2="0" y2="1"><stop stop-color="${d}"/><stop offset="1" stop-color="${a}"/></linearGradient></defs><rect width="600" height="400" fill="url(#g)"/><rect width="600" height="400" filter="url(#n)" opacity=".7"/>`,
        forestfloor: `<rect width="600" height="400" fill="${a}"/><g>${Array.from({ length: 95 }, (_, i) => `<path d="M${(i * 71) % 620} ${(i * 113) % 420}q${18 + i % 24} ${-18 - i % 35} ${38 + i % 45} ${3 + i % 17}q-24 20-38-3z" fill="${[b, c, d][i % 3]}" opacity="${.36 + (i % 5) * .11}" transform="rotate(${(i * 41) % 360} ${(i * 71) % 620} ${(i * 113) % 420})"/>`).join("")}</g>`,
        bark: `<rect width="600" height="400" fill="${a}"/><g fill="none" stroke-linecap="round">${Array.from({ length: 46 }, (_, i) => `<path d="M${i * 14 - 20} -10q${-20 + i % 37} 85 ${5 - i % 23} 165t${-8 + i % 19} 245" stroke="${[b, c, d][i % 3]}" stroke-width="${2 + i % 8}" opacity=".64"/>`).join("")}</g>`,
        ice: `<defs><linearGradient id="g"><stop stop-color="${d}"/><stop offset=".52" stop-color="${b}"/><stop offset="1" stop-color="${a}"/></linearGradient></defs><rect width="600" height="400" fill="url(#g)"/><g fill="none" stroke="${c}" opacity=".48">${Array.from({ length: 24 }, (_, i) => `<path d="M${(i * 79) % 620} ${(i * 47) % 420}l${45 + i % 70} ${-55 + i % 100} ${36 - i % 52} ${62 - i % 91}"/>`).join("")}</g>`,
        topographic: `<rect width="600" height="400" fill="${a}"/><g fill="none" stroke="${c}" stroke-width="2" opacity=".7">${Array.from({ length: 16 }, (_, i) => `<path d="M-40 ${i * 29}c120 ${-70 + i * 8} 210 ${70 - i * 5} 320 0s230 ${55 - i * 4} 360-10"/>`).join("")}</g>`,
        halftone: `<defs><pattern id="p" width="26" height="26" patternUnits="userSpaceOnUse"><rect width="26" height="26" fill="${a}"/><circle cx="7" cy="7" r="5" fill="${c}"/><circle cx="20" cy="20" r="8" fill="${b}"/></pattern></defs><rect width="600" height="400" fill="url(#p)"/>`,
        honeycomb: `<defs><pattern id="p" width="42" height="36" patternUnits="userSpaceOnUse"><rect width="42" height="36" fill="${a}"/><path d="M10 1h21l10 17-10 17H10L0 18z" fill="none" stroke="${c}" stroke-width="3"/></pattern></defs><rect width="600" height="400" fill="url(#p)"/>`,
        technicalgrid: `<defs><pattern id="p" width="48" height="48" patternUnits="userSpaceOnUse"><rect width="48" height="48" fill="${a}"/><path d="M0 0h48v48H0zM24 0v48M0 24h48" fill="none" stroke="${c}" stroke-width="1" opacity=".58"/></pattern></defs><rect width="600" height="400" fill="url(#p)"/>`,
        contourwaves: `<rect width="600" height="400" fill="${a}"/><g fill="none" stroke="${c}" stroke-width="8" opacity=".72">${Array.from({ length: 13 }, (_, i) => `<path d="M-80 ${i * 38}q130 -65 260 0t260 0t260 0"/>`).join("")}</g>`,
      };
      const content = shapes[surface.kind] || proceduralCamouflage(surface, [a, b, c, d]);
      const dimensions = shapes[surface.kind]
        ? 'width="600" height="400" viewBox="0 0 600 400"'
        : 'width="900" height="600" viewBox="0 0 900 600"';
      const svg = `<svg xmlns="http://www.w3.org/2000/svg" ${dimensions} preserveAspectRatio="xMidYMid slice">${content}</svg>`;
      return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
    };

    const selectedSizeButton = () =>
      sizeButtons.find((button) => button.classList.contains("is-active"));

    const selectedFlagWidthInches = () =>
      Math.max(1, Number(selectedSizeButton()?.dataset.customWidthIn) || 17);

    const materialTilePixels = (surfaceLayer, surface) => {
      const physicalTileWidthInches = Math.max(
        1,
        Number(surface?.physicalTileWidthInches) || 56,
      );
      const renderedFlagWidthPixels = Math.max(
        1,
        surfaceLayer.getBoundingClientRect().width ||
          surfaceLayer.parentElement?.getBoundingClientRect().width ||
          1,
      );
      return renderedFlagWidthPixels *
        (physicalTileWidthInches / selectedFlagWidthInches());
    };

    const buildConfigurationId = () => {
      const now = new Date();
      const date = [
        now.getFullYear(),
        String(now.getMonth() + 1).padStart(2, "0"),
        String(now.getDate()).padStart(2, "0"),
      ].join("");
      const bytes = new Uint8Array(3);
      let token = "";
      if (window.crypto?.getRandomValues) {
        window.crypto.getRandomValues(bytes);
        token = [...bytes]
          .map((value) => value.toString(16).padStart(2, "0"))
          .join("")
          .toUpperCase();
      }
      if (!token) token = Math.random().toString(36).slice(2, 8).toUpperCase();
      return `CGF-${date}-${token}`;
    };

    const configurationId =
      propertyInputs.get("configuration-id")?.value || buildConfigurationId();
    const configurationIdProperty = propertyInputs.get("configuration-id");
    if (configurationIdProperty) configurationIdProperty.value = configurationId;
    orderIdOutputs.forEach((output) => {
      output.textContent = configurationId;
    });

    const selectedFontOption = () => fontSelect?.selectedOptions?.[0] || null;

    const activeFont = () => {
      if (customFontFamily && customFontDataUrl) {
        return {
          label: `Custom / ${customFontFileName}`,
          family: customFontFamily,
          weight: "400",
          widthFactor: 0.62,
          trackingEm: -0.04,
          strokeEm: 0,
          source: `Customer uploaded / ${customFontFileName}`,
          assetUrl: "",
          dataUrl: customFontDataUrl,
          custom: true,
        };
      }
      const option = selectedFontOption();
      return {
        label: option?.dataset.fontLabel || option?.textContent?.trim() || "Archivo Black",
        family: option?.dataset.fontFamily || "Archivo Black, Arial, sans-serif",
        weight: option?.dataset.fontWeight || "400",
        widthFactor: Number(option?.dataset.fontWidthFactor) || 0.62,
        trackingEm: option?.dataset.fontTracking
          ? Number(option.dataset.fontTracking)
          : -0.04,
        strokeEm: Number(option?.dataset.fontStroke) || 0,
        source: option?.dataset.fontSource || "Curated / bundled OFL font",
        assetUrl: option?.dataset.fontUrl || "",
        dataUrl: "",
        custom: false,
      };
    };

    const applyActiveFont = () => {
      const font = activeFont();
      section.querySelectorAll("[data-custom-text], [data-custom-live-header-text]").forEach((text) => {
        text.style.fontFamily = font.family;
        text.style.fontWeight = font.weight;
        text.style.letterSpacing = `${font.trackingEm}em`;
        text.style.webkitTextStroke = font.strokeEm
          ? `${font.strokeEm}em currentColor`
          : "0 currentColor";
        text.style.paintOrder = font.strokeEm ? "stroke fill" : "normal";
      });
      if (fontSample) {
        fontSample.style.fontFamily = font.family;
        fontSample.style.fontWeight = font.weight;
        fontSample.style.letterSpacing = `${font.trackingEm}em`;
        fontSample.style.webkitTextStroke = font.strokeEm
          ? `${font.strokeEm}em currentColor`
          : "0 currentColor";
        fontSample.style.paintOrder = font.strokeEm ? "stroke fill" : "normal";
      }
      const choiceProperty = propertyInputs.get("font-choice");
      const sourceProperty = propertyInputs.get("font-source");
      const statusProperty = propertyInputs.get("font-status");
      if (choiceProperty) choiceProperty.value = font.label;
      if (sourceProperty) sourceProperty.value = font.source;
      if (statusProperty) {
        statusProperty.value = font.custom
          ? "Custom font attached / license and production review required"
          : "Curated preview / production proof required";
      }
      if (orderFontOutput) orderFontOutput.textContent = font.label;
      if (typeof syncLiveProof === "function") syncLiveProof();
    };

    const readBlobAsDataUrl = (blob) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.addEventListener("load", () => resolve(String(reader.result || "")));
        reader.addEventListener("error", () => reject(new Error("The selected asset could not be read.")));
        reader.readAsDataURL(blob);
      });

    const resolveSpacedRepeatMask = (source, layout) => {
      const columns = layout === "half-drop" ? 4 : 2;
      const rows = 2;
      const cacheKey = `${layout}|${source}`;
      const cached = spacedRepeatMaskAssets.get(cacheKey);
      if (cached) return cached;

      const pending = (async () => {
        const response = await fetch(source, { credentials: "same-origin" });
        if (!response.ok) throw new Error("The repeat artwork could not be loaded.");
        const blobUrl = URL.createObjectURL(await response.blob());
        try {
          const image = await new Promise((resolve, reject) => {
            const element = new Image();
            element.addEventListener("load", () => resolve(element), { once: true });
            element.addEventListener("error", () => reject(new Error("The repeat artwork could not be decoded.")), { once: true });
            element.src = blobUrl;
          });
          const naturalWidth = Math.max(1, image.naturalWidth || 1000);
          const naturalHeight = Math.max(1, image.naturalHeight || 1000);
          const renderScale = Math.min(1, 512 / naturalWidth, 512 / naturalHeight);
          const logoWidth = Math.max(1, Math.round(naturalWidth * renderScale));
          const logoHeight = Math.max(1, Math.round(naturalHeight * renderScale));
          const canvas = document.createElement("canvas");
          canvas.width = logoWidth * columns;
          canvas.height = logoHeight * rows;
          const context = canvas.getContext("2d");
          if (!context) throw new Error("The repeat artwork canvas could not be created.");
          context.drawImage(
            image,
            logoWidth * repeatLogoGapRatio / 2,
            logoHeight * repeatLogoGapRatio / 2,
            logoWidth,
            logoHeight,
          );
          return {
            dataUrl: canvas.toDataURL("image/png"),
            logoAspect: logoHeight / logoWidth,
            columns,
          };
        } finally {
          URL.revokeObjectURL(blobUrl);
        }
      })().catch((error) => {
        spacedRepeatMaskAssets.delete(cacheKey);
        throw error;
      });
      spacedRepeatMaskAssets.set(cacheKey, pending);
      return pending;
    };

    const resolveProofSurfaceArtwork = async (surface) => {
      const artwork = surfaceSvgDataUrl(surface);
      if (!artwork || !["material", "photographic"].includes(surface?.kind) || artwork.startsWith("data:")) return artwork;
      const cached = surfaceAssetDataUrls.get(artwork);
      if (cached) return cached;
      const response = await fetch(artwork, { credentials: "same-origin" });
      if (!response.ok) {
        throw new Error(`${surface?.name || "The selected surface"} could not be embedded in the cart proof.`);
      }
      const dataUrl = await readBlobAsDataUrl(await response.blob());
      surfaceAssetDataUrls.set(artwork, dataUrl);
      return dataUrl;
    };

    const restoreSavedUpload = async (side, saved) => {
      if (!saved?.dataUrl || !saved?.name) return;
      const input = uploads.find((candidate) => candidate.dataset.customUpload === side);
      if (!input) return;
      const response = await fetch(saved.dataUrl);
      if (!response.ok) throw new Error(`${saved.name} could not be restored from the saved flag.`);
      const blob = await response.blob();
      const file = new File([blob], saved.name, {
        type: blob.type || "application/octet-stream",
        lastModified: Date.now(),
      });
      const transfer = new DataTransfer();
      transfer.items.add(file);
      input.files = transfer.files;
      const status = section.querySelector(`[data-upload-status="${side}"]`);
      if (status) status.textContent = `${saved.name} / restored from your Shopify account`;
      if (file.type === "image/svg+xml" || file.name.toLowerCase().endsWith(".svg")) {
        releaseArtworkUrl(side);
        artworkUrls[side] = URL.createObjectURL(file);
      }
    };

    const releaseArtworkUrl = (side) => {
      if (artworkUrls[side]?.startsWith("blob:")) URL.revokeObjectURL(artworkUrls[side]);
    };

    const clearArtworkState = (side) => {
      releaseArtworkUrl(side);
      artworkUrls[side] = "";
      artworkDataUrls[side] = "";
      artworkFileNames[side] = "";
      artworkReadPromises[side] = Promise.resolve();
    };

    const setStockDesignButtonState = (activeButton) => {
      stockDesignButtons.forEach((button) => {
        const active = button === activeButton;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", String(active));
      });
      if (stockUploadButton) {
        const active = !activeButton;
        stockUploadButton.classList.toggle("is-active", active);
        stockUploadButton.setAttribute("aria-pressed", String(active));
      }
    };

    const activateCustomUpload = ({ clearArtwork = false } = {}) => {
      setStockDesignButtonState(null);
      if (stockDesignStatus) stockDesignStatus.textContent = "CUSTOM UPLOAD SELECTED";
      const stockProperty = propertyInputs.get("stock-design");
      const rightsProperty = propertyInputs.get("artwork-source-rights");
      if (stockProperty) stockProperty.value = "Custom upload";
      if (rightsProperty) {
        rightsProperty.value = "Customer-supplied / customer certification required";
      }
      if (clearArtwork) {
        clearArtworkState("front");
        clearArtworkState("back");
        uploads.forEach((input) => {
          input.value = "";
        });
        renderArtwork();
      }
    };

    const selectStockDesign = async (button) => {
      if (!button || button.disabled) return;
      const id = button.dataset.stockDesignId || "stock-design";
      const name = button.dataset.stockDesignName || "Gameday stock design";
      const url = button.dataset.stockDesignUrl || "";
      if (!url) return;

      setStockDesignButtonState(button);
      stockDesignButtons.forEach((candidate) => {
        candidate.disabled = true;
      });
      if (stockUploadButton) stockUploadButton.disabled = true;
      if (stockDesignStatus) stockDesignStatus.textContent = `LOADING / ${name.toUpperCase()}`;

      uploads.forEach((input) => {
        input.value = "";
      });
      clearArtworkState("front");
      clearArtworkState("back");

      try {
        const response = await fetch(url, { credentials: "same-origin" });
        if (!response.ok) throw new Error(`${name} could not be loaded.`);
        const blob = await response.blob();
        const dataUrl = await readBlobAsDataUrl(blob);
        artworkUrls.front = url;
        artworkDataUrls.front = dataUrl;
        artworkFileNames.front = `Gameday stock / ${name}`;
        artworkReadPromises.front = Promise.resolve();
        if (mirror) mirror.checked = true;

        const stockProperty = propertyInputs.get("stock-design");
        const rightsProperty = propertyInputs.get("artwork-source-rights");
        const backTreatment = propertyInputs.get("back-treatment");
        if (stockProperty) stockProperty.value = `${name} / ${id}`;
        if (rightsProperty) {
          rightsProperty.value = button.dataset.stockDesignRights || "Approved Gameday artwork";
        }
        if (backTreatment) {
          backTreatment.value = "Readable reverse from governed Gameday stock artwork";
        }
        if (stockDesignStatus) stockDesignStatus.textContent = `STOCK / ${name.toUpperCase()}`;
        const frontStatus = section.querySelector('[data-upload-status="front"]');
        const backStatus = section.querySelector('[data-upload-status="back"]');
        if (frontStatus) frontStatus.textContent = `${name} / live stock vector / color-ready`;
        if (backStatus) backStatus.textContent = "Readable reverse generated from the selected stock design.";
        if (nameInput && !nameInput.value.trim()) {
          nameInput.value = name;
          nameInput.dispatchEvent(new Event("input", { bubbles: true }));
        }
        renderArtwork();
      } catch (error) {
        activateCustomUpload();
        if (stockDesignStatus) {
          stockDesignStatus.textContent = error?.message || "STOCK DESIGN UNAVAILABLE";
        }
        renderArtwork();
      } finally {
        stockDesignButtons.forEach((candidate) => {
          candidate.disabled = false;
        });
        if (stockUploadButton) stockUploadButton.disabled = false;
      }
    };

    const clearCustomFont = () => {
      if (customFontFace && document.fonts?.delete) document.fonts.delete(customFontFace);
      customFontFace = null;
      customFontFamily = "";
      customFontDataUrl = "";
      customFontFileName = "";
      fontReadPromise = Promise.resolve();
      if (fontRights) fontRights.checked = false;
      if (fontRightsWrap) fontRightsWrap.hidden = true;
    };

    const canSubmit = () => !proPhotos?.busy() &&
      productAvailable &&
      Boolean(selectedSizeButton()?.dataset.variantId) &&
      Boolean(nameInput?.value.trim()) &&
      Boolean(rights?.checked) &&
      Boolean(batch?.checked) &&
      (!fontUpload?.files?.length || Boolean(fontRights?.checked)) &&
      !fontUploadPending &&
      !proofCapturePending;

    const syncSubmit = () => {
      if (submit) submit.disabled = !canSubmit();
    };

    const applyGeometry = (size) => {
      const geometry = approvedGeometryForSize(size);
      if (!stages.length || !geometry) return;
      const artworkBounds = centeredArtworkBounds(size);
      const geometryMask = (mirrored = false) => {
        const transform = mirrored ? ' transform="translate(1000 0) scale(-1 1)"' : "";
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" preserveAspectRatio="none"><path fill="white"${transform} d="${geometry.path}"/></svg>`;
        return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
      };
      const frontMask = geometryMask(false);
      const backMask = geometryMask(true);
      geometryPaths.forEach((path) => path.setAttribute("d", geometry.path));
      const openPerimeter = geometry.path.replace(/\s+Z\s*$/i, "");
      geometryOutlines.forEach((path) => path.setAttribute("d", openPerimeter));
      const headerWidth = geometry.headerWidth * approvedProofFrame.width;
      geometryHeaders.forEach((header) => {
        const side = header.dataset.approvedProofSide || "front";
        const headerX = side === "back"
          ? approvedProofFrame.x + approvedProofFrame.width - headerWidth
          : approvedProofFrame.x;
        header.setAttribute("x", String(headerX));
        header.setAttribute("y", String(approvedProofFrame.y));
        header.setAttribute("width", String(headerWidth));
        header.setAttribute("height", String(approvedProofFrame.height));
      });
      geometryHeaderSeams.forEach((seam) => {
        const side = seam.dataset.approvedProofSide || "front";
        const seamX = side === "back"
          ? approvedProofFrame.x + approvedProofFrame.width - headerWidth
          : approvedProofFrame.x + headerWidth;
        seam.setAttribute(
          "d",
          `M${seamX} ${approvedProofFrame.y}V${approvedProofFrame.y + approvedProofFrame.height}`,
        );
      });
      stages.forEach((geometryStage) => {
        geometryStage.style.setProperty("--custom-face-mask-front", frontMask);
        geometryStage.style.setProperty("--custom-face-mask-back", backMask);
        geometryStage.style.setProperty("--custom-aspect", String(geometry.aspect));
        geometryStage.style.setProperty("--custom-header-width", `${geometry.headerWidth * 100}%`);
        geometryStage.style.setProperty("--custom-tag-left", `${geometry.tag.left * 100}%`);
        geometryStage.style.setProperty("--custom-tag-top", `${geometry.tag.top * 100}%`);
        geometryStage.style.setProperty("--custom-tag-width", `${geometry.tag.width * 100}%`);
        geometryStage.style.setProperty("--custom-tag-height", `${geometry.tag.height * 100}%`);
        geometryStage.style.setProperty("--custom-safe-left", `${artworkBounds.left * 100}%`);
        geometryStage.style.setProperty("--custom-safe-right", `${artworkBounds.right * 100}%`);
        geometryStage.style.setProperty("--custom-safe-top", `${artworkBounds.top * 100}%`);
        geometryStage.style.setProperty("--custom-safe-bottom", `${artworkBounds.bottom * 100}%`);
        geometryStage.style.setProperty("--custom-loop-width", `${geometry.loop.width * 100}%`);
        geometryStage.style.setProperty("--custom-loop-inset", `${geometry.loop.inset * 100}%`);
        geometryStage.style.setProperty("--custom-loop-height", `${geometry.loop.heightPx}px`);
      });
    };

    const selectSize = (button) => {
      if (!button || button.disabled) return;
      sizeButtons.forEach((candidate) => {
        const active = candidate === button;
        candidate.classList.toggle("is-active", active);
        candidate.setAttribute("aria-pressed", String(active));
      });
      const size = button.dataset.customSize || "12x17";
      const label = button.dataset.customSizeLabel || button.textContent.trim();
      stages.forEach((geometryStage) => {
        geometryStage.dataset.size = size;
      });
      applyGeometry(size);
      syncLetterHeightControls(true);
      updateAllContentLayouts();
      sizeOutputs.forEach((output) => {
        output.textContent = label.toUpperCase();
      });
      if (variantInput && button.dataset.variantId) variantInput.value = button.dataset.variantId;
      const sizeProperty = propertyInputs.get("size");
      if (sizeProperty) sizeProperty.value = label;
      const sku = button.dataset.variantSku || "SKU PENDING";
      const price = button.dataset.variantPrice || "";
      const skuProperty = propertyInputs.get("variant-sku");
      const fulfillmentKey = propertyInputs.get("fulfillment-key");
      if (skuProperty) skuProperty.value = sku;
      if (fulfillmentKey) fulfillmentKey.value = `${configurationId} / ${sku}`;
      if (orderSizeOutput) orderSizeOutput.textContent = label;
      orderSkuOutputs.forEach((output) => {
        output.textContent = sku;
      });
      if (orderPriceOutput && price) orderPriceOutput.textContent = price;
      if (typeof renderBackground === "function") renderBackground();
      syncLiveProof();
      syncSubmit();
    };

    const selectSide = (side) => {
      const showBack = side === "back";
      if (stage) stage.dataset.side = showBack ? "back" : "front";
      if (configuratorProofStack) configuratorProofStack.dataset.activeSide = side;
      configuratorProofFaces.forEach((face) => {
        const active = face.dataset.customProofFace === side;
        face.classList.toggle("is-active", active);
        face.setAttribute("aria-current", active ? "true" : "false");
      });
      sideButtons.forEach((button) => {
        const active = button.dataset.customSide === side;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", String(active));
      });
    };

    const setMask = (element, url) => {
      if (!element) return;
      const mask = url ? `url("${url}")` : "none";
      element.style.maskImage = mask;
      element.style.webkitMaskImage = mask;
      element.hidden = !url;
    };

    const placementValue = (side, control, fallback) => {
      const input = placementInputs.find(
        (candidate) =>
          candidate.dataset.customPlacementSide === side &&
          candidate.dataset.customPlacement === control,
      );
      const value = Number(input?.value);
      return Number.isFinite(value) ? value : fallback;
    };

    const effectiveArtworkUrl = (side) =>
      artworkUrls[side] ||
      (side === "back" && mirror?.checked ? artworkUrls.front : "");

    const effectiveText = (side) => {
      const explicitText = section
        .querySelector(`[data-custom-text-input="${side}"]`)
        ?.value.trim();
      if (explicitText) return explicitText;
      if (side === "back" && mirror?.checked) {
        return section.querySelector('[data-custom-text-input="front"]')?.value.trim() || "";
      }
      return "";
    };

    const syncLetterHeightControls = (useSizeDefault = false) => {
      const size = selectedSizeButton()?.dataset.customSize || "12x17";
      const authoredBounds = dxfArtworkBounds[size];
      const safeHeight = authoredBounds
        ? 1 - authoredBounds.top - authoredBounds.bottom
        : 0.72;
      const physicalHeight = flagPhysicalHeightsInches[size] || 12;
      ["front", "back"].forEach((side) => {
        const input = placementInputs.find(
          (candidate) =>
            candidate.dataset.customPlacementSide === side &&
            candidate.dataset.customPlacement === "text-height",
        );
        if (!input) return;
        const hasBoth = Boolean(effectiveArtworkUrl(side) && effectiveText(side));
        const availableHeight = safeHeight * (hasBoth ? 0.28 : 1);
        const maximum = Math.max(
          0.5,
          Math.floor(physicalHeight * availableHeight * 0.82 * 2) / 2,
        );
        input.max = String(maximum);
        if (useSizeDefault && input.dataset.customHeightTouched !== "true") {
          input.value = String(Math.min(defaultLetterHeightsInches[size] || 2, maximum));
        } else if (Number(input.value) > maximum) {
          input.value = String(maximum);
        }
        updatePlacementOutput(input);
      });
    };

    const contentLayoutForSide = (side, hasArtwork, hasEnteredText) => {
      const size = selectedSizeButton()?.dataset.customSize || "12x17";
      const geometry = approvedGeometryForSize(size);
      const authoredBounds = centeredArtworkBounds(size);
      const bounds = side === "back"
        ? { ...authoredBounds, left: authoredBounds.right, right: authoredBounds.left }
        : authoredBounds;
      const safeWidth = 1 - bounds.left - bounds.right;
      const safeHeight = 1 - bounds.top - bounds.bottom;
      const hasBoth = hasArtwork && hasEnteredText;

      const logoScale = placementValue(side, "logo-scale", 100) / 100;
      const logoX = (placementValue(side, "logo-x", 0) + 100) / 200;
      const logoY = (placementValue(side, "logo-y", 0) + 100) / 200;
      const logoSlotHeight = safeHeight * (hasBoth ? 0.72 : 1);
      const logoWidth = safeWidth * logoScale;
      const logoHeight = logoSlotHeight * logoScale;
      const logoLeft = bounds.left + (safeWidth - logoWidth) * logoX;

      const physicalHeight = flagPhysicalHeightsInches[size] || 12;
      const textWidthRatio = placementValue(side, "text-width", 100) / 100;
      const letterHeightInches = placementValue(
        side,
        "text-height",
        defaultLetterHeightsInches[size] || 2,
      );
      const textX = (placementValue(side, "text-x", 0) + 100) / 200;
      const textY = (placementValue(side, "text-y", 0) + 100) / 200;
      const textSlotHeight = safeHeight * (hasBoth ? 0.28 : 1);
      const textWidth = safeWidth * Math.min(1, Math.max(0.3, textWidthRatio));
      // Letter height is stored as a physical dimension. Converting it to a
      // fraction of the selected flag keeps the preview and cart proof in scale.
      const textHeight = Math.min(textSlotHeight, letterHeightInches / physicalHeight);
      const textLeft = bounds.left + (safeWidth - textWidth) * textX;
      // When artwork and lettering share a face, distribute the remaining
      // vertical room above, between, and below them. Previously the artwork
      // started at the very top of the safe area while all unused lettering
      // room accumulated below it, making the complete lockup appear skewed.
      const balancedGutter = hasBoth
        ? Math.max(0, safeHeight - logoSlotHeight - textHeight) / 3
        : 0;
      const logoTop = bounds.top + balancedGutter + (logoSlotHeight - logoHeight) * logoY;
      const balancedTextTop = bounds.top + balancedGutter + logoSlotHeight + balancedGutter;
      const textTravel = hasBoth ? balancedGutter * 2 : textSlotHeight - textHeight;
      const textTop = hasBoth
        ? balancedTextTop + (textY - 0.5) * textTravel
        : bounds.top + (textSlotHeight - textHeight) * textY;

      return {
        bounds: { ...bounds, width: safeWidth, height: safeHeight },
        logo: { left: logoLeft, top: logoTop, width: logoWidth, height: logoHeight },
        text: {
          left: textLeft,
          top: textTop,
          width: textWidth,
          height: textHeight,
          letterHeightInches: textHeight * physicalHeight,
        },
        hasBoth,
      };
    };

    const setPercentBox = (element, left, top, width, height) => {
      element.style.left = `${left * 100}%`;
      element.style.top = `${top * 100}%`;
      element.style.right = "auto";
      element.style.bottom = "auto";
      element.style.width = `${width * 100}%`;
      element.style.height = `${height * 100}%`;
    };

    const fitTextToBox = (element, maximumFontSize) => {
      if (!element || element.hidden || !element.textContent.trim()) return;
      const boxWidth = element.clientWidth;
      const boxHeight = element.clientHeight;
      if (!boxWidth || !boxHeight) return;

      let low = 1;
      let high = Math.max(low, maximumFontSize);
      for (let pass = 0; pass < 14; pass += 1) {
        const candidate = (low + high) / 2;
        element.style.fontSize = `${candidate}px`;
        const fits =
          element.scrollWidth <= boxWidth &&
          element.scrollHeight <= boxHeight;
        if (fits) low = candidate;
        else high = candidate;
      }
      // Leave a fractional-pixel safety margin so browser font rounding cannot
      // push the final line outside the governed print box.
      element.style.fontSize = `${Math.max(1, low - 0.5)}px`;
    };

    const updateSideContentLayout = (side) => {
      const artworkUrl = effectiveArtworkUrl(side);
      const enteredText = effectiveText(side);
      const hasArtwork = Boolean(artworkUrl);
      const hasEnteredText = Boolean(enteredText);
      const layout = contentLayoutForSide(side, hasArtwork, hasEnteredText);

      section.querySelectorAll(`[data-custom-face="${side}"]`).forEach((face) => {
        face.classList.toggle("has-artwork", hasArtwork);
        face.classList.toggle("has-entered-text", hasEnteredText);
        face.classList.toggle("has-artwork-and-text", layout.hasBoth);
      });
      section.querySelectorAll(`[data-custom-art="${side}"]`).forEach((art) => {
        const frontTreatment = frontArtworkLayout?.value || "single";
        const usesRepeatBounds = side === "front" && ["straight-repeat", "half-drop"].includes(frontTreatment);
        const artBox = usesRepeatBounds ? layout.bounds : layout.logo;
        setPercentBox(art, artBox.left, artBox.top, artBox.width, artBox.height);
      });
      section.querySelectorAll(`[data-custom-text="${side}"]`).forEach((text) => {
        setPercentBox(text, layout.text.left, layout.text.top, layout.text.width, layout.text.height);
        const faceHeight = text.closest(".custom-flag-face")?.clientHeight || 0;
        text.textContent = enteredText || (hasArtwork || proPhotos?.surface(side)?.fullFlag ? "" : side.toUpperCase());
        text.hidden = hasArtwork && !hasEnteredText;
        if (faceHeight) {
          fitTextToBox(text, Math.max(5, layout.text.height * faceHeight));
        }
      });
      section.querySelectorAll(`[data-custom-artwork-boundary="${side}"]`).forEach((boundary) => {
        setPercentBox(
          boundary,
          layout.bounds.left,
          layout.bounds.top,
          layout.bounds.width,
          layout.bounds.height,
        );
      });
    };

    const updateAllContentLayouts = () => {
      updateSideContentLayout("front");
      updateSideContentLayout("back");
    };

    const updatePlacementOutput = (input) => {
      const key = `${input.dataset.customPlacementSide}-${input.dataset.customPlacement}`;
      const output = placementOutputs.get(key);
      if (!output) return;
      const value = Number(input.value);
      if (
        input.dataset.customPlacement.endsWith("scale") ||
        input.dataset.customPlacement === "text-width"
      ) {
        output.textContent = `${value}%`;
        return;
      }
      if (input.dataset.customPlacement === "text-height") {
        output.textContent = `${Number.isInteger(value) ? value : value.toFixed(1)} in`;
        return;
      }
      const axis = input.dataset.customPlacement.endsWith("-x")
        ? ["LEFT", "RIGHT"]
        : ["UP", "DOWN"];
      output.textContent = value === 0
        ? "CENTER"
        : `${value < 0 ? axis[0] : axis[1]} ${Math.abs(value)}`;
    };

    const relativeLuminance = (hex) => {
      const normalized = String(hex || "").replace("#", "").trim();
      if (!/^[0-9a-f]{6}$/i.test(normalized)) return 0;
      const channels = [0, 2, 4].map((index) => {
        const value = parseInt(normalized.slice(index, index + 2), 16) / 255;
        return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
      });
      return channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722;
    };

    const foregroundOutlineColorForSide = (side) => {
      const colorMode = foregroundBorderColor?.value || "auto";
      const artColor = selectedColor(
        colorSelects.find((select) => select.dataset.customColor === `${side}-art`),
      ).hex;
      const fieldColor = selectedColor(
        colorSelects.find((select) => select.dataset.customColor === `${side}-background`),
      ).hex;
      const patternColor = selectedColor(
        colorSelects.find((select) => select.dataset.customColor === `${side}-pattern`),
      ).hex;
      return colorMode === "black"
        ? "#050505"
        : colorMode === "white"
          ? "#ffffff"
          : colorMode === "background"
            ? fieldColor
            : colorMode === "pattern"
              ? patternColor
              : relativeLuminance(artColor) < 0.42
                ? "#ffffff"
                : "#050505";
    };

    const renderForegroundSeparation = () => {
      const strength = foregroundSeparation?.value || "none";
      ["front", "back"].forEach((side) => {
        const outlineColor = foregroundOutlineColorForSide(side);
        section.querySelectorAll(`[data-custom-face="${side}"]`).forEach((face) => {
          face.dataset.customSeparation = strength;
          face.style.setProperty("--custom-art-outline-color", outlineColor);
        });
      });
      const strengthProperty = propertyInputs.get("foreground-separation");
      const colorProperty = propertyInputs.get("foreground-border-color");
      if (strengthProperty) {
        strengthProperty.value = foregroundSeparation?.selectedOptions?.[0]?.textContent || "Standard";
      }
      if (colorProperty) {
        colorProperty.value = foregroundBorderColor?.selectedOptions?.[0]?.textContent || "Automatic contrast";
      }
    };

    const renderArtwork = () => {
      section.querySelectorAll('[data-custom-art="front"]').forEach((frontArt) => {
        setMask(frontArt, artworkUrls.front);
      });
      section.querySelectorAll('[data-custom-art="back"]').forEach((backArt) => {
        setMask(backArt, artworkUrls.back || (mirror?.checked ? artworkUrls.front : ""));
      });
      syncLetterHeightControls();
      updateAllContentLayouts();
      renderForegroundSeparation();
      if (typeof renderBackground === "function") renderBackground();
    };

    const backgroundSurfaceForSide = (side) => proPhotos?.surface(side) || backgroundSurfaces.find(
      (surface) => surface.id === backgroundSurfaceBySide[side]?.value,
    ) || backgroundSurfaces[0];

    const backgroundSurfaceDescription = (selectedSurface, side) => {
      const sideLabel = side === "back" ? "Back" : "Front";
      if (selectedSurface?.kind === "solid") return `Uses the selected ${side} background color.`;
      if (selectedSurface?.description) return `${sideLabel}: ${selectedSurface.description}`;
      if (selectedSurface?.kind === "material") {
        return `${sideLabel}: ${selectedSurface?.name || "Selected material"} / governed repeatable Blender material texture. Final textile and print color are confirmed during production review.`;
      }
      if (selectedSurface?.kind === "photographic") {
        return `${sideLabel}: ${selectedSurface?.name || "Selected surface"} / governed photographic surface preview. Final textile and print color are confirmed during production review.`;
      }
      return `${sideLabel}: ${selectedSurface?.name || "Selected surface"} / original procedural preview. Final textile and print color are confirmed during production review.`;
    };

    const backgroundSurfaceBadge = (surface) => {
      if (surface?.badge) return surface.badge;
      if (surface?.kind === "solid") return "COLOR CONTROL";
      if (surface?.kind === "material") return "EXO MATERIAL";
      if (surface?.kind === "photographic") return "CONTROLLED SOURCE";
      return "EXO ORIGINAL";
    };

    const backgroundSurfaceLicense = (surface) => {
      if (surface?.license) return surface.license;
      if (surface?.kind === "solid") return "Customer color control";
      if (surface?.kind === "material") return "EXO controlled material library";
      if (surface?.kind === "photographic") return "Governed source / production review";
      return "EXO original procedural recipe";
    };

    const backgroundSurfaceSearchText = (surface) => [
      surface?.name,
      surface?.group,
      surface?.category,
      surface?.description,
      ...(Array.isArray(surface?.tags) ? surface.tags : []),
    ].filter(Boolean).join(" ").toLowerCase();

    const backgroundSurfaceRepeats = (surface) =>
      Boolean(surface?.repeat) || surface?.kind === "material";

    const styleBackgroundPreview = (preview, surface, side = "front") => {
      if (!preview) return;
      const select = colorSelects.find((candidate) => candidate.dataset.customColor === `${side}-background`);
      const fallbackColor = select?.selectedOptions?.[0]?.dataset.hex || "#383838";
      const artwork = surfaceSvgDataUrl(surface);
      const repeats = backgroundSurfaceRepeats(surface);
      preview.style.backgroundColor = fallbackColor;
      preview.style.backgroundImage = artwork ? `url("${artwork}")` : "none";
      preview.style.backgroundRepeat = repeats ? "repeat" : "no-repeat";
      preview.style.backgroundPosition = repeats ? "0 0" : "center";
      preview.style.backgroundSize = repeats
        ? `${Math.max(52, Math.min(150, Number(surface?.catalogTilePixels) || 86))}px auto`
        : "cover";
    };

    const renderBackgroundChoiceButtons = () => {
      backgroundChoiceButtons.forEach((button) => {
        const side = button.dataset.customBackgroundOpen === "back" ? "back" : "front";
        const surface = backgroundSurfaceForSide(side);
        const name = button.querySelector(`[data-custom-background-choice-name="${side}"]`);
        const badge = button.querySelector(`[data-custom-background-choice-badge="${side}"]`);
        const swatch = button.querySelector(`[data-custom-background-choice-swatch="${side}"]`);
        if (name) name.textContent = surface?.name || "Solid color";
        if (badge) badge.textContent = backgroundSurfaceBadge(surface);
        styleBackgroundPreview(swatch, surface, side);
      });
    };

    const setBackgroundCatalogSide = (side) => {
      backgroundCatalogSide = side === "back" ? "back" : "front";
      backgroundCatalogSideButtons.forEach((button) => {
        const active = button.dataset.customBackgroundCatalogSide === backgroundCatalogSide;
        button.setAttribute("aria-selected", String(active));
        button.tabIndex = active ? 0 : -1;
      });
    };

    const renderBackgroundCatalog = () => {
      renderBackgroundChoiceButtons();
      if (!backgroundCatalogGrid || !backgroundCatalogCategories) return;
      const query = backgroundCatalogSearch?.value.trim().toLowerCase() || "";
      const categoryNames = ["All", ...new Set(backgroundSurfaces.map(
        (surface) => surface.category || surface.group || "Backgrounds",
      ))];
      if (!categoryNames.includes(backgroundCatalogCategory)) backgroundCatalogCategory = "All";
      backgroundCatalogCategories.replaceChildren();
      categoryNames.forEach((category) => {
        const button = document.createElement("button");
        button.type = "button";
        button.dataset.customBackgroundCategory = category;
        button.classList.toggle("is-active", category === backgroundCatalogCategory);
        button.textContent = category.toUpperCase();
        backgroundCatalogCategories.append(button);
      });

      const selectedSurface = backgroundSurfaceForSide(backgroundCatalogSide);
      const visibleSurfaces = backgroundSurfaces.filter((surface) => {
        const category = surface.category || surface.group || "Backgrounds";
        return (backgroundCatalogCategory === "All" || category === backgroundCatalogCategory) &&
          (!query || backgroundSurfaceSearchText(surface).includes(query));
      });
      backgroundCatalogGrid.replaceChildren();
      visibleSurfaces.forEach((surface) => {
        const card = document.createElement("button");
        card.type = "button";
        card.className = "custom-background-card";
        card.dataset.customBackgroundSurfaceChoice = surface.id;
        card.setAttribute("role", "option");
        const active = surface.id === selectedSurface?.id;
        card.classList.toggle("is-active", active);
        card.setAttribute("aria-selected", String(active));

        const preview = document.createElement("span");
        preview.className = "custom-background-card__preview";
        preview.setAttribute("aria-hidden", "true");
        styleBackgroundPreview(preview, surface, backgroundCatalogSide);
        const copy = document.createElement("span");
        copy.className = "custom-background-card__copy";
        const name = document.createElement("strong");
        name.textContent = surface.name;
        const badge = document.createElement("small");
        badge.textContent = backgroundSurfaceBadge(surface);
        copy.append(name, badge);
        card.append(preview, copy);
        backgroundCatalogGrid.append(card);
      });

      if (!visibleSurfaces.length) {
        const empty = document.createElement("p");
        empty.className = "custom-background-catalog__empty";
        empty.textContent = "No controlled backgrounds match this search.";
        backgroundCatalogGrid.append(empty);
      }
      styleBackgroundPreview(backgroundCatalogPreview, selectedSurface, backgroundCatalogSide);
      if (backgroundCatalogName) backgroundCatalogName.textContent = selectedSurface?.name || "Solid color";
      if (backgroundCatalogGroup) {
        backgroundCatalogGroup.textContent = (selectedSurface?.category || selectedSurface?.group || "Color").toUpperCase();
      }
      if (backgroundCatalogDescription) {
        backgroundCatalogDescription.textContent = backgroundSurfaceDescription(selectedSurface, backgroundCatalogSide);
      }
      if (backgroundCatalogLicense) backgroundCatalogLicense.textContent = backgroundSurfaceLicense(selectedSurface);
      if (backgroundCatalogApplied) {
        backgroundCatalogApplied.textContent = backgroundCatalogSide === "back" ? "BACK / CLEAN SIDE" : "FRONT / TAG SIDE";
      }
    };

    const applyBackgroundSurface = (side, surfaceId, { linked = backgroundCatalogLink?.checked } = {}) => {
      const resolvedSide = side === "back" ? "back" : "front";
      const select = backgroundSurfaceBySide[resolvedSide];
      if (!select || !backgroundSurfaces.some((surface) => surface.id === surfaceId)) return;
      select.value = surfaceId;
      if (linked) {
        const otherSide = resolvedSide === "front" ? "back" : "front";
        if (backgroundSurfaceBySide[otherSide]) backgroundSurfaceBySide[otherSide].value = surfaceId;
      }
      renderBackground();
      renderBackgroundCatalog();
    };

    const closeBackgroundCatalog = ({ restore = false } = {}) => {
      if (restore && backgroundCatalogSnapshot) {
        if (backgroundSurfaceBySide.front) backgroundSurfaceBySide.front.value = backgroundCatalogSnapshot.front;
        if (backgroundSurfaceBySide.back) backgroundSurfaceBySide.back.value = backgroundCatalogSnapshot.back;
        renderBackground();
      }
      backgroundCatalogSnapshot = null;
      if (backgroundCatalog?.open) backgroundCatalog.close();
    };

    const openBackgroundCatalog = (side) => {
      if (!backgroundCatalog) return;
      backgroundCatalogSnapshot = {
        front: backgroundSurfaceBySide.front?.value || "solid",
        back: backgroundSurfaceBySide.back?.value || "solid",
      };
      setBackgroundCatalogSide(side);
      if (backgroundCatalogSearch) backgroundCatalogSearch.value = "";
      backgroundCatalogCategory = "All";
      if (backgroundCatalogLink) backgroundCatalogLink.checked = false;
      renderBackgroundCatalog();
      backgroundCatalog.showModal();
      window.requestAnimationFrame(() => backgroundCatalogSearch?.focus());
    };

    const renderBackground = () => {
      if(proPreview)section.querySelectorAll('svg.gameday-approved-proof__svg').forEach(svg=>{let header=svg.querySelector('[data-custom-geometry-header]');const side=header?.dataset.approvedProofSide||(svg.closest('[data-custom-stage]')?.dataset.customStage?.includes('back')?'back':'front'),photo=proPhotos?.surface(side);if(!header&&photo){header=document.createElementNS('http://www.w3.org/2000/svg','rect');header.setAttribute('data-custom-geometry-header','');header.setAttribute('data-approved-proof-side',side);header.setAttribute('data-pro-added-header','');const clipped=svg.querySelector('g[clip-path]');if(!clipped)throw Error('Photo proof clip missing');clipped.append(header);}if(!header)return;if(header.hasAttribute('data-pro-added-header')){const w=approvedGeometryForSize(selectedSizeButton()?.dataset.customSize||'12x17').headerWidth*approvedProofFrame.width;for(const [k,v] of Object.entries({x:side==='back'?1000-approvedProofFrame.x-w:approvedProofFrame.x,y:approvedProofFrame.y,width:w,height:approvedProofFrame.height}))header.setAttribute(k,String(v));if(!photo){svg.querySelector('[data-pro-proof-photo]')?.remove();header.remove();return;}}let layer=svg.querySelector('[data-pro-proof-photo]');if(photo){if(!proHeaderStyles.has(header)){const declarations=[[header,'fill'],[header,'opacity'],...[...svg.querySelectorAll('[data-custom-geometry-header-seam]')].map(e=>[e,'stroke'])];proHeaderStyles.set(header,declarations.map(([el,property])=>({el,property,value:el.style.getPropertyValue(property),priority:el.style.getPropertyPriority(property)})));}if(!layer){layer=document.createElementNS('http://www.w3.org/2000/svg','image');layer.setAttribute('data-pro-proof-photo',side);header.before(layer);}for(const [k,v] of Object.entries({href:photo.dataUrl,x:side==='back'?1000-approvedProofFrame.x-approvedProofFrame.width:approvedProofFrame.x,y:approvedProofFrame.y,width:approvedProofFrame.width,height:approvedProofFrame.height,preserveAspectRatio:'none'}))layer.setAttribute(k,String(v));header.style.setProperty('fill',proPhotos.headerColor(),'important');header.style.setProperty('opacity',photo.fullFlag?'0':'1','important');svg.querySelectorAll('[data-custom-geometry-header-seam]').forEach(e=>e.style.setProperty('stroke',proPhotos.headerColor(),'important'));}else{layer?.remove();const original=proHeaderStyles.get(header);if(original){for(const {el,property,value,priority} of original){if(value)el.style.setProperty(property,value,priority);else el.style.removeProperty(property);}proHeaderStyles.delete(header);}}});

      section.querySelectorAll("[data-custom-surface]").forEach((surfaceLayer) => {
        const side = surfaceLayer.dataset.customSurface === "back" ? "back" : "front";
        const selectedSurface = backgroundSurfaceForSide(side);
        const selectedSurfaceArtwork = surfaceSvgDataUrl(selectedSurface);
        surfaceLayer.hidden = !selectedSurfaceArtwork;
        surfaceLayer.style.backgroundImage = selectedSurfaceArtwork ? `url("${selectedSurfaceArtwork}")` : "none";
        const materialTexture = backgroundSurfaceRepeats(selectedSurface);
        const governedTileSize = materialTilePixels(surfaceLayer, selectedSurface);
        surfaceLayer.style.backgroundRepeat = materialTexture ? "repeat" : "no-repeat";
        surfaceLayer.style.backgroundSize = materialTexture
          ? `${governedTileSize}px ${governedTileSize}px`
          : "cover";
        surfaceLayer.style.backgroundPosition = materialTexture ? "0 0" : "center";
        surfaceLayer.dataset.materialPitchIn = materialTexture
          ? String(selectedSurface?.diamondPitchInches || 2)
          : "";
        surfaceLayer.dataset.materialAngles = materialTexture
            ? (selectedSurface?.diamondAngles || [45, 135]).join(",")
            : "";
      });
      backgroundSurfaceNotes.forEach((note) => {
        const side = note.dataset.customBackgroundSurfaceNote === "back" ? "back" : "front";
        note.textContent = backgroundSurfaceDescription(backgroundSurfaceForSide(side), side);
      });
      const frontSurface = backgroundSurfaceForSide("front");
      const backSurface = backgroundSurfaceForSide("back");
      const surfaceProperty = propertyInputs.get("background-surface");
      const frontSurfaceProperty = propertyInputs.get("front-background-surface");
      const backSurfaceProperty = propertyInputs.get("back-background-surface");
      if (surfaceProperty) surfaceProperty.value = `Front: ${frontSurface?.name || "Solid color"} / Back: ${backSurface?.name || "Solid color"}`;
      if (frontSurfaceProperty) frontSurfaceProperty.value = frontSurface?.name || "Solid color";
      if (backSurfaceProperty) backSurfaceProperty.value = backSurface?.name || "Solid color";
      const motif = backgroundMotif?.value || "solid";
      const requestedLayout = backgroundLayout?.value || "solid";
      const geometricLayouts = new Set([
        "horizontal-stripes",
        "vertical-stripes",
        "diagonal-stripes",
        "checkerboard",
        "offset-signal",
        "center-band",
        "double-edge-bands",
        "border-frame",
      ]);
      const motifLayouts = new Set(["watermark", "straight-repeat", "half-drop"]);
      const layout = motif === "solid" && motifLayouts.has(requestedLayout)
        ? "solid"
        : requestedLayout;
      const scale = Math.max(3, Math.min(80, Number(backgroundScale?.value) || 28));
      const anchorKey = backgroundAnchor?.value || "center";
      const anchors = {
        center: [50, 50],
        "top-left": [0, 0],
        "top-center": [50, 0],
        "top-right": [100, 0],
        "bottom-left": [0, 100],
        "bottom-center": [50, 100],
        "bottom-right": [100, 100],
      };
      const [anchorX, anchorY] = anchors[anchorKey] || anchors.center;
      const anchorPosition = `${anchorX}% ${anchorY}%`;
      const source = motif === "foreground"
        ? artworkUrls.front
        : stockAssets.get(motif) || "";
      section.querySelectorAll("[data-custom-pattern]").forEach((pattern) => {
        const side = pattern.dataset.customPattern;
        const patternColor = selectedColor(
          colorSelects.find((select) => select.dataset.customColor === `${side}-pattern`),
        ).hex;
        const sideSource = motif === "foreground" && side === "back"
          ? (artworkUrls.back || artworkUrls.front)
          : source;
        pattern.className = "custom-flag-face__pattern";
        pattern.dataset.patternLayout = layout;
        pattern.style.setProperty("--custom-pattern-color", patternColor);
        pattern.style.setProperty("--custom-pattern-scale", `${scale}%`);
        pattern.style.setProperty("--custom-pattern-half", `${scale / 2}%`);
        pattern.style.setProperty("--custom-pattern-third", `${scale / 3}%`);
        pattern.style.setProperty("--custom-pattern-anchor-x", `${anchorX}%`);
        pattern.style.setProperty("--custom-pattern-anchor-y", `${anchorY}%`);
        pattern.style.setProperty("--custom-pattern-position", anchorPosition);
        pattern.style.backgroundColor = patternColor;
        pattern.style.backgroundImage = "none";
        pattern.style.webkitMaskImage = "none";
        pattern.style.maskImage = "none";

        if (layout === "solid") {
          pattern.hidden = true;
          return;
        }
        pattern.hidden = false;
        if (geometricLayouts.has(layout)) {
          pattern.classList.add("is-geometric", `is-${layout}`);
          return;
        }
        if (!sideSource) {
          pattern.hidden = true;
          return;
        }
        if (layout === "watermark") {
          pattern.style.webkitMaskImage = `url("${sideSource}")`;
          pattern.style.maskImage = pattern.style.webkitMaskImage;
          pattern.style.webkitMaskRepeat = "no-repeat";
          pattern.style.maskRepeat = "no-repeat";
          pattern.style.webkitMaskPosition = anchorPosition;
          pattern.style.maskPosition = anchorPosition;
          pattern.style.webkitMaskSize = `${Math.min(92, scale + 24)}% auto`;
          pattern.style.maskSize = pattern.style.webkitMaskSize;
          return;
        }

        const renderToken = `${layout}|${sideSource}|${scale}|${anchorKey}`;
        pattern.dataset.repeatRenderToken = renderToken;
        pattern.style.webkitMaskImage = `url("${sideSource}")`;
        pattern.style.maskImage = pattern.style.webkitMaskImage;
        pattern.style.webkitMaskRepeat = "space";
        pattern.style.maskRepeat = "space";
        pattern.style.webkitMaskPosition = anchorPosition;
        pattern.style.maskPosition = anchorPosition;
        pattern.style.webkitMaskSize = `${scale}% auto`;
        pattern.style.maskSize = pattern.style.webkitMaskSize;

        resolveSpacedRepeatMask(sideSource, layout).then((asset) => {
          if (pattern.dataset.repeatRenderToken !== renderToken) return;
          const spacedMask = `url("${asset.dataUrl}")`;
          const cellScale = scale * asset.columns;
          if (layout === "half-drop") {
            const shiftX = pattern.clientWidth * scale * 2 / 100;
            const shiftY = pattern.clientWidth * scale * asset.logoAspect / 100;
            pattern.style.webkitMaskImage = `${spacedMask}, ${spacedMask}`;
            pattern.style.maskImage = pattern.style.webkitMaskImage;
            pattern.style.webkitMaskRepeat = "repeat, repeat";
            pattern.style.maskRepeat = "repeat, repeat";
            pattern.style.webkitMaskPosition = `${anchorPosition}, calc(${anchorX}% + ${shiftX}px) calc(${anchorY}% + ${shiftY}px)`;
            pattern.style.maskPosition = pattern.style.webkitMaskPosition;
            pattern.style.webkitMaskSize = `${cellScale}% auto, ${cellScale}% auto`;
            pattern.style.maskSize = pattern.style.webkitMaskSize;
            return;
          }
          pattern.style.webkitMaskImage = spacedMask;
          pattern.style.maskImage = spacedMask;
          pattern.style.webkitMaskRepeat = "repeat";
          pattern.style.maskRepeat = "repeat";
          pattern.style.webkitMaskPosition = anchorPosition;
          pattern.style.maskPosition = anchorPosition;
          pattern.style.webkitMaskSize = `${cellScale}% auto`;
          pattern.style.maskSize = pattern.style.webkitMaskSize;
        }).catch((error) => {
          console.warn("The spaced logo repeat could not be prepared; using distributed spacing.", error);
        });
      });
      if (backgroundScaleOutput) backgroundScaleOutput.textContent = `${scale}%`;
      const motifProperty = propertyInputs.get("background-motif");
      const layoutProperty = propertyInputs.get("background-layout");
      const scaleProperty = propertyInputs.get("background-scale");
      const anchorProperty = propertyInputs.get("background-anchor");
      if (motifProperty) motifProperty.value = backgroundMotif?.selectedOptions?.[0]?.textContent || "Solid field";
      if (layoutProperty) layoutProperty.value = backgroundLayout?.selectedOptions?.[0]?.textContent || "Solid";
      if (scaleProperty) scaleProperty.value = `${scale}%`;
      if (anchorProperty) anchorProperty.value = backgroundAnchor?.selectedOptions?.[0]?.textContent || "Centered";
      renderBackgroundChoiceButtons();
      renderFrontArtworkTreatment();
    };

    const selectedColor = (select) => {
      const option = select?.selectedOptions?.[0];
      return {
        name: option?.dataset.name || "Color",
        hex: option?.dataset.hex || "#383838",
        pantone: option?.dataset.pantone || "",
      };
    };

    const describeColor = (color) =>
      `${color.name} / ${color.hex}${color.pantone ? ` / ${color.pantone}` : ""}`;

    const liveProofColor = (role) => selectedColor(
      colorSelects.find((select) => select.dataset.customColor === role),
    );

    const syncLiveProof = () => {
      const designName = nameInput?.value.trim() || "Untitled";
      const headerText = headerTextInput?.value.trim() || "";
      const sizeButton = selectedSizeButton();
      const sizeLabel = sizeButton?.dataset.customSizeLabel || "12 × 17 in";
      const price = sizeButton?.dataset.variantPrice || "PRICE PENDING";
      const frontBackground = liveProofColor("front-background");
      const frontArtwork = liveProofColor("front-art");
      const backBackground = liveProofColor("back-background");
      const backArtwork = liveProofColor("back-art");

      renderConstructionProof(backBackground.hex, frontBackground.hex);

      if (liveProofTitle) liveProofTitle.textContent = `${designName} ${customProductTitle}`;
      if (liveProofSize) liveProofSize.textContent = sizeLabel;
      if (liveProofPrice) liveProofPrice.textContent = price;
      proofFrontCaptions.forEach((caption) => {
        caption.textContent = `${frontBackground.name} field / ${frontArtwork.name} artwork`;
      });
      proofBackCaptions.forEach((caption) => {
        caption.textContent = `${backBackground.name} field / ${backArtwork.name} artwork`;
      });
      section.querySelectorAll("[data-custom-live-header-text]").forEach((output) => {
        output.textContent = headerText.toUpperCase();
        output.hidden = !headerText;
      });
      if (liveProofPersonalization) {
        liveProofPersonalization.textContent = headerTextInput?.value.trim()
          ? `Header reads “${headerText}${/[.!?]$/.test(headerText) ? "" : "."}” Front and back artwork, colors, type, and placement update this approval proof live.`
          : "Standard clean header. Optional header text, front and back artwork, colors, type, and placement update this approval proof live.";
      }
    };

    let frontArtworkRenderVersion = 0;
    const frontArtworkAnchors = {
      center: [50, 50],
      "top-left": [0, 0],
      "top-center": [50, 0],
      "top-right": [100, 0],
      "bottom-left": [0, 100],
      "bottom-center": [50, 100],
      "bottom-right": [100, 100],
    };

    const applyFrontArtworkFill = (element, { text = false } = {}) => {
      const flatColor = selectedColor(
        colorSelects.find((select) => select.dataset.customColor === "front-art"),
      ).hex;
      const usesTemplateFieldText = ["offset-signal", "retro-double-stripe"].includes(
        section.dataset.customTemplate,
      );
      const templateTextColor = usesTemplateFieldText
        ? selectedColor(
            colorSelects.find((select) => select.dataset.customColor === "front-background"),
          ).hex
        : flatColor;
      const usesBackTexture = Boolean(frontArtworkBackTexture?.checked);
      element.style.backgroundImage = "none";
      element.style.backgroundRepeat = "no-repeat";
      element.style.backgroundPosition = "center";
      element.style.backgroundSize = "cover";
      if (text) {
        element.style.backgroundClip = "border-box";
        element.style.webkitBackgroundClip = "border-box";
        element.style.color = templateTextColor;
      } else {
        element.style.backgroundColor = flatColor;
      }
      if (!usesBackTexture || (text && usesTemplateFieldText)) return;

      const backSurface = backgroundSurfaceForSide("back");
      const backSurfaceArtwork = surfaceSvgDataUrl(backSurface);
      const backColor = selectedColor(
        colorSelects.find((select) => select.dataset.customColor === "back-background"),
      ).hex;
      if (!backSurfaceArtwork) {
        if (text) element.style.color = backColor;
        else element.style.backgroundColor = backColor;
        return;
      }
      const repeats = backgroundSurfaceRepeats(backSurface);
      const tileSize = materialTilePixels(element, backSurface);
      element.style.backgroundImage = `url("${backSurfaceArtwork}")`;
      element.style.backgroundRepeat = repeats ? "repeat" : "no-repeat";
      element.style.backgroundPosition = repeats ? "0 0" : "center";
      element.style.backgroundSize = repeats
        ? `${tileSize}px ${tileSize}px`
        : "cover";
      if (text) {
        element.style.color = "transparent";
        element.style.backgroundClip = "text";
        element.style.webkitBackgroundClip = "text";
      } else {
        element.style.backgroundColor = backColor;
      }
    };

    const renderFrontArtworkTreatment = () => {
      const treatment = frontArtworkLayout?.value || "single";
      const scale = Math.max(10, Math.min(100, Number(frontArtworkScale?.value) || 32));
      const anchorKey = frontArtworkAnchor?.value || "center";
      const [anchorX, anchorY] = frontArtworkAnchors[anchorKey] || frontArtworkAnchors.center;
      const anchorPosition = `${anchorX}% ${anchorY}%`;
      const source = artworkUrls.front;
      const renderVersion = String(++frontArtworkRenderVersion);

      updateAllContentLayouts();
      section.querySelectorAll('[data-custom-art="front"]').forEach((art) => {
        art.dataset.frontArtLayout = treatment;
        art.dataset.frontRepeatRenderToken = renderVersion;
        applyFrontArtworkFill(art);
        if (!source) {
          setMask(art, "");
          return;
        }
        if (treatment === "single") {
          setMask(art, source);
          art.style.webkitMaskPosition = anchorPosition;
          art.style.maskPosition = anchorPosition;
          return;
        }

        art.style.webkitMaskImage = `url("${source}")`;
        art.style.maskImage = art.style.webkitMaskImage;
        art.style.webkitMaskRepeat = "space";
        art.style.maskRepeat = "space";
        art.style.webkitMaskPosition = anchorPosition;
        art.style.maskPosition = anchorPosition;
        art.style.webkitMaskSize = `${scale}% auto`;
        art.style.maskSize = art.style.webkitMaskSize;
        const renderToken = `${renderVersion}|${treatment}|${source}|${scale}|${anchorKey}`;
        art.dataset.frontRepeatRenderToken = renderToken;
        resolveSpacedRepeatMask(source, treatment).then((asset) => {
          if (art.dataset.frontRepeatRenderToken !== renderToken) return;
          const spacedMask = `url("${asset.dataUrl}")`;
          const cellScale = scale * asset.columns;
          if (treatment === "half-drop") {
            const shiftX = art.clientWidth * scale * 2 / 100;
            const shiftY = art.clientWidth * scale * asset.logoAspect / 100;
            art.style.webkitMaskImage = `${spacedMask}, ${spacedMask}`;
            art.style.maskImage = art.style.webkitMaskImage;
            art.style.webkitMaskRepeat = "repeat, repeat";
            art.style.maskRepeat = "repeat, repeat";
            art.style.webkitMaskPosition = `${anchorPosition}, calc(${anchorX}% + ${shiftX}px) calc(${anchorY}% + ${shiftY}px)`;
            art.style.maskPosition = art.style.webkitMaskPosition;
            art.style.webkitMaskSize = `${cellScale}% auto, ${cellScale}% auto`;
            art.style.maskSize = art.style.webkitMaskSize;
            return;
          }
          art.style.webkitMaskImage = spacedMask;
          art.style.maskImage = spacedMask;
          art.style.webkitMaskRepeat = "repeat";
          art.style.maskRepeat = "repeat";
          art.style.webkitMaskPosition = anchorPosition;
          art.style.maskPosition = anchorPosition;
          art.style.webkitMaskSize = `${cellScale}% auto`;
          art.style.maskSize = art.style.webkitMaskSize;
        }).catch((error) => {
          console.warn("The front artwork repeat could not be prepared; using distributed spacing.", error);
        });
      });
      section.querySelectorAll('[data-custom-text="front"]').forEach((text) => {
        applyFrontArtworkFill(text, { text: true });
      });
      if (frontArtworkScaleOutput) frontArtworkScaleOutput.textContent = `${scale}%`;
      const layoutProperty = propertyInputs.get("front-art-layout");
      const scaleProperty = propertyInputs.get("front-art-scale");
      const anchorProperty = propertyInputs.get("front-art-anchor");
      const fillProperty = propertyInputs.get("front-art-fill");
      if (layoutProperty) layoutProperty.value = frontArtworkLayout?.selectedOptions?.[0]?.textContent || "Single artwork";
      if (scaleProperty) scaleProperty.value = `${scale}%`;
      if (anchorProperty) anchorProperty.value = frontArtworkAnchor?.selectedOptions?.[0]?.textContent || "Centered";
      if (fillProperty) {
        fillProperty.value = frontArtworkBackTexture?.checked
          ? `Selected back-side texture / ${backgroundSurfaceForSide("back")?.name || "Solid color"}`
          : "Flat front artwork color";
      }
      renderForegroundSeparation();
    };

    const updateProofColors = () => {
      const usesTemplateFieldText = ["offset-signal", "retro-double-stripe"].includes(
        section.dataset.customTemplate,
      );
      colorSelects.forEach((select) => {
        const role = select.dataset.customColor;
        const color = selectedColor(select);
        const [side, use] = role.split("-");
        if (use === "background") {
          section.style.setProperty(`--custom-${side}-background`, color.hex);
        }
        if (use === "art") {
          section.querySelectorAll(`[data-custom-art="${side}"]`).forEach((art) => {
            art.style.backgroundColor = color.hex;
          });
          section.querySelectorAll(`[data-custom-text="${side}"]`).forEach((text) => {
            const fieldSelect = colorSelects.find(
              (candidate) => candidate.dataset.customColor === `${side}-background`,
            );
            text.style.color = usesTemplateFieldText ? selectedColor(fieldSelect).hex : color.hex;
          });
        }
        if (use === "pattern") {
          section.querySelectorAll(`[data-custom-pattern="${side}"]`).forEach((pattern) => {
            pattern.style.backgroundColor = color.hex;
          });
        }
        const property = propertyInputs.get(role);
        if (property) property.value = describeColor(color);
      });
      renderForegroundSeparation();
      renderBackground();
      syncLiveProof();
    };

    const standardSecondaryRoles = new Set(["front-art", "front-pattern", "back-background"]);
    const setPaletteOrientation = (orientation) => {
      paletteInverted = orientation;
      const label = orientation === true
        ? "FRONT SECONDARY / BACK PRIMARY"
        : orientation === false
          ? "FRONT PRIMARY / BACK SECONDARY"
          : "CUSTOM COLOR ASSIGNMENT";
      if (paletteOrientationOutput) paletteOrientationOutput.textContent = label;
      if (paletteInvert) paletteInvert.setAttribute("aria-pressed", String(orientation === true));
      const property = propertyInputs.get("palette-orientation");
      if (property) {
        property.value = orientation === true
          ? "Inverted / front secondary / back primary"
          : orientation === false
            ? "Standard / front primary / back secondary"
            : "Custom color assignment";
      }
    };

    const inferPaletteOrientation = () => {
      if (!colorSelects.length || colorSelects.some((select) => select.options.length < 2)) {
        setPaletteOrientation(null);
        return;
      }
      const indices = Object.fromEntries(colorSelects.map((select) => [select.dataset.customColor, select.selectedIndex]));
      const standard = colorSelects.every((select) =>
        indices[select.dataset.customColor] === (standardSecondaryRoles.has(select.dataset.customColor) ? 1 : 0));
      const inverted = colorSelects.every((select) =>
        indices[select.dataset.customColor] === (standardSecondaryRoles.has(select.dataset.customColor) ? 0 : 1));
      setPaletteOrientation(standard ? false : inverted ? true : null);
    };

    const invertPaletteColors = () => {
      colorSelects.forEach((select) => {
        if (select.options.length < 2) return;
        if (select.selectedIndex === 0) select.selectedIndex = 1;
        else if (select.selectedIndex === 1) select.selectedIndex = 0;
      });
      inferPaletteOrientation();
      updateProofColors();
    };

    const updatePaletteNote = (palette) => {
      const statusCopy = {
        documented: "Pantone names are documented in the connected source proof.",
        "named-spot": "A named spot color is present; production Pantone mapping still requires review.",
        screen: "Screen-reference colors only. Confirm current brand standards, usage rights, and any required Pantone production match before printing.",
      };
      if (paletteNote) {
        paletteNote.textContent = `${palette.group ? `${palette.group} / ` : ""}${statusCopy[palette.status] || statusCopy.screen}`;
      }
    };

    const loadPalette = (paletteId) => {
      const palette = palettes.find((candidate) => candidate.id === paletteId) || palettes[0];
      if (!palette || palette.colors.length < 2) return;
      activePaletteId = palette.id;
      colorSelects.forEach((select) => {
        select.replaceChildren();
        palette.colors.forEach((color) => {
          const option = document.createElement("option");
          option.value = color.hex;
          option.textContent = describeColor(color);
          option.dataset.name = color.name;
          option.dataset.hex = color.hex;
          option.dataset.pantone = color.pantone;
          select.append(option);
        });
        const role = select.dataset.customColor;
        select.selectedIndex = role === "front-art" || role === "front-pattern" || role === "back-background" ? 1 : 0;
      });
      setPaletteOrientation(false);
      updatePaletteNote(palette);
      const paletteProperty = propertyInputs.get("palette");
      if (paletteProperty) {
        paletteProperty.value = `${palette.name} / ${palette.status}`;
      }
      updateProofColors();
    };

    const refreshPaletteOptions = ({ preserve = true, preferred = "" } = {}) => {
      if (!paletteSelect) return;
      // Filtering is a browsing action. Keep the active custom palette available.
      const retained = palettes.find((palette) => palette.id === (preferred || activePaletteId));
      const current = preferred || (preserve ? paletteSelect.value : "") || (retained?.group === "Custom brand" ? retained.id : "");
      const group = paletteGroup?.value || "all";
      const query = paletteSearch?.value.trim().toLowerCase() || "";
      const filtered = palettes.filter((palette) =>
        (group === "all" || palette.group === group) &&
        (!query || `${palette.name} ${palette.group || ""}`.toLowerCase().includes(query)));
      if (retained?.group === "Custom brand" && !filtered.some((palette) => palette.id === retained.id)) filtered.unshift(retained);
      paletteSelect.replaceChildren();
      const groups = new Map();
      filtered.forEach((palette) => {
        const key = palette.group || "Reference";
        if (!groups.has(key)) {
          const optgroup = document.createElement("optgroup");
          optgroup.label = key;
          groups.set(key, optgroup);
          paletteSelect.append(optgroup);
        }
        const option = document.createElement("option");
        option.value = palette.id;
        option.textContent = palette.name;
        groups.get(key).append(option);
      });
      if (filtered.some((palette) => palette.id === current)) paletteSelect.value = current;
      else if (filtered[0]) paletteSelect.value = filtered[0].id;
      if (filtered[0]) {
        if (paletteSelect.value !== activePaletteId) loadPalette(paletteSelect.value);
        else updatePaletteNote(palettes.find((palette) => palette.id === activePaletteId));
      } else if (paletteNote) paletteNote.textContent = "No reference palettes match this search.";
    };

    const mergePaletteLibrary = (library) => {
      const records = Array.isArray(library?.palettes) ? library.palettes : [];
      const curatedIds = new Set(palettes.map((palette) => palette.id));
      palettes = [...palettes, ...records.filter((palette) =>
        palette?.id && palette?.name && Array.isArray(palette.colors) && palette.colors.length > 1 && !curatedIds.has(palette.id))];
      refreshPaletteOptions({ preserve: false, preferred: activePaletteId || defaultPaletteId });
    };

    const hydratePaletteLibrary = async () => {
      const url = section.dataset.teamPaletteUrl;
      if (!url) return refreshPaletteOptions({ preserve: false, preferred: activePaletteId || defaultPaletteId });
      try {
        const response = await fetch(url, { credentials: "same-origin" });
        if (!response.ok) throw new Error(`Palette library request failed: ${response.status}`);
        mergePaletteLibrary(await response.json());
      } catch (error) {
        console.warn("The extended Gameday palette library could not be loaded.", error);
        refreshPaletteOptions({ preserve: false, preferred: activePaletteId || defaultPaletteId });
      }
    };

    const populateBackgroundSurfaces = () => {
      if (!backgroundSurfaceSelects.length) return;
      backgroundSurfaceSelects.forEach((select) => {
        const current = select.value || "solid";
        select.replaceChildren();
        const groups = new Map();
        backgroundSurfaces.forEach((surface) => {
          const key = surface.group || "Backgrounds";
          if (!groups.has(key)) {
            const optgroup = document.createElement("optgroup");
            optgroup.label = key;
            groups.set(key, optgroup);
            select.append(optgroup);
          }
          const option = document.createElement("option");
          option.value = surface.id;
          option.textContent = surface.name;
          groups.get(key).append(option);
        });
        select.value = backgroundSurfaces.some((surface) => surface.id === current) ? current : "solid";
      });
      renderBackground();
      renderBackgroundCatalog();
    };

    const hydrateBackgroundLibrary = async () => {
      const url = section.dataset.backgroundLibraryUrl;
      if (!url) return populateBackgroundSurfaces();
      try {
        const response = await fetch(url, { credentials: "same-origin" });
        if (!response.ok) throw new Error(`Background library request failed: ${response.status}`);
        const payload = await response.json();
        if (Array.isArray(payload?.surfaces) && payload.surfaces.length) backgroundSurfaces = payload.surfaces;
      } catch (error) {
        console.warn("The Gameday background library could not be loaded.", error);
      }
      populateBackgroundSurfaces();
    };

    const applyCustomBrandPalette = () => {
      const primaryHex = normalizeCustomHex(brandHexInputs.get("primary")?.value, "#383838");
      const secondaryHex = normalizeCustomHex(brandHexInputs.get("secondary")?.value, "#FFFFFF");
      const label = brandName?.value.trim() || "Custom brand";
      const matchMethodLabel = brandMatchMethod?.selectedOptions?.[0]?.textContent?.trim() || "HEX / RGB screen reference";
      const palette = {
        id: `custom-brand-${Date.now()}`,
        name: label,
        group: "Custom brand",
        status: "screen",
        colors: [
          { name: `${label} primary`, hex: primaryHex, rgb: customHexToRgb(primaryHex), pantone: brandPantoneInputs.get("primary")?.value.trim() || "" },
          { name: `${label} secondary`, hex: secondaryHex, rgb: customHexToRgb(secondaryHex), pantone: brandPantoneInputs.get("secondary")?.value.trim() || "" },
        ],
      };
      palettes = [palette, ...palettes.filter((candidate) => candidate.group !== "Custom brand")];
      // A custom label is not a team-search query; retain the library being browsed.
      if (paletteSearch) paletteSearch.value = "";
      refreshPaletteOptions({ preserve: false, preferred: palette.id });
      const reference = propertyInputs.get("brand-color-reference");
      if (reference) {
        reference.value = `${label} / ${matchMethodLabel} / ${primaryHex} / RGB ${customHexToRgb(primaryHex)}${palette.colors[0].pantone ? ` / Pantone ${palette.colors[0].pantone}` : ""} + ${secondaryHex} / RGB ${customHexToRgb(secondaryHex)}${palette.colors[1].pantone ? ` / Pantone ${palette.colors[1].pantone}` : ""}`;
      }
      const matchMethodProperty = propertyInputs.get("color-match-method");
      if (matchMethodProperty) matchMethodProperty.value = `${matchMethodLabel} / production proof required`;
    };

    paletteSelect?.addEventListener("change", () => loadPalette(paletteSelect.value));
    paletteGroup?.addEventListener("change", () => refreshPaletteOptions({ preserve: false }));
    paletteSearch?.addEventListener("input", () => refreshPaletteOptions());
    const syncBrandHex = (input, key) => {
      const hex = normalizeCustomHex(input.value, key === "primary" ? "#383838" : "#FFFFFF");
      const rgbInput = brandRgbInputs.get(key);
      if (rgbInput) rgbInput.value = customHexToRgb(hex);
    };
    const syncBrandRgb = (input, key) => {
      const hexInput = brandHexInputs.get(key);
      const hex = customRgbToHex(input.value, hexInput?.value || (key === "primary" ? "#383838" : "#FFFFFF"));
      if (hexInput) hexInput.value = hex;
    };
    brandHexInputs.forEach((input, key) => {
      input.addEventListener("input", () => syncBrandHex(input, key));
      input.addEventListener("change", () => {
        input.value = normalizeCustomHex(input.value, key === "primary" ? "#383838" : "#FFFFFF");
        syncBrandHex(input, key);
      });
    });
    brandRgbInputs.forEach((input, key) => {
      input.addEventListener("input", () => syncBrandRgb(input, key));
      input.addEventListener("change", () => {
        const hexInput = brandHexInputs.get(key);
        const hex = customRgbToHex(input.value, hexInput?.value || (key === "primary" ? "#383838" : "#FFFFFF"));
        input.value = customHexToRgb(hex);
        if (hexInput) hexInput.value = hex;
      });
    });
    brandMatchMethod?.addEventListener("change", () => {
      const property = propertyInputs.get("color-match-method");
      if (property) {
        property.value = `${brandMatchMethod.selectedOptions?.[0]?.textContent?.trim() || "HEX / RGB screen reference"} / production proof required`;
      }
    });
    brandApply?.addEventListener("click", applyCustomBrandPalette);
    paletteInvert?.addEventListener("click", invertPaletteColors);
    colorSelects.forEach((select) => select.addEventListener("change", () => {
      inferPaletteOrientation();
      updateProofColors();
    }));
    fontSelect?.addEventListener("change", () => {
      applyActiveFont();
      updateAllContentLayouts();
    });
    fontUpload?.addEventListener("change", async () => {
      clearCustomFont();
      const file = fontUpload.files?.[0];
      if (!file) {
        if (fontUploadStatus) {
          fontUploadStatus.textContent =
            "WOFF2 preferred. WOFF, TTF, or OTF accepted. One file, 2 MB maximum.";
        }
        applyActiveFont();
        updateAllContentLayouts();
        syncSubmit();
        return;
      }

      const extension = file.name.toLowerCase().match(/\.(woff2?|ttf|otf)$/)?.[0] || "";
      if (!extension) {
        fontUpload.value = "";
        if (fontUploadStatus) {
          fontUploadStatus.textContent = "Use one WOFF2, WOFF, TTF, or OTF font file.";
        }
        applyActiveFont();
        syncSubmit();
        return;
      }
      if (file.size > 2 * 1024 * 1024) {
        fontUpload.value = "";
        if (fontUploadStatus) {
          fontUploadStatus.textContent = "This file is over 2 MB. Upload a smaller font file.";
        }
        applyActiveFont();
        syncSubmit();
        return;
      }
      if (typeof FontFace === "undefined" || !document.fonts) {
        fontUpload.value = "";
        if (fontUploadStatus) {
          fontUploadStatus.textContent = "This browser cannot preview a custom font file.";
        }
        applyActiveFont();
        syncSubmit();
        return;
      }

      fontUploadPending = true;
      if (fontRightsWrap) fontRightsWrap.hidden = false;
      if (fontUploadStatus) fontUploadStatus.textContent = `Checking ${file.name}...`;
      syncSubmit();
      const family = `GamedayCustom${configurationId.replace(/[^A-Za-z0-9]/g, "")}`;
      fontReadPromise = readBlobAsDataUrl(file);
      try {
        const dataUrl = await fontReadPromise;
        const face = new FontFace(family, `url("${dataUrl}")`, {
          style: "normal",
          weight: "400",
        });
        await face.load();
        document.fonts.add(face);
        customFontFace = face;
        customFontFamily = family;
        customFontDataUrl = dataUrl;
        customFontFileName = file.name;
        if (fontUploadStatus) {
          fontUploadStatus.textContent = `${file.name} / live proof preview / production review required`;
        }
      } catch (error) {
        clearCustomFont();
        fontUpload.value = "";
        if (fontUploadStatus) {
          fontUploadStatus.textContent =
            error?.message || "This font file could not be loaded for preview.";
        }
      } finally {
        fontUploadPending = false;
        applyActiveFont();
        updateAllContentLayouts();
        syncSubmit();
      }
    });

    nameInput?.addEventListener("input", () => {
      if (proofName) proofName.textContent = nameInput.value.trim() || "UNTITLED CUSTOM FLAG";
      syncLiveProof();
    });
    headerTextInput?.addEventListener("input", syncLiveProof);
    textInputs.forEach((input) => {
      input.addEventListener("input", () => {
        syncLetterHeightControls();
        updateAllContentLayouts();
      });
    });
    placementInputs.forEach((input) => {
      updatePlacementOutput(input);
      input.addEventListener("input", () => {
        if (input.dataset.customPlacement === "text-height") {
          input.dataset.customHeightTouched = "true";
        }
        updatePlacementOutput(input);
        updateSideContentLayout(input.dataset.customPlacementSide);
      });
    });
    window.addEventListener("resize", updateAllContentLayouts, { passive: true });

    uploads.forEach((input) => {
      input.addEventListener("change", () => {
        activateCustomUpload();
        const side = input.dataset.customUpload;
        const status = section.querySelector(`[data-upload-status="${side}"]`);
        clearArtworkState(side);
        const file = input.files?.[0];
        if (!file) {
          if (status) status.textContent = side === "back"
            ? "Leave empty to create a readable reverse from the front artwork."
            : "SVG previews live. PDF, AI, and EPS are attached for review.";
          renderArtwork();
          return;
        }
        if (file.size > 10 * 1024 * 1024) {
          input.value = "";
          if (status) status.textContent = "File is over 10 MB. Please upload a smaller production file.";
          renderArtwork();
          return;
        }
        const isSvg = file.type === "image/svg+xml" || file.name.toLowerCase().endsWith(".svg");
        artworkFileNames[side] = file.name;
        if (isSvg) artworkUrls[side] = URL.createObjectURL(file);
        artworkReadPromises[side] = new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.addEventListener("load", () => {
            artworkDataUrls[side] = String(reader.result || "");
            resolve();
          });
          reader.addEventListener("error", () => {
            reject(new Error(`${file.name} could not be read for the saved project.`));
          });
          reader.readAsDataURL(file);
        });
        if (status) {
          status.textContent = isSvg
            ? `${file.name} / live placement preview`
            : `${file.name} / attached for production review; browser preview unavailable`;
        }
        renderArtwork();
      });
    });
    stockDesignButtons.forEach((button) => {
      button.addEventListener("click", () => selectStockDesign(button));
    });
    stockUploadButton?.addEventListener("click", () => {
      activateCustomUpload({ clearArtwork: true });
      const frontStatus = section.querySelector('[data-upload-status="front"]');
      const backStatus = section.querySelector('[data-upload-status="back"]');
      if (frontStatus) frontStatus.textContent = "SVG previews live. PDF, AI, and EPS are attached for review.";
      if (backStatus) backStatus.textContent = "Leave empty to create a readable reverse from the front artwork.";
    });
    [...backgroundSurfaceSelects, backgroundMotif, backgroundLayout, backgroundScale, backgroundAnchor].forEach((control) => {
      control?.addEventListener("input", renderBackground);
      control?.addEventListener("change", renderBackground);
    });
    backgroundChoiceButtons.forEach((button) => {
      button.addEventListener("click", () => openBackgroundCatalog(button.dataset.customBackgroundOpen));
    });
    backgroundCatalogSideButtons.forEach((button) => {
      button.addEventListener("click", () => {
        setBackgroundCatalogSide(button.dataset.customBackgroundCatalogSide);
        renderBackgroundCatalog();
      });
    });
    backgroundCatalogCategories?.addEventListener("click", (event) => {
      const button = event.target.closest("[data-custom-background-category]");
      if (!button) return;
      backgroundCatalogCategory = button.dataset.customBackgroundCategory || "All";
      renderBackgroundCatalog();
    });
    backgroundCatalogGrid?.addEventListener("click", (event) => {
      const card = event.target.closest("[data-custom-background-surface-choice]");
      if (!card) return;
      applyBackgroundSurface(backgroundCatalogSide, card.dataset.customBackgroundSurfaceChoice);
    });
    backgroundCatalogSearch?.addEventListener("input", renderBackgroundCatalog);
    backgroundCatalogCancelButtons.forEach((button) => {
      button.addEventListener("click", () => closeBackgroundCatalog({ restore: true }));
    });
    backgroundCatalogApply?.addEventListener("click", () => closeBackgroundCatalog());
    backgroundCopyFront?.addEventListener("click", () => {
      const surfaceId = backgroundSurfaceBySide.front?.value || "solid";
      applyBackgroundSurface("back", surfaceId, { linked: false });
      setBackgroundCatalogSide("back");
      renderBackgroundCatalog();
    });
    backgroundSwap?.addEventListener("click", () => {
      const front = backgroundSurfaceBySide.front?.value || "solid";
      const back = backgroundSurfaceBySide.back?.value || "solid";
      if (backgroundSurfaceBySide.front) backgroundSurfaceBySide.front.value = back;
      if (backgroundSurfaceBySide.back) backgroundSurfaceBySide.back.value = front;
      renderBackground();
      renderBackgroundCatalog();
    });
    backgroundCatalog?.addEventListener("cancel", (event) => {
      event.preventDefault();
      closeBackgroundCatalog({ restore: true });
    });
    backgroundCatalog?.addEventListener("click", (event) => {
      if (event.target === backgroundCatalog) closeBackgroundCatalog({ restore: true });
    });
    if ("ResizeObserver" in window && stage) {
      const materialScaleObserver = new ResizeObserver(() => renderBackground());
      materialScaleObserver.observe(stage);
    }
    [foregroundSeparation, foregroundBorderColor].forEach((control) => {
      control?.addEventListener("input", renderForegroundSeparation);
      control?.addEventListener("change", renderForegroundSeparation);
    });
    [frontArtworkLayout, frontArtworkAnchor, frontArtworkBackTexture].forEach((control) => {
      control?.addEventListener("input", renderFrontArtworkTreatment);
      control?.addEventListener("change", renderFrontArtworkTreatment);
    });
    frontArtworkScale?.addEventListener("input", renderFrontArtworkTreatment);
    frontArtworkScale?.addEventListener("change", renderFrontArtworkTreatment);

    const projectRecipe = () => ({
      type: "gameday-custom-flag-v7",
      proPhotos:proPhotos?.recipe(),
      configurationId,
      productHandle: "custom-gameday-flag",
      name: nameInput?.value.trim() || "Untitled custom flag",
      variant: {
        id: selectedSizeButton()?.dataset.variantId || "",
        sku: selectedSizeButton()?.dataset.variantSku || "",
        size: selectedSizeButton()?.dataset.customSize || "12x17",
      },
      palette: (() => {
        const active = palettes.find((candidate) => candidate.id === activePaletteId);
        return {
          id: active?.id || paletteSelect?.value || "",
          name: active?.name || "Custom palette",
          group: active?.group || "Reference",
          status: active?.status || "screen",
          colors: active?.colors || [],
          inverted: paletteInverted === true,
          orientation: propertyInputs.get("palette-orientation")?.value || "Custom color assignment",
          colorMatchMethod: brandMatchMethod?.value || "hex",
          brandName: brandName?.value.trim() || "",
          brandColorReference: propertyInputs.get("brand-color-reference")?.value || "",
        };
      })(),
      foreground: {
        artwork: propertyInputs.get("stock-design")?.value || "Custom upload",
        rights: propertyInputs.get("artwork-source-rights")?.value || "",
        front: { name: artworkFileNames.front, dataUrl: artworkDataUrls.front },
        back: { name: artworkFileNames.back, dataUrl: artworkDataUrls.back },
        mirrorBack: Boolean(mirror?.checked),
        layout: frontArtworkLayout?.value || "single",
        repeatScale: Number(frontArtworkScale?.value) || 32,
        anchor: frontArtworkAnchor?.value || "center",
        useBackTexture: Boolean(frontArtworkBackTexture?.checked),
      },
      background: {
        surface: backgroundSurfaceBySide.front?.value || "solid",
        frontSurface: backgroundSurfaceBySide.front?.value || "solid",
        backSurface: backgroundSurfaceBySide.back?.value || "solid",
        motif: backgroundMotif?.value || "solid",
        layout: backgroundLayout?.value || "solid",
        scale: Number(backgroundScale?.value) || 28,
        anchor: backgroundAnchor?.value || "center",
      },
      separation: {
        strength: foregroundSeparation?.value || "none",
        color: foregroundBorderColor?.value || "auto",
      },
      colors: Object.fromEntries(colorSelects.map((select) => [select.dataset.customColor, selectedColor(select)])),
      text: Object.fromEntries(textInputs.map((input) => [input.dataset.customTextInput, input.value])),
      headerPersonalization: headerTextInput?.value || "",
      placement: Object.fromEntries(placementInputs.map((input) => [
        `${input.dataset.customPlacementSide}-${input.dataset.customPlacement}`,
        input.value,
      ])),
      savedAt: new Date().toISOString(),
    });

    const applyProjectRecipe = async (recipe) => {
      if (!recipe || !["gameday-custom-flag-v2", "gameday-custom-flag-v3", "gameday-custom-flag-v4", "gameday-custom-flag-v5", "gameday-custom-flag-v6", "gameday-custom-flag-v7"].includes(recipe.type)) throw new Error("This saved project is not a Gameday flag.");
      if (nameInput) { nameInput.value = recipe.name || "Saved custom flag"; nameInput.dispatchEvent(new Event("input", { bubbles: true })); }
      const sizeButton = sizeButtons.find((button) => button.dataset.customSize === recipe.variant?.size);
      if (sizeButton) selectSize(sizeButton);
      if(proPhotos)await proPhotos.restore(recipe.proPhotos);
      const savedPalette = recipe.palette;
      if (savedPalette?.id && Array.isArray(savedPalette.colors) && savedPalette.colors.length >= 2) {
        const restoredPalette = {
          id: savedPalette.id,
          name: savedPalette.name || "Saved custom palette",
          group: savedPalette.group || "Custom brand",
          status: savedPalette.status || "screen",
          colors: savedPalette.colors,
        };
        palettes = [restoredPalette, ...palettes.filter((candidate) => candidate.id !== restoredPalette.id)];
        if (paletteGroup) paletteGroup.value = "all";
        if (paletteSearch) paletteSearch.value = "";
        refreshPaletteOptions({ preserve: false });
        if (paletteSelect) paletteSelect.value = restoredPalette.id;
        loadPalette(restoredPalette.id);
      } else if (savedPalette?.id && palettes.some((candidate) => candidate.id === savedPalette.id)) {
        if (paletteSelect) paletteSelect.value = savedPalette.id;
        loadPalette(savedPalette.id);
      }
      if (brandName) brandName.value = savedPalette?.brandName || "";
      if (brandMatchMethod) brandMatchMethod.value = savedPalette?.colorMatchMethod || "hex";
      ["primary", "secondary"].forEach((key, index) => {
        const savedColor = savedPalette?.colors?.[index];
        if (!savedColor) return;
        const hex = normalizeCustomHex(savedColor.hex, index === 0 ? "#383838" : "#FFFFFF");
        if (brandHexInputs.get(key)) brandHexInputs.get(key).value = hex;
        if (brandRgbInputs.get(key)) brandRgbInputs.get(key).value = customHexToRgb(hex);
        if (brandPantoneInputs.get(key)) brandPantoneInputs.get(key).value = savedColor.pantone || "";
      });
      const brandReference = propertyInputs.get("brand-color-reference");
      if (brandReference) brandReference.value = savedPalette?.brandColorReference || "";
      const matchMethodProperty = propertyInputs.get("color-match-method");
      if (matchMethodProperty) {
        matchMethodProperty.value = `${brandMatchMethod?.selectedOptions?.[0]?.textContent?.trim() || "HEX / RGB screen reference"} / production proof required`;
      }
      for (const side of ["front", "back"]) {
        clearArtworkState(side);
        const saved = recipe.foreground?.[side] || {};
        artworkDataUrls[side] = saved.dataUrl || "";
        artworkUrls[side] = saved.dataUrl || "";
        artworkFileNames[side] = saved.name || "";
      }
      const artworkChoice = recipe.foreground?.artwork || "Custom upload";
      const stockButton = stockDesignButtons.find((button) =>
        artworkChoice.endsWith(`/ ${button.dataset.stockDesignId}`));
      if (stockButton) {
        setStockDesignButtonState(stockButton);
        if (stockDesignStatus) {
          stockDesignStatus.textContent = `STOCK / ${(stockButton.dataset.stockDesignName || "GAMEDAY ARTWORK").toUpperCase()}`;
        }
      } else {
        activateCustomUpload();
        await Promise.all(["front", "back"].map((side) =>
          restoreSavedUpload(side, recipe.foreground?.[side])));
      }
      const stockProperty = propertyInputs.get("stock-design");
      const rightsProperty = propertyInputs.get("artwork-source-rights");
      if (stockProperty) stockProperty.value = artworkChoice;
      if (rightsProperty) rightsProperty.value = recipe.foreground?.rights || "";
      if (mirror) mirror.checked = Boolean(recipe.foreground?.mirrorBack);
      if (frontArtworkLayout) frontArtworkLayout.value = recipe.foreground?.layout || "single";
      if (frontArtworkScale) frontArtworkScale.value = String(recipe.foreground?.repeatScale || 32);
      if (frontArtworkAnchor) frontArtworkAnchor.value = recipe.foreground?.anchor || "center";
      if (frontArtworkBackTexture) frontArtworkBackTexture.checked = Boolean(recipe.foreground?.useBackTexture);
      if (backgroundSurfaceBySide.front) {
        backgroundSurfaceBySide.front.value = recipe.background?.frontSurface || recipe.background?.surface || "solid";
      }
      if (backgroundSurfaceBySide.back) {
        backgroundSurfaceBySide.back.value = recipe.background?.backSurface || recipe.background?.surface || "solid";
      }
      if (backgroundMotif) backgroundMotif.value = recipe.background?.motif || "solid";
      if (backgroundLayout) backgroundLayout.value = recipe.background?.layout || "solid";
      if (backgroundScale) backgroundScale.value = String(recipe.background?.scale || 28);
      if (backgroundAnchor) backgroundAnchor.value = recipe.background?.anchor || "center";
      if (foregroundSeparation) foregroundSeparation.value = recipe.separation?.strength || "none";
      if (foregroundBorderColor) foregroundBorderColor.value = recipe.separation?.color || "auto";
      colorSelects.forEach((select) => {
        const hex = recipe.colors?.[select.dataset.customColor]?.hex;
        const option = [...select.options].find((candidate) => candidate.dataset.hex === hex);
        if (option) select.value = option.value;
      });
      inferPaletteOrientation();
      textInputs.forEach((input) => { input.value = recipe.text?.[input.dataset.customTextInput] || ""; input.dispatchEvent(new Event("input", { bubbles: true })); });
      if (headerTextInput) {
        headerTextInput.value = recipe.headerPersonalization || "";
        headerTextInput.dispatchEvent(new Event("input", { bubbles: true }));
      }
      placementInputs.forEach((input) => {
        const key = `${input.dataset.customPlacementSide}-${input.dataset.customPlacement}`;
        if (recipe.placement?.[key] != null) input.value = recipe.placement[key];
        updatePlacementOutput(input);
      });
      updateProofColors();
      renderArtwork();
    };

    const saveProject = async ({ button = projectSaveButton, status = projectStatus } = {}) => {if(proPhotos?.busy()){if(status)status.textContent='Please wait for photo uploads to finish.';return false;}
      if (button) button.disabled = true;
      if (status) status.textContent = "Saving artwork and configuration...";
      try {
        await Promise.all([artworkReadPromises.front, artworkReadPromises.back]);
        window.GamedayProPackage.assertSaveSize(projectRecipe());
        const response = await fetch("/apps/exo-projects/projects", {
          method: "POST",
          headers: { "content-type": "application/json", accept: "application/json" },
          body: JSON.stringify({ name: nameInput?.value.trim() || "Untitled custom flag", payload: projectRecipe() }),
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) {
          const message = [401, 403].includes(response.status)
            ? "Sign in to your Shopify customer account, then save this flag again."
            : result.error || "The project could not be saved.";
          throw new Error(message);
        }
        if (status) status.textContent = `Saved / revision ${result.project?.revision || 1}`;
        return true;
      } catch (error) {
        if (status) status.textContent = error?.message || "The project could not be saved.";
        return false;
      } finally {
        if (button) button.disabled = false;
      }
    };

    projectSaveButton?.addEventListener("click", () => saveProject());

    let accountPopup = null;
    let accountPopupPoll = null;
    let accountSaveAuthorized = false;
    const closeAccountDialog = () => {
      accountSaveAuthorized = false;
      if (!accountDialog?.open) return;
      accountDialog.close();
    };
    const openAccountDialog = () => {
      if (!accountDialog) return;
      if (accountStatus) accountStatus.textContent = "Your current design will remain open while you sign in.";
      accountDialog.showModal();
    };
    accountOpenButton?.addEventListener("click", openAccountDialog);
    accountCloseButton?.addEventListener("click", closeAccountDialog);
    accountDialog?.addEventListener("cancel", (event) => {
      event.preventDefault();
      closeAccountDialog();
    });
    accountDialog?.addEventListener("click", (event) => {
      if (event.target === accountDialog) closeAccountDialog();
    });
    accountSaveButton?.addEventListener("click", async () => {
      const saved = await saveProject({ button: accountSaveButton, status: accountStatus });
      if (saved) window.setTimeout(closeAccountDialog, 700);
    });

    const saveAfterAccountReturn = async () => {
      if (!accountSaveAuthorized) return;
      accountSaveAuthorized = false;
      if (accountStatus) accountStatus.textContent = "Account connected. Saving your flag...";
      const saved = await saveProject({ button: accountSaveButton, status: accountStatus });
      if (saved) window.setTimeout(closeAccountDialog, 700);
    };
    accountLaunchButton?.addEventListener("click", () => {
      const loginUrl = accountLaunchButton.dataset.accountLoginUrl || accountLaunchButton.href;
      accountSaveAuthorized = true;
      accountPopup = window.open(loginUrl, "exo-gameday-account", "popup=yes,width=560,height=760,resizable=yes,scrollbars=yes");
      if (!accountPopup) {
        accountSaveAuthorized = false;
        if (accountStatus) accountStatus.textContent = "Your browser blocked the account window. Allow popups and try again.";
        return;
      }
      if (accountStatus) accountStatus.textContent = "Sign in in the account window. This design will stay here.";
      window.clearInterval(accountPopupPoll);
      accountPopupPoll = window.setInterval(() => {
        if (accountPopup && !accountPopup.closed) return;
        window.clearInterval(accountPopupPoll);
        accountPopupPoll = null;
        saveAfterAccountReturn();
      }, 700);
    });
    window.addEventListener("message", (event) => {
      if (
        !accountSaveAuthorized ||
        event.source !== accountPopup ||
        event.origin !== window.location.origin ||
        event.data?.type !== "exo-gameday-account-ready"
      ) return;
      window.clearInterval(accountPopupPoll);
      accountPopupPoll = null;
      saveAfterAccountReturn();
    });

    projectListButton?.addEventListener("click", async () => {
      projectListButton.disabled = true;
      if (projectStatus) projectStatus.textContent = "Loading saved flags…";
      try {
        const response = await fetch("/apps/exo-projects/projects", { headers: { accept: "application/json" } });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error || "Saved flags could not be loaded.");
        const projects = (result.projects || []).filter((project) =>
          ["gameday-custom-flag-v2", "gameday-custom-flag-v3", "gameday-custom-flag-v4", "gameday-custom-flag-v5", "gameday-custom-flag-v6", "gameday-custom-flag-v7"].includes(project.payload?.type));
        if (!projects.length) throw new Error("No saved Gameday flags yet.");
        const labels = projects.map((project, index) => `${index + 1}. ${project.name} / rev ${project.revision}`).join("\n");
        const choice = Number(window.prompt(`Choose a saved flag:\n${labels}`, "1"));
        if (!Number.isInteger(choice) || !projects[choice - 1]) return;
        await applyProjectRecipe(projects[choice - 1].payload);
        if (projectStatus) projectStatus.textContent = `Loaded / ${projects[choice - 1].name}`;
      } catch (error) {
        if (projectStatus) projectStatus.textContent = error?.message || "Saved flags could not be loaded.";
      } finally { projectListButton.disabled = false; }
    });
    mirror?.addEventListener("change", () => {
      const backTreatment = propertyInputs.get("back-treatment");
      if (backTreatment) {
        backTreatment.value = mirror.checked
          ? "Readable reverse from front artwork when no back file is supplied"
          : "Separate back artwork required";
      }
      renderArtwork();
    });
    sizeButtons.forEach((button) =>
      button.addEventListener("click", () => selectSize(button)));
    sideButtons.forEach((button) =>
      button.addEventListener("click", () => selectSide(button.dataset.customSide)));
    rights?.addEventListener("change", syncSubmit);
    batch?.addEventListener("change", syncSubmit);
    fontRights?.addEventListener("change", syncSubmit);
    nameInput?.addEventListener("input", syncSubmit);
    // Configuration PDF is handled by the shared read-only export controller.
    if(liveProofPrint)liveProofPrint.textContent='Save configuration PDF ↓';


    const escapeXml = (value) =>
      String(value || "")
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&apos;");

    const resolveProofFont = async () => {
      await fontReadPromise;
      const font = activeFont();
      let dataUrl = font.dataUrl;
      if (!dataUrl && font.assetUrl) {
        dataUrl = fontAssetDataUrls.get(font.assetUrl) || "";
        if (!dataUrl) {
          const response = await fetch(font.assetUrl, { credentials: "same-origin" });
          if (!response.ok) throw new Error(`${font.label} could not be embedded in the cart proof.`);
          dataUrl = await readBlobAsDataUrl(await response.blob());
          fontAssetDataUrls.set(font.assetUrl, dataUrl);
        }
      }
      const embeddedFamily = dataUrl
        ? font.family.replace(/[^A-Za-z0-9 _-]/g, "").trim() || "GamedayProofFont"
        : font.family;
      const styleMarkup = dataUrl
        ? `<style>@font-face{font-family:'${escapeXml(embeddedFamily)}';src:url('${dataUrl}');font-style:normal;font-weight:${escapeXml(font.weight)};}</style>`
        : "";
      return { ...font, family: embeddedFamily, styleMarkup };
    };

    const generateProofFile = async (snapshotOnly = false, exportLogoUrl = "") => {
      if (
        !proofFileInputs.combined ||
        !proofFileInputs.front ||
        !proofFileInputs.back ||
        typeof DataTransfer === "undefined"
      ) {
        throw new Error("This browser cannot attach the front and back cart proofs.");
      }
      await Promise.all([artworkReadPromises.front, artworkReadPromises.back]);
      const proofFont = await resolveProofFont();
      let brandLogoDataUrl = "";
      const brandLogoUrl = (snapshotOnly && exportLogoUrl) || section.dataset.customBrandLogoUrl || "";
      if (brandLogoUrl) {
        try {
          brandLogoDataUrl = fontAssetDataUrls.get(brandLogoUrl) || "";
          if (!brandLogoDataUrl) {
            const response = await fetch(brandLogoUrl, { credentials: "same-origin" });
            if (response.ok) {
              brandLogoDataUrl = await readBlobAsDataUrl(await response.blob());
              fontAssetDataUrls.set(brandLogoUrl, brandLogoDataUrl);
            }
          }
        } catch (error) {
          console.warn("The Gameday logo could not be embedded in the Live Proof.", error);
        }
      }
      const sizeButton = selectedSizeButton();
      const sizeId = sizeButton?.dataset.customSize || "12x17";
      const sizeLabel = sizeButton?.dataset.customSizeLabel || sizeId;
      const physicalFlagWidthInches = Math.max(
        1,
        Number(sizeButton?.dataset.customWidthIn) || 17,
      );
      const sku = sizeButton?.dataset.variantSku || "SKU PENDING";
      const geometry = approvedGeometryForSize(sizeId);
      if (!geometry?.path) throw new Error("The selected flag perimeter is unavailable.");

      const colors = Object.fromEntries(
        colorSelects.map((select) => [
          select.dataset.customColor,
          selectedColor(select).hex,
        ]),
      );
      const frontEnteredText =
        section.querySelector('[data-custom-text-input="front"]')?.value.trim() || "";
      const backEnteredText =
        section.querySelector('[data-custom-text-input="back"]')?.value.trim() ||
        (mirror?.checked ? frontEnteredText : "");
      const frontArt = artworkDataUrls.front;
      const backArt =
        artworkDataUrls.back || (mirror?.checked ? artworkDataUrls.front : "");
      const proofName = nameInput?.value.trim() || "Untitled custom flag";
      const proofHeaderText = headerTextInput?.value.trim() || "";
      const proofSurfaces = {
        front: backgroundSurfaceForSide("front"),
        back: backgroundSurfaceForSide("back"),
      };
      const proofSurfaceArtwork = {
        front: await resolveProofSurfaceArtwork(proofSurfaces.front),
        back: await resolveProofSurfaceArtwork(proofSurfaces.back),
      };
      const flagWidth = 650;
      const flagHeight = flagWidth / Number(geometry.aspect || 1.5);
      const flagY = 250;
      const patternMotif = backgroundMotif?.value || "solid";
      const patternLayout = backgroundLayout?.value || "solid";
      const patternScale = Math.max(3, Math.min(80, Number(backgroundScale?.value) || 28));
      const patternAnchor = backgroundAnchor?.value || "center";
      const anchorCoordinates = {
        center: [0.5, 0.5],
        "top-left": [0, 0],
        "top-center": [0.5, 0],
        "top-right": [1, 0],
        "bottom-left": [0, 1],
        "bottom-center": [0.5, 1],
        "bottom-right": [1, 1],
      };
      const [anchorX, anchorY] = anchorCoordinates[patternAnchor] || anchorCoordinates.center;
      const separationStrength = foregroundSeparation?.value || "none";
      const outlineRadius = { none: 0, fine: 2, standard: 4, bold: 8 }[separationStrength] || 0;
      const proofFrontArtworkTreatment = frontArtworkLayout?.value || "single";
      const proofFrontArtworkScale = Math.max(
        10,
        Math.min(100, Number(frontArtworkScale?.value) || 32),
      );
      const proofFrontArtworkAnchor = frontArtworkAnchor?.value || "center";
      const [frontArtworkAnchorX, frontArtworkAnchorY] =
        anchorCoordinates[proofFrontArtworkAnchor] || anchorCoordinates.center;
      const proofFrontUsesBackTexture = Boolean(frontArtworkBackTexture?.checked);
      let stockPatternArtwork = "";
      const stockPatternUrl = stockAssets.get(patternMotif) || "";
      if (stockPatternUrl) {
        try {
          const response = await fetch(stockPatternUrl, { credentials: "same-origin" });
          if (response.ok) stockPatternArtwork = await readBlobAsDataUrl(await response.blob());
        } catch (error) {
          console.warn("The stock background motif could not be embedded in the cart proof.", error);
        }
      }

      const proofPatternMarkup = ({ id, x, background, patternColor, patternArtwork }) => {
        if (patternLayout === "solid") return "";
        const tile = Math.max(20, flagWidth * patternScale / 100);
        const tileHeight = Math.max(20, flagHeight * patternScale / 100);
        const tileX = x + (flagWidth - tile) * anchorX;
        const tileY = flagY + (flagHeight - tileHeight) * anchorY;
        const clip = `clip-path="url(#${id}-clip)"`;
        if (patternLayout === "watermark" && patternArtwork) {
          const watermarkWidth = flagWidth * Math.min(92, patternScale + 24) / 100;
          const watermarkHeight = flagHeight * Math.min(92, patternScale + 24) / 100;
          const watermarkX = x + (flagWidth - watermarkWidth) * anchorX;
          const watermarkY = flagY + (flagHeight - watermarkHeight) * anchorY;
          return `<image ${clip} href="${escapeXml(patternArtwork)}" x="${watermarkX}" y="${watermarkY}" width="${watermarkWidth}" height="${watermarkHeight}" preserveAspectRatio="xMidYMid meet" opacity="0.28"/>`;
        }
        if (["straight-repeat", "half-drop"].includes(patternLayout) && patternArtwork) {
          const patternWidth = patternLayout === "half-drop" ? tile * 4 : tile * 2;
          const patternHeight = tileHeight * 2;
          const motifImages = patternLayout === "half-drop"
            ? `
              <image href="${escapeXml(patternArtwork)}" x="${tile / 2}" y="${tileHeight / 2}" width="${tile}" height="${tileHeight}" preserveAspectRatio="xMidYMid meet"/>
              <image href="${escapeXml(patternArtwork)}" x="${tile * 2.5}" y="${-tileHeight / 2}" width="${tile}" height="${tileHeight}" preserveAspectRatio="xMidYMid meet"/>
              <image href="${escapeXml(patternArtwork)}" x="${tile * 2.5}" y="${tileHeight * 1.5}" width="${tile}" height="${tileHeight}" preserveAspectRatio="xMidYMid meet"/>`
            : `<image href="${escapeXml(patternArtwork)}" x="${tile / 2}" y="${tileHeight / 2}" width="${tile}" height="${tileHeight}" preserveAspectRatio="xMidYMid meet"/>`;
          return `
            <defs><pattern id="${id}-pattern" patternUnits="userSpaceOnUse" x="${tileX}" y="${tileY}" width="${patternWidth}" height="${patternHeight}">${motifImages}</pattern></defs>
            <rect ${clip} x="${x}" y="${flagY}" width="${flagWidth}" height="${flagHeight}" fill="url(#${id}-pattern)" opacity="0.28"/>`;
        }
        if (patternLayout === "horizontal-stripes") {
          return `<defs><pattern id="${id}-pattern" patternUnits="userSpaceOnUse" x="${x}" y="${tileY}" width="${flagWidth}" height="${tileHeight}"><rect width="${flagWidth}" height="${tileHeight / 2}" fill="${escapeXml(patternColor)}"/></pattern></defs><rect ${clip} x="${x}" y="${flagY}" width="${flagWidth}" height="${flagHeight}" fill="url(#${id}-pattern)"/>`;
        }
        if (patternLayout === "vertical-stripes") {
          return `<defs><pattern id="${id}-pattern" patternUnits="userSpaceOnUse" x="${tileX}" y="${flagY}" width="${tile}" height="${flagHeight}"><rect width="${tile / 2}" height="${flagHeight}" fill="${escapeXml(patternColor)}"/></pattern></defs><rect ${clip} x="${x}" y="${flagY}" width="${flagWidth}" height="${flagHeight}" fill="url(#${id}-pattern)"/>`;
        }
        if (patternLayout === "diagonal-stripes") {
          return `<defs><pattern id="${id}-pattern" patternUnits="userSpaceOnUse" x="${tileX}" y="${tileY}" width="${tile}" height="${tile}"><path d="M ${-tile / 2} ${tile} L ${tile} ${-tile / 2} M 0 ${tile * 1.5} L ${tile * 1.5} 0" stroke="${escapeXml(patternColor)}" stroke-width="${tile / 3}"/></pattern></defs><rect ${clip} x="${x}" y="${flagY}" width="${flagWidth}" height="${flagHeight}" fill="url(#${id}-pattern)"/>`;
        }
        if (patternLayout === "checkerboard") {
          return `<defs><pattern id="${id}-pattern" patternUnits="userSpaceOnUse" x="${tileX}" y="${tileY}" width="${tile}" height="${tileHeight}"><rect width="${tile / 2}" height="${tileHeight / 2}" fill="${escapeXml(patternColor)}"/><rect x="${tile / 2}" y="${tileHeight / 2}" width="${tile / 2}" height="${tileHeight / 2}" fill="${escapeXml(patternColor)}"/></pattern></defs><rect ${clip} x="${x}" y="${flagY}" width="${flagWidth}" height="${flagHeight}" fill="url(#${id}-pattern)"/>`;
        }
        if (patternLayout === "offset-signal") {
          return `<rect ${clip} x="${x}" y="${flagY + flagHeight * 0.70}" width="${flagWidth}" height="${flagHeight * 0.30}" fill="${escapeXml(patternColor)}"/>`;
        }
        if (patternLayout === "center-band") {
          return `<rect ${clip} x="${x}" y="${flagY + flagHeight * 0.34}" width="${flagWidth}" height="${flagHeight * 0.32}" fill="${escapeXml(patternColor)}"/>`;
        }
        if (patternLayout === "double-edge-bands") {
          return `<g ${clip}><rect x="${x}" y="${flagY}" width="${flagWidth}" height="${flagHeight * 0.18}" fill="${escapeXml(patternColor)}"/><rect x="${x}" y="${flagY + flagHeight * 0.82}" width="${flagWidth}" height="${flagHeight * 0.18}" fill="${escapeXml(patternColor)}"/></g>`;
        }
        if (patternLayout === "border-frame") {
          return `<rect ${clip} x="${x + 18}" y="${flagY + 18}" width="${flagWidth - 36}" height="${flagHeight - 36}" fill="none" stroke="${escapeXml(patternColor)}" stroke-width="36"/>`;
        }
        return "";
      };

      const faceMarkup = ({
        side,
        x,
        background,
        headerColor,
        headerPatternColor,
        patternColor,
        patternArtwork,
        surface,
        surfaceArtwork,
        surfaceKind,
        artworkColor,
        textColor,
        text,
        enteredText,
        artwork,
        filename,
        showAnnotations = true,
        showTag = true,
      }) => {
        const hasArtwork = Boolean(artwork);
        const hasEnteredText = Boolean(enteredText);
        const templateId = section.dataset.customTemplate || "standard";
        const standardLayout = contentLayoutForSide(side, hasArtwork, hasEnteredText);
        const layout = templateId === "offset-signal"
          ? {
              ...standardLayout,
              logo: { left: 0.11, top: 0.055, width: 0.78, height: 0.58 },
              text: { left: 0.09, top: 0.735, width: 0.82, height: 0.215 },
            }
          : templateId === "retro-double-stripe"
            ? {
                ...standardLayout,
                logo: { left: 0.11, top: 0.205, width: 0.78, height: 0.52 },
                text: { left: 0.09, top: 0.835, width: 0.82, height: 0.13 },
              }
            : standardLayout;
        const repeatsFrontArtwork =
          side === "front" &&
          ["straight-repeat", "half-drop"].includes(proofFrontArtworkTreatment);
        const artLayout = repeatsFrontArtwork ? layout.bounds : layout.logo;
        const artX = x + flagWidth * artLayout.left;
        const artY = flagY + flagHeight * artLayout.top;
        const artWidth = flagWidth * artLayout.width;
        const artHeight = flagHeight * artLayout.height;
        const textX = x + flagWidth * (layout.text.left + layout.text.width / 2);
        const textY = flagY + flagHeight * (layout.text.top + layout.text.height / 2);
        const textBoxWidth = flagWidth * layout.text.width;
        const textBoxHeight = flagHeight * layout.text.height;
        const proofText = enteredText || (!hasArtwork && !surface?.fullFlag ? text : "");
        const displayProofText = proofText.toUpperCase();
        const proofCharacterCount = Math.max(displayProofText.length, 4);
        const proofTextWidthEm =
          proofCharacterCount * proofFont.widthFactor +
          Math.max(proofCharacterCount - 1, 0) * proofFont.trackingEm;
        const textFontSize = Math.max(
          18,
          Math.min(
            textBoxHeight,
            textBoxWidth / proofTextWidthEm,
          ),
        );
        const label = side === "front" ? "TAG SIDE / FRONT" : "CLEAN SIDE / BACK";
        const id = `proof-${side}-${Math.round(x)}`;
        const outlineColor = foregroundOutlineColorForSide(side);
        const artworkFilter = outlineRadius ? ` filter="url(#${id}-outline)"` : "";
        const frontTextureSurface = side === "front" && proofFrontUsesBackTexture
          ? proofSurfaces.back
          : null;
        const frontTextureArtwork = side === "front" && proofFrontUsesBackTexture
          ? proofSurfaceArtwork.back
          : "";
        const frontTextureColor = colors["back-background"] || "#FFFFFF";
        const frontTextureRepeats = Boolean(frontTextureSurface?.repeat) ||
          frontTextureSurface?.kind === "material";
        const frontTextureTileSize = flagWidth *
          (Math.max(1, Number(frontTextureSurface?.physicalTileWidthInches) || 56) /
            physicalFlagWidthInches);
        const frontTextureDefinition = !frontTextureArtwork
          ? ""
          : frontTextureRepeats
            ? `<pattern id="${id}-front-art-fill" patternUnits="userSpaceOnUse" x="${artX}" y="${artY}" width="${frontTextureTileSize}" height="${frontTextureTileSize}"><image href="${escapeXml(frontTextureArtwork)}" x="0" y="0" width="${frontTextureTileSize}" height="${frontTextureTileSize}" preserveAspectRatio="none"/></pattern>`
            : `<pattern id="${id}-front-art-fill" patternUnits="userSpaceOnUse" x="${artX}" y="${artY}" width="${artWidth}" height="${artHeight}"><image href="${escapeXml(frontTextureArtwork)}" x="${artX}" y="${artY}" width="${artWidth}" height="${artHeight}" preserveAspectRatio="xMidYMid slice"/></pattern>`;
        const frontArtworkPaint = side === "front" && proofFrontUsesBackTexture
          ? frontTextureArtwork
            ? `url(#${id}-front-art-fill)`
            : frontTextureColor
          : artworkColor;
        const frontAnchorPreserveAspect = {
          center: "xMidYMid",
          "top-left": "xMinYMin",
          "top-center": "xMidYMin",
          "top-right": "xMaxYMin",
          "bottom-left": "xMinYMax",
          "bottom-center": "xMidYMax",
          "bottom-right": "xMaxYMax",
        }[proofFrontArtworkAnchor] || "xMidYMid";
        const artworkRepeatTile = Math.max(32, flagWidth * proofFrontArtworkScale / 100);
        const artworkRepeatTileHeight = artworkRepeatTile;
        const artworkRepeatWidth = proofFrontArtworkTreatment === "half-drop"
          ? artworkRepeatTile * 4
          : artworkRepeatTile * 2;
        const artworkRepeatHeight = artworkRepeatTileHeight * 2;
        const artworkPatternX = artX +
          Math.max(0, artWidth - artworkRepeatWidth) * frontArtworkAnchorX;
        const artworkPatternY = artY +
          Math.max(0, artHeight - artworkRepeatHeight) * frontArtworkAnchorY;
        const artworkRepeatImages = proofFrontArtworkTreatment === "half-drop"
          ? `
            <image href="${escapeXml(artwork)}" x="${artworkRepeatTile / 2}" y="${artworkRepeatTileHeight / 2}" width="${artworkRepeatTile}" height="${artworkRepeatTileHeight}" preserveAspectRatio="xMidYMid meet"/>
            <image href="${escapeXml(artwork)}" x="${artworkRepeatTile * 2.5}" y="${-artworkRepeatTileHeight / 2}" width="${artworkRepeatTile}" height="${artworkRepeatTileHeight}" preserveAspectRatio="xMidYMid meet"/>
            <image href="${escapeXml(artwork)}" x="${artworkRepeatTile * 2.5}" y="${artworkRepeatTileHeight * 1.5}" width="${artworkRepeatTile}" height="${artworkRepeatTileHeight}" preserveAspectRatio="xMidYMid meet"/>`
          : `<image href="${escapeXml(artwork)}" x="${artworkRepeatTile / 2}" y="${artworkRepeatTileHeight / 2}" width="${artworkRepeatTile}" height="${artworkRepeatTileHeight}" preserveAspectRatio="xMidYMid meet"/>`;
        const artworkMaskDefinition = !artwork
          ? ""
          : repeatsFrontArtwork
            ? `
              <pattern id="${id}-front-art-pattern" patternUnits="userSpaceOnUse" x="${artworkPatternX}" y="${artworkPatternY}" width="${artworkRepeatWidth}" height="${artworkRepeatHeight}">${artworkRepeatImages}</pattern>
              <mask id="${id}-art-mask" maskUnits="userSpaceOnUse" x="${artX}" y="${artY}" width="${artWidth}" height="${artHeight}" mask-type="alpha"><rect x="${artX}" y="${artY}" width="${artWidth}" height="${artHeight}" fill="url(#${id}-front-art-pattern)"/></mask>`
            : `<mask id="${id}-art-mask" maskUnits="userSpaceOnUse" x="${artX}" y="${artY}" width="${artWidth}" height="${artHeight}" mask-type="alpha"><image href="${escapeXml(artwork)}" x="${artX}" y="${artY}" width="${artWidth}" height="${artHeight}" preserveAspectRatio="${frontAnchorPreserveAspect} meet"/></mask>`;
        const artworkMarkup = artwork
          ? `<rect x="${artX}" y="${artY}" width="${artWidth}" height="${artHeight}" fill="${escapeXml(frontArtworkPaint)}" mask="url(#${id}-art-mask)"${artworkFilter}/>`
          : "";
        const proofTextStroke = outlineRadius
          ? ` stroke="${escapeXml(outlineColor)}" stroke-width="${outlineRadius * 2}" paint-order="stroke fill" stroke-linejoin="round"`
          : proofFont.strokeEm
            ? ` stroke="${escapeXml(artworkColor)}" stroke-width="${textFontSize * proofFont.strokeEm * 2}" paint-order="stroke fill"`
            : "";
        const textMarkup = displayProofText
          ? `<text x="${textX}" y="${textY}" fill="${escapeXml(
              textColor || frontArtworkPaint,
            )}" text-anchor="middle" dominant-baseline="middle" font-family="${escapeXml(
              proofFont.family,
            )}" font-size="${textFontSize}" font-weight="${escapeXml(proofFont.weight)}" letter-spacing="${
              proofFont.trackingEm
            }em"${proofTextStroke}>${escapeXml(
              displayProofText,
            )}</text>`
          : "";
        const fileLine = showAnnotations && filename
          ? `<text x="${x}" y="${flagY + flagHeight + 68}" fill="#BCC4C5" font-family="Arial, sans-serif" font-size="20">${escapeXml(
              filename,
            )}</text>`
          : "";
        const surfaceTileSize = flagWidth *
          (Math.max(1, Number(surface?.physicalTileWidthInches) || 56) /
            physicalFlagWidthInches);
        const repeatSurfaceArtwork = Boolean(surface?.repeat) || surfaceKind === "material";
        const surfaceMarkup = !surfaceArtwork
          ? ""
          : repeatSurfaceArtwork
            ? `<defs><pattern id="${id}-surface" patternUnits="userSpaceOnUse" x="${x}" y="${flagY}" width="${surfaceTileSize}" height="${surfaceTileSize}"><image href="${escapeXml(surfaceArtwork)}" x="0" y="0" width="${surfaceTileSize}" height="${surfaceTileSize}" preserveAspectRatio="none"/></pattern></defs><rect clip-path="url(#${id}-clip)" x="${x}" y="${flagY}" width="${flagWidth}" height="${flagHeight}" fill="url(#${id}-surface)"/>`
            : `<image clip-path="url(#${id}-clip)" href="${escapeXml(surfaceArtwork)}" x="${x}" y="${flagY}" width="${flagWidth}" height="${flagHeight}" preserveAspectRatio="xMidYMid slice"/>`;
        const headerWidth = flagWidth * Number(geometry.headerWidth || 0.06);
        const headerX = side === "back" ? x + flagWidth - headerWidth : x;
        const geometryTransform = side === "back"
          ? `translate(${x + flagWidth} ${flagY}) scale(${-flagWidth / 1000} ${flagHeight / 1000})`
          : `translate(${x} ${flagY}) scale(${flagWidth / 1000} ${flagHeight / 1000})`;
        const openGeometryPath = geometry.path.replace(/\s+Z\s*$/i, "");
        const templateIdForHeader = section.dataset.customTemplate || "standard";
        const headerBase = `<rect clip-path="url(#${id}-clip)" x="${headerX}" y="${flagY}" width="${headerWidth}" height="${flagHeight}" fill="${escapeXml(headerColor || background)}"/>`;
        const headerMarkup = surface?.fullFlag ? '' : surface?.kind === 'pro-photo' ? `<rect clip-path="url(#${id}-clip)" x="${headerX}" y="${flagY}" width="${headerWidth}" height="${flagHeight}" fill="${proPhotos.headerColor()}"/>` : side !== "front"
          ? ""
          : templateIdForHeader === "offset-signal"
            ? `${headerBase}<rect clip-path="url(#${id}-clip)" x="${headerX}" y="${flagY + flagHeight * 0.70}" width="${headerWidth}" height="${flagHeight * 0.30}" fill="${escapeXml(headerPatternColor || patternColor)}"/>`
            : templateIdForHeader === "retro-double-stripe"
              ? `${headerBase}<g clip-path="url(#${id}-clip)"><rect x="${headerX}" y="${flagY}" width="${headerWidth}" height="${flagHeight * 0.18}" fill="${escapeXml(headerPatternColor || patternColor)}"/><rect x="${headerX}" y="${flagY + flagHeight * 0.82}" width="${headerWidth}" height="${flagHeight * 0.18}" fill="${escapeXml(headerPatternColor || patternColor)}"/></g>`
              : headerBase;
        const headerSeamX = side === "back"
          ? x + flagWidth - headerWidth
          : x + headerWidth;
        const headerSeamMarkup = `<path d="M${headerSeamX} ${flagY}V${flagY + flagHeight}" fill="none" stroke="#050505" stroke-width="2" vector-effect="non-scaling-stroke"/>`;
        const headerExtension = flagWidth *
          (Number(approvedProofFrame.extension || 24) / Number(approvedProofFrame.width || 954));
        const headerOuterX = side === "back" ? x + flagWidth : x;
        const headerExtensionEndX = side === "back"
          ? headerOuterX + headerExtension
          : headerOuterX - headerExtension;
        const headerExtensionMarkup = `<path d="M${headerOuterX} ${flagY}H${headerExtensionEndX} M${headerOuterX} ${flagY + flagHeight}H${headerExtensionEndX}" fill="none" stroke="#050505" stroke-width="4" stroke-linecap="square" vector-effect="non-scaling-stroke"/>`;
        const tag =
          showTag && side === "front"
            ? `<rect x="${x + headerWidth}" y="${
                flagY + flagHeight * 0.08
              }" width="${Math.max(18, flagWidth * 0.027)}" height="${
                flagHeight * 0.24
              }" fill="#111111"/>`
            : "";
        const labelMarkup = showAnnotations
          ? `<text x="${x}" y="${flagY - 28}" fill="#FFFFFF" font-family="Arial, sans-serif" font-size="24" font-weight="700">${label}</text>`
          : "";
        return `
          ${labelMarkup}
          <defs>
            <clipPath id="${id}-clip"><path d="${escapeXml(geometry.path)}" transform="${geometryTransform}"/></clipPath>
            ${frontTextureDefinition}
            ${artworkMaskDefinition}
            <filter id="${id}-outline" x="-30%" y="-30%" width="160%" height="160%" color-interpolation-filters="sRGB">
              <feMorphology in="SourceAlpha" operator="dilate" radius="${outlineRadius}" result="spread"/>
              <feFlood flood-color="${escapeXml(outlineColor)}" result="outline-color"/>
              <feComposite in="outline-color" in2="spread" operator="in" result="outline"/>
              <feMerge><feMergeNode in="outline"/><feMergeNode in="SourceGraphic"/></feMerge>
            </filter>
          </defs>
          <path d="${escapeXml(geometry.path)}" transform="${geometryTransform}" fill="${escapeXml(background)}"/>
          ${surfaceMarkup}
          ${proofPatternMarkup({ id, x, background, patternColor, patternArtwork })}
          ${headerMarkup}
          ${proPreview && side === "front" ? window.GamedayProRedlines.headerMarkup({text:proofHeaderText,x:headerX,y:flagY,width:flagWidth,height:flagHeight,headerWidth,inches:({"12x17":12,"3x5":36,"4x6":48,"5x8":60})[sizeId],font:proofFont.family,weight:proofFont.weight,color:surface?.kind==='pro-photo'?proPhotos.headerColor():headerColor||background}) : ""}
          <g clip-path="url(#${id}-clip)">${tag}${artworkMarkup}${textMarkup}</g>
          ${headerSeamMarkup}
          <path d="${escapeXml(openGeometryPath)}" transform="${geometryTransform}" fill="none" stroke="#050505" stroke-width="4" vector-effect="non-scaling-stroke"/>
          ${headerExtensionMarkup}
          ${fileLine}
        `;
      };

      const frontFace = {
        side: "front",
        background: colors["front-background"] || "#383838",
        headerColor: colors["back-background"] || "#FFFFFF",
        headerPatternColor: colors["back-pattern"] || "#383838",
        patternColor: colors["front-pattern"] || "#FFFFFF",
        patternArtwork: patternMotif === "foreground" ? frontArt : stockPatternArtwork,
        surface: proofSurfaces.front,
        surfaceArtwork: proofSurfaceArtwork.front,
        surfaceKind: proofSurfaces.front?.kind || "solid",
        surfaceName: proofSurfaces.front?.name || "Solid color",
        artworkColor: colors["front-art"] || "#FFFFFF",
        textColor: ["offset-signal", "retro-double-stripe"].includes(section.dataset.customTemplate)
          ? colors["front-background"] || "#383838"
          : colors["front-art"] || "#FFFFFF",
        text: frontEnteredText || "FRONT",
        enteredText: frontEnteredText,
        artwork: frontArt,
        filename: artworkFileNames.front,
      };
      const backFace = {
        side: "back",
        background: colors["back-background"] || "#FFFFFF",
        headerColor: colors["back-background"] || "#FFFFFF",
        headerPatternColor: colors["back-pattern"] || "#383838",
        patternColor: colors["back-pattern"] || "#383838",
        patternArtwork: patternMotif === "foreground" ? backArt : stockPatternArtwork,
        surface: proofSurfaces.back,
        surfaceArtwork: proofSurfaceArtwork.back,
        surfaceKind: proofSurfaces.back?.kind || "solid",
        surfaceName: proofSurfaces.back?.name || "Solid color",
        artworkColor: colors["back-art"] || "#383838",
        textColor: ["offset-signal", "retro-double-stripe"].includes(section.dataset.customTemplate)
          ? colors["back-background"] || "#FFFFFF"
          : colors["back-art"] || "#383838",
        text: backEnteredText || "BACK",
        enteredText: backEnteredText,
        artwork: backArt,
        filename:
          artworkFileNames.back ||
          (mirror?.checked && artworkFileNames.front
            ? `${artworkFileNames.front} / readable reverse`
            : ""),
      };
      const [constructionTopRaster, constructionUndersideRaster] = await Promise.all([
        recoloredConstruction("top", backFace.background, frontFace.background),
        recoloredConstruction("underside", backFace.background, frontFace.background),
      ]);
      const constructionTopDataUrl = constructionTopRaster.toDataURL("image/png");
      const constructionUndersideDataUrl = constructionUndersideRaster.toDataURL("image/png");
      const constructionPersonalizationX = 74 + 580 * 0.365;
      const constructionPersonalizationY = 928 + 364 * 0.45;
      const constructionPersonalizationMarkup = proofHeaderText
        ? `<text x="${constructionPersonalizationX}" y="${constructionPersonalizationY}" fill="${escapeXml(frontFace.background)}" text-anchor="middle" dominant-baseline="central" font-family="${escapeXml(proofFont.family)}" font-size="27" font-weight="${escapeXml(proofFont.weight)}" transform="rotate(-90 ${constructionPersonalizationX} ${constructionPersonalizationY})">${escapeXml(proofHeaderText.toUpperCase())}</text>`
        : "";

      const liveFaceScale = Math.min(1.16, 380 / flagHeight);
      const liveFaceX = 710 + (820 - flagWidth * liveFaceScale) / 2;
      const liveFrontY = 410 - flagY * liveFaceScale;
      const liveBackY = 900 - flagY * liveFaceScale;
      const frontBackgroundName = liveProofColor("front-background").name;
      const frontArtworkName = liveProofColor("front-art").name;
      const backBackgroundName = liveProofColor("back-background").name;
      const backArtworkName = liveProofColor("back-art").name;
      const brandLogoMarkup = brandLogoDataUrl
        ? `<image href="${brandLogoDataUrl}" x="74" y="62" width="610" height="150" preserveAspectRatio="xMinYMid meet"/>`
        : `<text x="74" y="150" fill="#111" font-family="Arial, sans-serif" font-size="72" font-weight="900">Gameday Flags</text>`;
      const combinedSvg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="1600" height="2071" viewBox="0 0 1600 2071">
          ${proofFont.styleMarkup}
          <defs>
            <clipPath id="live-front-panel"><rect x="700" y="405" width="830" height="408"/></clipPath>
            <clipPath id="live-back-panel"><rect x="700" y="895" width="830" height="408"/></clipPath>
          </defs>
          <rect width="1600" height="2071" fill="#FFFFFF"/>
          ${brandLogoMarkup}
          <rect x="1320" y="78" width="206" height="54" fill="#111"/>
          <text x="1423" y="112" fill="#FFF" text-anchor="middle" font-family="Arial, sans-serif" font-size="20" font-weight="900" letter-spacing="1.5">LIVE / VARIABLE</text>
          <text x="74" y="252" fill="#596062" font-family="Arial, sans-serif" font-size="20" font-weight="900" letter-spacing="1.4">CUSTOM GAMEDAY FLAG / PRODUCT + CONSTRUCTION PROOF</text>
          <text x="74" y="322" fill="#111" font-family="Arial, sans-serif" font-size="54" font-weight="900">${escapeXml(proofName)} ${escapeXml(customProductTitle)}</text>
          <line x1="74" y1="356" x2="1526" y2="356" stroke="#A6D90D" stroke-width="5"/>

          <rect x="74" y="402" width="580" height="938" fill="#FFF" stroke="#D5D7D4" stroke-width="2"/>
          <rect x="74" y="402" width="580" height="104" fill="#171817"/>
          <text x="98" y="440" fill="#A6D90D" font-family="Arial, sans-serif" font-size="17" font-weight="900" letter-spacing="1">STACKED CONSTRUCTION PREVIEW</text>
          <text x="98" y="474" fill="#FFF" font-family="Arial, sans-serif" font-size="21" font-weight="900">TOP + UNDERSIDE / CONTINUOUS HEADER</text>
          <rect x="74" y="516" width="350" height="48" fill="#171817"/><text x="96" y="548" fill="#A6D90D" font-family="Arial, sans-serif" font-size="18" font-weight="900">01</text><text x="132" y="548" fill="#FFF" font-family="Arial, sans-serif" font-size="18" font-weight="900">TOP / WOVEN LOGO TAG</text>
          <image href="${escapeXml(constructionTopDataUrl)}" x="74" y="564" width="580" height="364" preserveAspectRatio="xMidYMid meet"/>
          <image href="${escapeXml(constructionUndersideDataUrl)}" x="74" y="928" width="580" height="364" preserveAspectRatio="xMidYMid meet"/>
          ${constructionPersonalizationMarkup}
          <rect x="74" y="1292" width="390" height="48" fill="#171817"/><text x="96" y="1324" fill="#A6D90D" font-family="Arial, sans-serif" font-size="18" font-weight="900">02</text><text x="132" y="1324" fill="#FFF" font-family="Arial, sans-serif" font-size="18" font-weight="900">UNDERSIDE / PERSONALIZATION</text>

          <rect x="700" y="402" width="830" height="448" fill="#FFF" stroke="#D5D7D4" stroke-width="2"/>
          <g clip-path="url(#live-front-panel)"><g transform="translate(${liveFaceX} ${liveFrontY}) scale(${liveFaceScale})">${faceMarkup({ ...frontFace, x: 0, showAnnotations: false, showTag: false })}</g></g>
          <text x="718" y="830" fill="#79A800" font-family="Arial, sans-serif" font-size="18" font-weight="900">SIDE A</text>
          <text x="806" y="830" fill="#111" font-family="Arial, sans-serif" font-size="17" font-weight="800">${escapeXml(`${frontBackgroundName} field / ${frontArtworkName} artwork`)}</text>
          <line x1="700" y1="848" x2="1530" y2="848" stroke="#A6D90D" stroke-width="5"/>

          <rect x="700" y="892" width="830" height="448" fill="#FFF" stroke="#D5D7D4" stroke-width="2"/>
          <g clip-path="url(#live-back-panel)"><g transform="translate(${liveFaceX} ${liveBackY}) scale(${liveFaceScale})">${faceMarkup({ ...backFace, x: 0, showAnnotations: false, showTag: false })}</g></g>
          <text x="718" y="1320" fill="#79A800" font-family="Arial, sans-serif" font-size="18" font-weight="900">SIDE B</text>
          <text x="806" y="1320" fill="#111" font-family="Arial, sans-serif" font-size="17" font-weight="800">${escapeXml(`${backBackgroundName} field / ${backArtworkName} artwork`)}</text>
          <line x1="700" y1="1338" x2="1530" y2="1338" stroke="#A6D90D" stroke-width="5"/>

          <rect x="74" y="1382" width="1452" height="182" fill="#FFF" stroke="#D5D7D4" stroke-width="2"/>
          <line x1="800" y1="1382" x2="800" y2="1564" stroke="#D5D7D4" stroke-width="2"/><line x1="74" y1="1473" x2="1526" y2="1473" stroke="#D5D7D4" stroke-width="2"/>
          <text x="98" y="1418" fill="#79A800" font-family="Arial, sans-serif" font-size="16" font-weight="900">PRODUCT</text><text x="98" y="1452" fill="#111" font-family="Arial, sans-serif" font-size="22" font-weight="800">${escapeXml(customProductTitle)}</text>
          <text x="824" y="1418" fill="#79A800" font-family="Arial, sans-serif" font-size="16" font-weight="900">CONFIGURATION</text><text x="824" y="1452" fill="#111" font-family="Arial, sans-serif" font-size="22" font-weight="800">${escapeXml(sizeLabel)}</text>
          <text x="98" y="1509" fill="#79A800" font-family="Arial, sans-serif" font-size="16" font-weight="900">PRODUCT CODE</text><text x="98" y="1543" fill="#111" font-family="Arial, sans-serif" font-size="22" font-weight="800">${escapeXml(sku)}</text>
          <text x="824" y="1509" fill="#79A800" font-family="Arial, sans-serif" font-size="16" font-weight="900">DESIGN NUMBER</text><text x="824" y="1543" fill="#111" font-family="Arial, sans-serif" font-size="22" font-weight="800">${escapeXml(configurationId)}</text>

          <rect x="74" y="1602" width="1452" height="286" fill="#FFF" stroke="#D5D7D4" stroke-width="2"/><line x1="558" y1="1602" x2="558" y2="1888" stroke="#D5D7D4" stroke-width="2"/><line x1="1042" y1="1602" x2="1042" y2="1888" stroke="#D5D7D4" stroke-width="2"/>
          <text x="98" y="1644" fill="#79A800" font-family="Arial, sans-serif" font-size="16" font-weight="900">AUTHENTIC CONSTRUCTION</text><text x="98" y="1684" fill="#4F5657" font-family="Arial, sans-serif" font-size="18"><tspan x="98" dy="0">Full sewn header, woven Gameday tag,</tspan><tspan x="98" dy="29">reinforced perimeter, and two attachment</tspan><tspan x="98" dy="29">loops keep loads out of the printed field.</tspan></text>
          <text x="582" y="1644" fill="#79A800" font-family="Arial, sans-serif" font-size="16" font-weight="900">LIVE PERSONALIZATION</text><text x="582" y="1684" fill="#4F5657" font-family="Arial, sans-serif" font-size="18"><tspan x="582" dy="0">Header / ${proofHeaderText ? escapeXml(proofHeaderText) : "Standard clean header"}</tspan><tspan x="582" dy="29">${proofHeaderText ? `Font / ${escapeXml(proofFont.label)}` : "No underside personalization selected."}</tspan><tspan x="582" dy="29">Front and back remain independently editable.</tspan></text>
          <text x="1066" y="1644" fill="#79A800" font-family="Arial, sans-serif" font-size="16" font-weight="900">APPROVAL RULE</text><text x="1066" y="1684" fill="#4F5657" font-family="Arial, sans-serif" font-size="18"><tspan x="1066" dy="0">This saved Live Proof is the customer</tspan><tspan x="1066" dy="29">approval record. Production requires final</tspan><tspan x="1066" dy="29">artwork, color, rights, and print review.</tspan></text>
          <text x="74" y="1972" fill="#4F5657" font-family="Arial, sans-serif" font-size="16" font-weight="900" letter-spacing="1">LIVE PRODUCT DATA / PRINTABLE PRODUCT PROOF</text>
          <text x="1526" y="1972" fill="#111" text-anchor="end" font-family="Arial, sans-serif" font-size="16" font-weight="900">GAMEDAY-LIVE-PROOF-R01</text>
        </svg>
      `;

      const singleFaceSvg = (face) => `
        <svg xmlns="http://www.w3.org/2000/svg" width="900" height="900" viewBox="0 0 900 900">
          ${proofFont.styleMarkup}
          <rect width="900" height="900" fill="#171817"/>
          <rect x="34" y="34" width="832" height="832" fill="none" stroke="#383838" stroke-width="2"/>
          <text x="64" y="88" fill="#FFFFFF" font-family="Arial, sans-serif" font-size="30" font-weight="700">${face.side.toUpperCase()} CART PROOF</text>
          <text x="64" y="128" fill="#A6D90D" font-family="Arial, sans-serif" font-size="19" font-weight="700">${escapeXml(configurationId)}</text>
          <text x="836" y="88" fill="#FFFFFF" text-anchor="end" font-family="Arial, sans-serif" font-size="18">${escapeXml(`${sku} / ${sizeLabel}`)}</text>
          <text x="836" y="128" fill="#BCC4C5" text-anchor="end" font-family="Arial, sans-serif" font-size="18">${escapeXml(proofName)}</text>
          ${faceMarkup({ ...face, x: 125 })}
          <line x1="64" y1="812" x2="836" y2="812" stroke="#383838" stroke-width="2"/>
          <text x="64" y="850" fill="#FFFFFF" font-family="Arial, sans-serif" font-size="18" font-weight="700">SURFACE ${escapeXml(face.surfaceName || "Solid color")} / BACKGROUND ${escapeXml(face.background)} / ART ${escapeXml(face.artworkColor)} / FONT / ${escapeXml(proofFont.label)}</text>
        </svg>
      `;

      const renderProofBlob = async (source, width, height) => {
        const svgUrl = URL.createObjectURL(
          new Blob([source], { type: "image/svg+xml;charset=utf-8" }),
        );
        try {
          const image = await new Promise((resolve, reject) => {
          const proofImage = new Image();
          proofImage.onload = () => resolve(proofImage);
          proofImage.onerror = () => reject(new Error("The proof image could not be rendered."));
          proofImage.src = svgUrl;
          });
          const canvas = document.createElement("canvas");
          canvas.width = width;
          canvas.height = height;
          const context = canvas.getContext("2d");
          if (!context) throw new Error("The proof canvas is unavailable.");
          context.drawImage(image, 0, 0);
          return await new Promise((resolve, reject) => {
            canvas.toBlob(
              (value) =>
                value ? resolve(value) : reject(new Error("The proof file could not be encoded.")),
              "image/png",
              0.94,
            );
          });
        } finally {
          URL.revokeObjectURL(svgUrl);
        }
      };

      const attachProof = (input, blob, suffix) => {
        const transfer = new DataTransfer();
        transfer.items.add(
          new File([blob], `${configurationId.toLowerCase()}-${suffix}.png`, {
            type: "image/png",
            lastModified: Date.now(),
          }),
        );
        input.files = transfer.files;
      };

      const [combinedBlob, frontBlob, backBlob] = await Promise.all([
        renderProofBlob(combinedSvg, 1600, 2071),
        renderProofBlob(singleFaceSvg(frontFace), 900, 900),
        renderProofBlob(singleFaceSvg(backFace), 900, 900),
      ]);
      if (snapshotOnly) return await readBlobAsDataUrl(combinedBlob);
      attachProof(proofFileInputs.combined, combinedBlob, "live-proof");
      attachProof(proofFileInputs.front, frontBlob, "front-proof");
      attachProof(proofFileInputs.back, backBlob, "back-proof");
      const proofStatus = propertyInputs.get("proof-status");
      if (proofStatus) {
        proofStatus.value = `Live Proof, front, and back attached / ${configurationId} / GAMEDAY-LIVE-PROOF-R01`;
      }
    };

    section.captureConfigurationSheet=(logo)=>generateProofFile(true,logo);

    const activateCartFieldNames = () => {
      form?.querySelectorAll("[data-custom-cart-name]").forEach((control) => {
        control.name = control.dataset.customCartName;
      });
    };

    const addSelectedSurfaceMount = async () => {
      const mount = form?.querySelector("[data-custom-kit-mount]");
      if (!mount?.checked || form.dataset.customKitMountReady === "true") return;
      const variantId = Number(mount.value);
      if (!Number.isFinite(variantId) || variantId <= 0) {
        throw new Error("The Surface Mount option is temporarily unavailable.");
      }
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties: { "Added with": customProductTitle, "Custom configuration": configurationId },
          }],
        }),
      });
      if (!response.ok) throw new Error("The Surface Mount could not be added. Please try again.");
      form.dataset.customKitMountReady = "true";
    };

    form?.addEventListener("submit", async (event) => {
      if (form.dataset.customProofReady === "true") return;
      event.preventDefault();
      if (!canSubmit()) return;
      proofCapturePending = true;
      syncSubmit();
      if (proofCaptureStatus) {
        proofCaptureStatus.textContent =
          "Saving the front and back views shown here with this cart line...";
      }
      try {
        await generateProofFile();
        if(proPhotos)await window.GamedayProPackage.attach(form,projectRecipe());
        await addSelectedSurfaceMount();
        activateCartFieldNames();
        form.dataset.customProofReady = "true";
        if (proofCaptureStatus) {
          proofCaptureStatus.textContent =
            "Front and back saved. Adding this exact configuration to your cart...";
        }
        HTMLFormElement.prototype.submit.call(form);
      } catch (error) {
        proofCapturePending = false;
        syncSubmit();
        if (proofCaptureStatus) {
          proofCaptureStatus.textContent =
            error?.message || "The configuration proof could not be attached.";
        }
      }
    });

    refreshPaletteOptions({ preserve: false, preferred: activePaletteId || defaultPaletteId });
    hydratePaletteLibrary();
    populateBackgroundSurfaces();
    hydrateBackgroundLibrary();
    selectSize(
      sizeButtons.find((button) => !button.disabled && button.dataset.variantId) ||
        sizeButtons.find((button) => !button.disabled),
    );
    if(proPreview){proPhotos=window.GamedayProPhotos.mount(section,{paletteColor:()=>selectedColor(colorSelects.find(s=>s.dataset.customColor==='front-background')).hex,size:()=>selectedSizeButton()?.dataset.customSize||'12x17',geometry:()=>approvedGeometryForSize(selectedSizeButton()?.dataset.customSize||'12x17'),changed:()=>{renderBackground();syncSubmit();section.dispatchEvent(new Event('input',{bubbles:true}));}});
    section.proCandidate={recipe:projectRecipe,restore:applyProjectRecipe,proof:generateProofFile,photos:proPhotos};window.GamedayProRedlines.mount(section,section.proCandidate);
    const heading=document.querySelector('main h1');if(heading)heading.textContent=location.pathname.includes('kit')?'PRO Gameday Flag Kit':'PRO Gameday Flag';

    }
    selectSide("front");
    applyActiveFont();
    renderArtwork();
    renderBackground();
  }

  const CORNHOLE_DEFAULT_PALETTES = [
    {
      id: "gameday",
      name: "Gameday neutral",
      status: "screen",
      colors: [
        { name: "Gameday gray", hex: "#383838", reference: "" },
        { name: "Machined silver", hex: "#BCC4C5", reference: "" },
        { name: "Rally white", hex: "#FFFFFF", reference: "" },
      ],
    },
    {
      id: "alabama",
      name: "Alabama",
      status: "screen",
      colors: [
        { name: "Crimson", hex: "#A40C31", reference: "" },
        { name: "White", hex: "#FFFFFF", reference: "" },
      ],
    },
    {
      id: "arizona-state",
      name: "Arizona State",
      status: "documented",
      colors: [
        { name: "Maroon", hex: "#79133B", reference: "PANTONE 216 C" },
        { name: "Gold", hex: "#EEC13B", reference: "PANTONE 123 C" },
      ],
    },
    {
      id: "boise-state",
      name: "Boise State",
      status: "screen",
      colors: [
        { name: "Blue", hex: "#0033A0", reference: "" },
        { name: "Orange", hex: "#FB653D", reference: "" },
        { name: "White", hex: "#FFFFFF", reference: "" },
      ],
    },
    {
      id: "california",
      name: "California",
      status: "documented",
      colors: [
        { name: "Navy", hex: "#041E42", reference: "" },
        { name: "Gold", hex: "#FFC72C", reference: "PANTONE 123 C" },
      ],
    },
    {
      id: "clemson",
      name: "Clemson",
      status: "screen",
      colors: [
        { name: "Orange", hex: "#F9581D", reference: "" },
        { name: "White", hex: "#FFFFFF", reference: "" },
      ],
    },
    {
      id: "florida",
      name: "Florida",
      status: "screen",
      colors: [
        { name: "Blue", hex: "#0021A3", reference: "" },
        { name: "Orange", hex: "#F84616", reference: "" },
        { name: "White", hex: "#FFFFFF", reference: "" },
      ],
    },
    {
      id: "illinois",
      name: "Illinois",
      status: "screen",
      colors: [
        { name: "Navy", hex: "#13294B", reference: "" },
        { name: "Orange", hex: "#FF5F05", reference: "" },
        { name: "White", hex: "#FFFFFF", reference: "" },
      ],
    },
    {
      id: "indiana",
      name: "Indiana",
      status: "screen",
      colors: [
        { name: "Crimson", hex: "#9D0533", reference: "" },
        { name: "White", hex: "#FFFFFF", reference: "" },
      ],
    },
    {
      id: "iowa-state",
      name: "Iowa State",
      status: "screen",
      colors: [
        { name: "Cardinal", hex: "#C8102E", reference: "" },
        { name: "Gold", hex: "#FFCA38", reference: "" },
      ],
    },
    {
      id: "kansas-state",
      name: "Kansas State",
      status: "named-spot",
      colors: [
        { name: "Purple", hex: "#2C1449", reference: "K-State Purple" },
        { name: "White", hex: "#FFFFFF", reference: "" },
      ],
    },
    {
      id: "miami",
      name: "Miami",
      status: "screen",
      colors: [
        { name: "Green", hex: "#005938", reference: "" },
        { name: "Orange", hex: "#F05A00", reference: "" },
        { name: "White", hex: "#FFFFFF", reference: "" },
      ],
    },
    {
      id: "notre-dame",
      name: "Notre Dame",
      status: "screen",
      colors: [
        { name: "Navy", hex: "#0C2340", reference: "" },
        { name: "Gold", hex: "#AE9142", reference: "" },
        { name: "White", hex: "#FFFFFF", reference: "" },
      ],
    },
    {
      id: "oklahoma",
      name: "Oklahoma",
      status: "screen",
      colors: [
        { name: "Crimson", hex: "#9D0533", reference: "" },
        { name: "White", hex: "#FFFFFF", reference: "" },
      ],
    },
    {
      id: "ole-miss",
      name: "Ole Miss",
      status: "screen",
      colors: [
        { name: "Navy", hex: "#1E2644", reference: "" },
        { name: "Red", hex: "#E31636", reference: "" },
        { name: "Powder blue", hex: "#3C6BA3", reference: "" },
      ],
    },
    {
      id: "oregon",
      name: "Oregon",
      status: "screen",
      colors: [
        { name: "Green", hex: "#007941", reference: "" },
        { name: "Yellow", hex: "#FCDF2B", reference: "" },
      ],
    },
    {
      id: "smu",
      name: "SMU",
      status: "screen",
      colors: [
        { name: "Red", hex: "#CC0035", reference: "" },
        { name: "Blue", hex: "#354CA1", reference: "" },
        { name: "White", hex: "#FFFFFF", reference: "" },
      ],
    },
    {
      id: "tennessee",
      name: "Tennessee",
      status: "documented",
      colors: [
        { name: "Orange", hex: "#FF8400", reference: "PANTONE 151 C" },
        { name: "White", hex: "#FFFFFF", reference: "" },
      ],
    },
    {
      id: "texas-am",
      name: "Texas A&M",
      status: "screen",
      colors: [
        { name: "Maroon", hex: "#500000", reference: "" },
        { name: "White", hex: "#FFFFFF", reference: "" },
      ],
    },
    {
      id: "texas-tech",
      name: "Texas Tech",
      status: "screen",
      colors: [
        { name: "Red", hex: "#CC0000", reference: "" },
        { name: "Black", hex: "#000000", reference: "" },
        { name: "White", hex: "#FFFFFF", reference: "" },
      ],
    },
    {
      id: "usc",
      name: "USC",
      status: "screen",
      colors: [
        { name: "Cardinal", hex: "#A40C31", reference: "" },
        { name: "Gold", hex: "#FFCD03", reference: "" },
        { name: "White", hex: "#FFFFFF", reference: "" },
      ],
    },
  ];

  function initCornholeCustomizer(section) {
    if (!section || section.dataset.cornholeReady === "true") return;
    section.dataset.cornholeReady = "true";

    const paletteSelect = section.querySelector("[data-cornhole-palette]");
    const paletteNote = section.querySelector("[data-cornhole-palette-note]");
    const colorSelects = Object.fromEntries(
      [...section.querySelectorAll("[data-cornhole-color]")].map((select) => [
        select.dataset.cornholeColor,
        select,
      ]),
    );
    const customColors = Object.fromEntries(
      [...section.querySelectorAll("[data-cornhole-custom-color]")].map((input) => [
        input.dataset.cornholeCustomColor,
        input,
      ]),
    );
    const colorOutputs = Object.fromEntries(
      [...section.querySelectorAll("[data-cornhole-color-output]")].map((output) => [
        output.dataset.cornholeColorOutput,
        output,
      ]),
    );
    const boardImages = Object.fromEntries(
      [...section.querySelectorAll("[data-cornhole-preview-image]")].map((image) => [
        image.dataset.cornholePreviewImage,
        image,
      ]),
    );
    const boardTints = Object.fromEntries(
      [...section.querySelectorAll("[data-cornhole-preview-tint]")].map((tint) => [
        tint.dataset.cornholePreviewTint,
        tint,
      ]),
    );
    const boardResponses = Object.fromEntries(
      [...section.querySelectorAll("[data-cornhole-preview-response]")].map((response) => [
        response.dataset.cornholePreviewResponse,
        response,
      ]),
    );
    const boardLabels = Object.fromEntries(
      [...section.querySelectorAll("[data-cornhole-board-label]")].map((label) => [
        label.dataset.cornholeBoardLabel,
        label,
      ]),
    );
    const bagLabels = Object.fromEntries(
      [...section.querySelectorAll("[data-cornhole-bag-label]")].map((label) => [
        label.dataset.cornholeBagLabel,
        label,
      ]),
    );
    const propertyInputs = Object.fromEntries(
      [...section.querySelectorAll("[data-cornhole-property]")].map((input) => [
        input.dataset.cornholeProperty,
        input,
      ]),
    );
    const previewLabel = section.querySelector("[data-cornhole-preview-label]");
    const previewReference = section.querySelector("[data-cornhole-preview-reference]");
    const finishButtons = [...section.querySelectorAll("[data-cornhole-finish]")];
    const bagButtons = [...section.querySelectorAll("[data-cornhole-bags]")];
    const bagColorControls = [
      ...section.querySelectorAll("[data-cornhole-bag-color-control]"),
    ];
    const bagPreviews = [...section.querySelectorAll("[data-cornhole-bag-preview]")];
    const viewButtons = [...section.querySelectorAll("[data-cornhole-view]")];
    const proof = section.querySelector("[data-cornhole-proof]");
    const customControls = section.querySelector("[data-cornhole-custom-controls]");
    const matchReference = section.querySelector("[data-cornhole-reference]");
    const swapButton = section.querySelector("[data-cornhole-swap]");
    const variantInput = section.querySelector("[data-cornhole-variant]");
    const priceOutput = section.querySelector("[data-cornhole-price]");
    const submit = section.querySelector("[data-cornhole-submit]");
    const submitLabel = section.querySelector("[data-cornhole-submit-label]");
    let variants = [];
    try {
      variants = JSON.parse(
        section.querySelector("[data-cornhole-variants]")?.textContent || "[]",
      );
    } catch {
      return;
    }
    const paletteRecords = [
      ...section.querySelectorAll("[data-cornhole-palette-record]"),
    ].map(
      (record) => ({
        id: record.dataset.id,
        name: record.dataset.name,
        status: record.dataset.status,
        colors: [...record.querySelectorAll("[data-cornhole-palette-color]")].map(
          (color) => ({
            name: color.dataset.name || "Color",
            hex: color.dataset.hex || "#383838",
            reference: color.dataset.reference || "",
          }),
        ),
      }),
    );
    const palettes = paletteRecords.length
      ? paletteRecords
      : CORNHOLE_DEFAULT_PALETTES.map((palette) => ({
          ...palette,
          colors: palette.colors.map((color) => ({ ...color })),
        }));
    let selection = {
      finish: "Super Durable Matte Black",
      kind: "stock",
      image: section.dataset.blackRender,
      reference: "Prismatic PSS-11181",
      palette: palettes[0]?.name || "Screen color reference",
      finishOption: "Black Powder",
      bags: "No bags",
    };

    const describeColor = (color) => {
      const reference = color.reference ? ` / ${color.reference}` : "";
      return `${color.name} / ${color.hex}${reference}`;
    };

    const setActiveFinish = (activeButton) => {
      finishButtons.forEach((button) => {
        const active = button === activeButton;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-pressed", String(active));
      });
    };

    const colorFromSelect = (role) => {
      const option = colorSelects[role]?.selectedOptions?.[0];
      return {
        name: option?.dataset.name || "Custom screen color",
        hex: (option?.dataset.hex || option?.value || "#383838").toUpperCase(),
        reference: option?.dataset.reference || "",
      };
    };

    const frameColor = (side) => {
      const paletteColor = colorFromSelect(`board-${side}`);
      const input = customColors[`board-${side}`];
      if (selection.kind !== "custom" || !input) return paletteColor;
      const hex = input.value.toUpperCase();
      const option = [...(colorSelects[`board-${side}`]?.options || [])].find(
        (candidate) => (candidate.dataset.hex || candidate.value).toUpperCase() === hex,
      );
      return {
        name: option?.dataset.name || "Custom screen color",
        hex,
        reference: option?.dataset.reference || "",
      };
    };

    const selectedPalette = () => {
      return palettes.find((palette) => palette.id === paletteSelect?.value) || palettes[0];
    };

    const setProperty = (key, value) => {
      if (propertyInputs[key]) propertyInputs[key].value = value;
    };

    const formatColor = (color) =>
      `${color.name} / ${color.hex}${color.reference ? ` / ${color.reference}` : ""}`;

    const syncVariant = () => {
      const variant = variants.find(
        (candidate) =>
          candidate.option1 === selection.finishOption &&
          (candidate.option2 || "No bags") === selection.bags,
      );
      if (!variant) {
        if (submit) submit.disabled = true;
        if (submitLabel) submitLabel.textContent = "SELECTED PAIR UNAVAILABLE";
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (priceOutput) {
        const currency = window.Shopify?.currency?.active || "USD";
        priceOutput.textContent = new Intl.NumberFormat(
          document.documentElement.lang || "en",
          {
            style: "currency",
            currency,
          },
        ).format(variant.price / 100);
      }
      if (submit) submit.disabled = !variant.available;
      if (submitLabel) {
        submitLabel.textContent = variant.available
          ? "ADD PAIR TO CART"
          : "SELECTED PAIR UNAVAILABLE";
      }
    };

    const render = () => {
      const palette = selectedPalette();
      const boardA = frameColor("a");
      const boardB = frameColor("b");
      const bagA = colorFromSelect("bag-a");
      const bagB = colorFromSelect("bag-b");
      const custom = selection.kind === "custom";
      const responseAsset = section.dataset.matteResponse;

      ["a", "b"].forEach((side) => {
        if (boardImages[side]) boardImages[side].src = selection.image;
        if (boardTints[side]) boardTints[side].hidden = !custom;
        if (boardResponses[side]) {
          boardResponses[side].src =
            responseAsset || section.dataset.powderResponse || "";
          boardResponses[side].hidden = !custom;
        }
      });
      section.style.setProperty("--board-a-color", boardA.hex);
      section.style.setProperty("--board-b-color", boardB.hex);
      section.style.setProperty("--bag-a-color", bagA.hex);
      section.style.setProperty("--bag-b-color", bagB.hex);
      const bagsIncluded = selection.bags !== "No bags";
      bagColorControls.forEach((control) => {
        control.hidden = !bagsIncluded;
        control.querySelectorAll("select").forEach((select) => {
          select.disabled = !bagsIncluded;
        });
      });
      bagPreviews.forEach((preview) => {
        preview.hidden = !bagsIncluded;
      });

      if (previewLabel) {
        previewLabel.textContent = selection.finish.toUpperCase();
      }
      if (previewReference) {
        const customReference =
          matchReference?.value.trim() ||
          [boardA.reference, boardB.reference].filter(Boolean).join(" / ") ||
          "SCREEN REFERENCE / PHYSICAL SAMPLE REQUIRED";
        previewReference.textContent = (
          custom ? customReference : selection.reference
        ).toUpperCase();
      }
      if (boardLabels.a) {
        boardLabels.a.textContent = (
          custom
            ? `${boardA.name} / ${section.dataset.finishScopeLabel || "board finish"}`
            : `${selection.finish} / ${section.dataset.finishScopeLabel || "board finish"}`
        ).toUpperCase();
      }
      if (boardLabels.b) {
        boardLabels.b.textContent = (
          custom
            ? `${boardB.name} / ${section.dataset.finishScopeLabel || "board finish"}`
            : `${selection.finish} / ${section.dataset.finishScopeLabel || "board finish"}`
        ).toUpperCase();
      }
      if (bagLabels.a) bagLabels.a.textContent = formatColor(bagA).toUpperCase();
      if (bagLabels.b) bagLabels.b.textContent = formatColor(bagB).toUpperCase();

      setProperty("finish", selection.finish);
      setProperty(
        "palette",
        palette ? `${palette.name} / ${palette.status}` : "Direct screen color",
      );
      setProperty("bags", selection.bags);
      setProperty("board-a", custom ? formatColor(boardA) : selection.finish);
      setProperty("board-b", custom ? formatColor(boardB) : selection.finish);
      setProperty("bag-a", bagsIncluded ? formatColor(bagA) : "Not included");
      setProperty("bag-b", bagsIncluded ? formatColor(bagB) : "Not included");
    };

    const loadPalette = (paletteId) => {
      const palette =
        palettes.find((candidate) => candidate.id === paletteId) || palettes[0];
      if (!palette) return;
      Object.values(colorSelects).forEach((select) => {
        select.replaceChildren();
        palette.colors.forEach((color) => {
          const option = document.createElement("option");
          option.value = color.hex;
          option.textContent = describeColor(color);
          option.dataset.name = color.name;
          option.dataset.hex = color.hex;
          option.dataset.reference = color.reference;
          select.append(option);
        });
      });
      const secondIndex = palette.colors.length > 1 ? 1 : 0;
      colorSelects["board-a"].selectedIndex = 0;
      colorSelects["bag-a"].selectedIndex = secondIndex;
      colorSelects["board-b"].selectedIndex = secondIndex;
      colorSelects["bag-b"].selectedIndex = 0;
      if (customColors["board-a"]) {
        customColors["board-a"].value = colorFromSelect("board-a").hex;
      }
      if (customColors["board-b"]) {
        customColors["board-b"].value = colorFromSelect("board-b").hex;
      }
      Object.entries(colorOutputs).forEach(([side, output]) => {
        output.textContent = customColors[side]?.value.toUpperCase() || "";
      });
      const statusCopy = {
        documented:
          "The connected record includes a production reference; a final coated sample may still be required.",
        "named-spot":
          "A named spot reference is recorded; powder-system mapping and production review are still required.",
        screen:
          "These are screen references. A physical swatch, powder code, or coated sample must control production.",
      };
      if (paletteNote) {
        paletteNote.textContent = statusCopy[palette.status] || statusCopy.screen;
      }
      selection.palette = palette.name;
      render();
    };

    palettes.forEach((palette) => {
      const option = document.createElement("option");
      option.value = palette.id;
      option.textContent =
        palette.id === "gameday" ? palette.name : `${palette.name} color reference`;
      paletteSelect?.append(option);
    });
    paletteSelect?.addEventListener("change", () => {
      const customButton = finishButtons.find((button) => button.dataset.kind === "custom");
      if (selection.kind !== "custom" && customButton) customButton.click();
      loadPalette(paletteSelect.value);
    });

    Object.entries(colorSelects).forEach(([role, select]) => {
      select.addEventListener("change", () => {
        if (role === "board-a" || role === "board-b") {
          const input = customColors[role];
          if (input) input.value = colorFromSelect(role).hex;
          if (colorOutputs[role]) colorOutputs[role].textContent = colorFromSelect(role).hex;
        }
        render();
      });
    });

    Object.entries(customColors).forEach(([side, input]) => {
      input.addEventListener("input", () => {
        if (colorOutputs[side]) colorOutputs[side].textContent = input.value.toUpperCase();
        render();
      });
    });

    finishButtons.forEach((button) => {
      button.addEventListener("click", () => {
        setActiveFinish(button);
        selection = {
          ...selection,
          finish: button.dataset.label || "Metal frame finish",
          kind: button.dataset.kind || "stock",
          image: button.dataset.image || section.dataset.blackRender,
          reference: button.dataset.reference || "Production review required",
          finishOption: button.dataset.optionValue || "Black Powder",
        };
        syncVariant();
        if (customControls) customControls.hidden = selection.kind !== "custom";
        ["board-a", "board-b"].forEach((role) => {
          if (colorSelects[role]) colorSelects[role].disabled = selection.kind !== "custom";
        });
        render();
      });
    });

    bagButtons.forEach((button) => {
      button.addEventListener("click", () => {
        bagButtons.forEach((candidate) => {
          const active = candidate === button;
          candidate.classList.toggle("is-active", active);
          candidate.setAttribute("aria-pressed", String(active));
        });
        selection.bags = button.dataset.cornholeBags || "No bags";
        syncVariant();
        render();
      });
    });

    swapButton?.addEventListener("click", () => {
      const bagA = colorSelects["bag-a"]?.value;
      const bagB = colorSelects["bag-b"]?.value;
      if (colorSelects["bag-a"]) colorSelects["bag-a"].value = bagB;
      if (colorSelects["bag-b"]) colorSelects["bag-b"].value = bagA;
      if (selection.kind === "custom") {
        const frameA = customColors["board-a"]?.value;
        const frameB = customColors["board-b"]?.value;
        if (customColors["board-a"]) customColors["board-a"].value = frameB;
        if (customColors["board-b"]) customColors["board-b"].value = frameA;
        if (colorOutputs["board-a"]) colorOutputs["board-a"].textContent = frameB.toUpperCase();
        if (colorOutputs["board-b"]) colorOutputs["board-b"].textContent = frameA.toUpperCase();
      }
      render();
    });

    viewButtons.forEach((button) => {
      button.addEventListener("click", () => {
        viewButtons.forEach((candidate) => {
          const active = candidate === button;
          candidate.classList.toggle("is-active", active);
          candidate.setAttribute("aria-pressed", String(active));
        });
        if (proof) proof.dataset.view = button.dataset.cornholeView || "pair";
      });
    });
    matchReference?.addEventListener("input", render);

    if (palettes[0]) loadPalette(palettes[0].id);
    const initial = finishButtons.find((button) => button.classList.contains("is-active"));
    if (initial) initial.click();
  }

  function initGamedayBagProduct(section) {
    if (!section || section.dataset.bagProductReady === "true") return;
    section.dataset.bagProductReady = "true";

    const motionImage = section.querySelector("[data-bag-motion-image]");
    const motionToggle = section.querySelector("[data-bag-motion-toggle]");
    const colorInputs = {
      a: section.querySelector('[data-bag-color-input="a"]'),
      b: section.querySelector('[data-bag-color-input="b"]'),
    };
    const colorOutputs = {
      a: section.querySelector('[data-bag-color-output="a"]'),
      b: section.querySelector('[data-bag-color-output="b"]'),
    };
    const previewLabels = {
      a: section.querySelector('[data-bag-preview-label="a"]'),
      b: section.querySelector('[data-bag-preview-label="b"]'),
    };
    const propertyInputs = {
      a: section.querySelector("[data-bag-property-a]"),
      b: section.querySelector("[data-bag-property-b]"),
    };
    const quoteLink = section.querySelector("[data-bag-quote-link]");

    const setMotionState = (playing) => {
      if (!motionImage || !motionToggle) return;
      motionImage.src = playing
        ? motionImage.dataset.motionSrc
        : motionImage.dataset.posterSrc;
      motionToggle.setAttribute("aria-pressed", String(playing));
      motionToggle.textContent = playing
        ? "PAUSE COLOR MOTION"
        : "PLAY COLOR MOTION";
    };

    const updateConfiguration = () => {
      const colors = {
        a: colorInputs.a?.value.toUpperCase() || "#174EA6",
        b: colorInputs.b?.value.toUpperCase() || "#C72032",
      };
      section.style.setProperty("--bag-color-a", colors.a);
      section.style.setProperty("--bag-color-b", colors.b);
      ["a", "b"].forEach((side) => {
        if (colorOutputs[side]) colorOutputs[side].textContent = colors[side];
        if (previewLabels[side]) previewLabels[side].textContent = colors[side];
        if (propertyInputs[side]) propertyInputs[side].value = colors[side];
      });

      if (quoteLink) {
        const url = new URL(quoteLink.href, window.location.origin);
        url.searchParams.set("color_a", colors.a);
        url.searchParams.set("color_b", colors.b);
        quoteLink.href = url.toString();
      }
    };

    const reducedMotion = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)",
    );
    if (reducedMotion?.matches) setMotionState(false);
    motionToggle?.addEventListener("click", () => {
      setMotionState(motionToggle.getAttribute("aria-pressed") !== "true");
    });

    Object.values(colorInputs).forEach((input) => {
      input?.addEventListener("input", updateConfiguration);
    });
    section.querySelectorAll("[data-bag-palette-a]").forEach((button) => {
      button.addEventListener("click", () => {
        if (colorInputs.a) colorInputs.a.value = button.dataset.bagPaletteA;
        if (colorInputs.b) colorInputs.b.value = button.dataset.bagPaletteB;
        updateConfiguration();
      });
    });
    updateConfiguration();
  }

  function repairInjectedUtilityLinks(root = document) {
    root.querySelectorAll("#hmak-float-buttons a[href]").forEach((link) => {
      const href = link.getAttribute("href")?.trim() || "";
      if (/^(?:www\.)?exolox\.com\/pages\/contact\/?$/i.test(href)) {
        link.setAttribute("href", "/pages/contact");
      }
      if (link.target === "_blank") {
        link.rel = "noopener noreferrer";
      }
      if (!link.getAttribute("aria-label")) {
        const label = link.parentElement
          ?.querySelector(".lb-float-button")
          ?.textContent?.trim();
        if (label) link.setAttribute("aria-label", label);
      }
    });
  }

  function watchInjectedUtilityLinks() {
    if (!document.documentElement || typeof MutationObserver === "undefined") {
      return;
    }
    const observer = new MutationObserver(() => {
      if (!document.querySelector("#hmak-float-buttons a[href]")) return;
      repairInjectedUtilityLinks();
      observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 10000);
  }

  function initCartLiveProof(root = document) {
    root.querySelectorAll("[data-cart-live-proof-print]").forEach((button) => {
      if (button.dataset.cartLiveProofReady === "true") return;
      button.dataset.cartLiveProofReady = "true";
      button.addEventListener("click", () => {
        const cartItem = button.closest(".cart-item--live-proof");
        const printTarget = cartItem?.querySelector(".cart-item__live-proof-sheet");
        if (!cartItem || !printTarget) return;
        const printAncestors = [];
        let printAncestor = printTarget.parentElement;
        while (printAncestor && printAncestor !== document.body) {
          printAncestor.classList.add("is-gameday-print-ancestor");
          printAncestors.push(printAncestor);
          printAncestor = printAncestor.parentElement;
        }
        document.documentElement.classList.add("is-printing-cart-live-proof");
        document.body.classList.add("is-printing-cart-live-proof");
        cartItem.classList.add("is-printing-live-proof");
        printTarget.classList.add("is-gameday-print-target");
        const clearPrintState = () => {
          document.documentElement.classList.remove("is-printing-cart-live-proof");
          document.body.classList.remove("is-printing-cart-live-proof");
          cartItem.classList.remove("is-printing-live-proof");
          printTarget.classList.remove("is-gameday-print-target");
          printAncestors.forEach((ancestor) => ancestor.classList.remove("is-gameday-print-ancestor"));
        };
        window.addEventListener("afterprint", clearPrintState, { once: true });
        window.print();
        window.setTimeout(clearPrintState, 1500);
      });
    });
  }

  const initialize = (root = document) => {
    initAdaptiveHeader(root);
    initCartLiveProof(root);
    repairInjectedUtilityLinks(root);
    root
      .querySelectorAll("[data-gameday-catalog]")
      .forEach((section) => initCatalog(section));
    root
      .querySelectorAll(".gameday-product-page")
      .forEach((section) => initProduct(section));
    root
      .querySelectorAll("[data-gameday-custom-designer]")
      .forEach((section) => initCustomDesigner(section));
    root
      .querySelectorAll("[data-gameday-kit]")
      .forEach((section) => initGamedayKit(section));
    root
      .querySelectorAll("[data-gameday-cornhole-customizer]")
      .forEach((section) => initCornholeCustomizer(section));
    root
      .querySelectorAll("[data-gameday-bag-product]")
      .forEach((section) => initGamedayBagProduct(section));
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initialize());
  } else {
    initialize();
  }
  watchInjectedUtilityLinks();
  window.setTimeout(() => repairInjectedUtilityLinks(), 1000);
  document.addEventListener("shopify:section:load", (event) => initialize(event.target));
})();
